import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { toast } from "react-toastify";
import { ApiUrl } from "./ApiUrl";
import { useLanguage } from "./languageContext";
import translations from "./translation.json";
import AddWeekModal from "./addWeekModal";
import Loader from "./loader";
import Select from "react-select";
import CreateFormModal from "./createFormModal";
import EditEventModal from "./ModalAddDealer_CreateEvent";
import { useNavigate } from "react-router-dom";
import FilterBar from "./components/filterBar";
import debounce from "lodash/debounce";
import { externalUsers, internalUsers } from "./constants/userTypes";
import numeral from "numeral";
import * as XLSX from "xlsx";
import DraggableHeaderCell from "./components/EventsPage/DraggableHeaderCell";
import { horizontalListSortingStrategy } from "@dnd-kit/sortable";
import {
  DndContext,
  closestCenter,
  useSensor,
  useSensors,
  PointerSensor,
  KeyboardSensor,
} from "@dnd-kit/core";
import { SortableContext, arrayMove } from "@dnd-kit/sortable";
import AddViewModal from "./components/EventsPage/AddViewModal";
import { format } from "date-fns";
import useGetViewsData from "./hooks/useGetViewsData";
import { AllEventColoumnData } from "./utils/data";
import { findPathsToValue } from "./GetPath";
import { Field } from "formik";

const EventsNew = ({
  setDisplayComponent,
  eventTrigger,
  setEditEventID,
  setIsDarkMode,
  isDarkMode,
  isLoading,
  setIsLoading,
  users,
  dealerships,
  groups,
  setPrevDisplay,
  events,
  setEvents,
  stats,
  setStats,
  key,
  setKey,
  total,
  setTotal,
  searchCache,
  setSearchCache,
  pageCache,
  setPageCache,
  deleteStates,
  setDeleteStates,
  pageNo,
  setPageNo,
  selectedDealershipOption,
  selectedProvince,
  setSelectedProvince,
  setSelectedDealership,
  totalEvents,
  setTotalEvents,
  setDealershipLabel,
  selectedOptionRef,
  checkedFields,
  setCheckedFields,
  dataEnd,
  setDataEnd,
  dataLoaded,
  setDataLoaded,
  filterOption,
  setFilterOption,
  setrepOptions2,
  setmanagers,
  setpackageOptions,
  packageOptions,
  managers,
  repOptions2,
  isFetchingRef
}) => {
  const { language } = useLanguage();
  var button = document.getElementById("openViewModal");
  const userData = JSON.parse(localStorage.getItem("userData"));
  const eventsFilterData = JSON.parse(localStorage.getItem("eventsFilterData"));
  const dealershipFilter = JSON.parse(localStorage.getItem("dealershipFilter"));
  const eventsFilterPostData = JSON.parse(
    localStorage.getItem("eventsFilterPostData")
  );
  const [openRow, setOpenRow] = useState(null);
  const userType = localStorage.getItem("userType");
  const pageTranslations = translations["EventsPortal"];
  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor)
  );
   const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
const monthTranslations = {
  en: [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ],
  fr: [
    "Janvier", "Février", "Mars", "Avril", "Mai", "Juin",
    "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"
  ]
};
const isAdminUser =
  userType &&
  internalUsers.includes(userType) &&
  ["Admin", "Super Admin"].includes(userData?.roles?.[0]?.name);

// Suppose you have a variable `language` which is either "en" or "fr"
const monthsList = monthTranslations[language].map((month, index) => ({
  label: month,   // translated month for UI
  value: index,   // numeric month (0 = Jan, 11 = Dec)
}));
  const commonDropdown = [
    { label: translations["dropdown"].yes[language], value: "Yes" },
    { label: translations["dropdown"].no[language], value: "No" },
  ];
  const fidgiContestOptions = [
    ...commonDropdown,
    {
      label: translations["dropdown"].toBeConfirmed[language],
      value: "To be confirmed",
    },
  ];
  const role = localStorage.getItem("userType");
  const isRepresentative = role === "Representative";
  const navigate = useNavigate();
  const [filtersData, setFiltersData] = useState(eventsFilterPostData || []);
  const statusOptions = [
    {
      label: translations.usersPage.createUser.statusOptions.active[language],
      value: "Active",
    },
    {
      label:
        translations.usersPage.createUser.statusOptions.cancelled[language],
      value: "Cancelled",
    },
    {
      label: translations.usersPage.createUser.statusOptions.waiting[language],
      value: "Waiting",
    },
    {
      label:
        translations.usersPage.createUser.statusOptions.completed[language],
      value: "Completed",
    },
     {
      label:
      translations.usersPage.createUser.statusOptions.pending[language],
      value: "Pending",
    },
  ];
  const filterOptions = [
    {
      label: translations.EventsPortal.filterOptions.currentYear[language],
      value: "currentYear",
    },
    {
      label: "Archive",
      value: "previousYear",
    },
    {
      label: translations.EventsPortal.filterOptions.futureYear[language],
      value: "future",
    },
    {
      label:
        translations.usersPage.createUser.statusOptions.cancelled[language],
      value: "cancel",
    },
     {
      label:
        translations.usersPage.createUser.statusOptions.pending[language],
      value: "pending",
    },
    
  ];
  const yearFilterTypes = ["cancel", "pending", "previousYear"];
  const getYearFilterKey = (type) => {
    if (type === "cancel") return "cancelYear";
    if (type === "pending") return "pendingYear";
    return "previousYear";
  };
  const getYearOptions = (type) => {
    const currentYear = new Date().getFullYear();
    const years =
      type === "previousYear"
        ? Array.from({ length: 5 }, (_, i) => currentYear - 1 - i)
        : Array.from({ length: 8 }, (_, i) => currentYear + 3 - i);

    return years.map((year) => ({ label: year, value: year }));
  };

  const token = localStorage.getItem("token");
  const [clickedRow, setClickedRow] = useState(null);
  const [eventsSearch, setEventsSearch] = useState();
  const [editID, seteditID] = useState();
  const [activeSearch, setActiveSearch] = useState(false);
  const [eventId, setEventId] = useState("");
  const [parentId, setParentId] = useState("");
  const [week, setWeek] = useState("");
  const [loading, setLoading] = useState("");
  // const [filterOption, setFilterOption] = useState(filterOptions[0].value);

  const [oldData, setOldData] = useState(null);
  const [brands, setBrands] = useState();
  const [parentForms, setParentForms] = useState([]);
  const [clientForms, setClientForms] = useState(false);
  const [childId, setChildId] = useState("");
  // const [checkedFields, setCheckedFields] = useState([]);
  // const [repOptions2, setrepOptions2] = useState([]);
  const [agents, setagents] = useState([]);
  // const [managers, setmanagers] = useState([]);
  // const [packageOptions, setpackageOptions] = useState([]);
  const containerRef = useRef(null);
  const topMarkerRef = useRef(null);
  const bottomMarkerRef = useRef(null);
  const [allowScrollFetch, setAllowScrollFetch] = useState(true);
  const [prevScrollPos, setPrevScrollPos] = useState(0);
  const [initialScrollDone, setInitialScrollDone] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  // const isFetchingRef = useRef(false);
  const lastScrollTopRef = useRef(0);
  // const [dataEnd, setDataEnd] = useState(false);
  // const [dataLoaded, setDataLoaded] = useState(false);
  const [selectedYear, setSelectedYear] = useState("");
  const columnWidthsRef = useRef({});
  const pendingStateUpdate = useRef(false);
  const [formDealerID, setformDealerID] = useState("");

  const [selectedWeeks, setSelectedWeeks] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
useEffect(() => {
  const meta = document.querySelector('meta[name="viewport"]');
  if (!meta) return;

  const originalContent = meta.getAttribute("content");
  let currentContent = originalContent;

  const updateViewport = () => {
    const screenWidth = window.screen.width;
    const isMobile = screenWidth < 768;

    const newContent = isMobile
      ? "width=device-width, initial-scale=1.0"
      : "width=1000";

    // Only update if it’s different from current
    if (currentContent !== newContent) {
      meta.setAttribute("content", newContent);
      currentContent = newContent;
    }
  };

  // Initial update
  updateViewport();

  // Update on window resize
  window.addEventListener("resize", updateViewport);

  // Cleanup on unmount
  return () => {
    if (originalContent) {
      meta.setAttribute("content", originalContent);
    }
    window.removeEventListener("resize", updateViewport);
  };
}, []);

  const getColumns = () => {
    return {
      name: "Default View",
      current: true,
      type: "default event",
      csv: true,
      xlsx: true,
      columns: [
        {
          id: "week",
          content: "week",
          style: {
            position: "-webkit-sticky",
            position: "sticky",
            left: "0px",
            // width: "57px",
          },
          width: 57,
          className: "text-center",
          renderInView: true,
        },
        {
          id: "nom_vp",
          content: translations.commonFields.name[language],
          style: {
            // position: "-webkit-sticky",
            // position: "sticky",
            // left: language === "fr" ? "80px" : "58px",
            // width: "83px",
          },
          width: 83,
          renderInView: true,
        },
        {
          id: "group",
          content: translations.commonFields.group[language],
          style: {
            // position: "-webkit-sticky",
            // position: "sticky",
            // left: language === "fr" ? "80px" : "58px",
            // width: "83px",
          },
          width: 83,
          renderInView: true,
        },
        {
          id: "dealership",
          content: translations.quickCreationModal.dealership[language],
          width: 120,
          renderInView: true,
        },
        {
          id: "package",
          content: translations.forms.privateEventformFields.package[language],
          showIf: userType && internalUsers.includes(userType),
          width: 100,
          renderInView: true,
        },
        {
          id: "start_date",
          content:
            translations.forms.privateEventformFields.startDate[language],
          style: { minWidth: "125px" },
          width: 125,
          renderInView: true,
        },
        {
          id: "end_date",
          content: translations.forms.privateEventformFields.endDate[language],
          width: 125,
          renderInView: true,
        },
        {
          id: "clients",
          content:
            translations.usersPage.createUser.statusOptions.active[language],
          showIf: userType && internalUsers.includes(userType),
          width: 80,
          renderInView: true,
        },
        {
          id: "inactive",
          content: translations.forms.formFields.inactive[language],
          showIf: userType && internalUsers.includes(userType),
          style: { minWidth: "55px" },
          width: 80,
          renderInView: true,
        },
        {
          id: "conquest",
          content:
            translations.forms.formFields.conquestSection.title[language],
          showIf:
            userType &&
            internalUsers.includes(userType) &&
            (userData.roles[0].name === "Project Manager" ||
              userData.roles[0].name === "Representative" ||
              userData.roles[0].name === "Admin" ||
              userData.roles[0].name === "Super Admin"),
          style: { minWidth: "55px" },
          width: 100,
          renderInView: true,
        },
        {
          id: "mailing_amount",
          content: translations.viewBillingPage.mailingAmount[language],
          width: 100,
          renderInView: true,
        },
        {
          id: "amount",
          content: translations.forms.formFields.amount[language],
          showIf: userType && internalUsers.includes(userType),
          width: 100,
          renderInView: true,
        },
        {
          id: "sales_rep",
          content: translations.forms.formFields.representative[language],
          width: 120,
          renderInView: true,
        },
        {
          id: "brand",
          content: translations.quickCreationModal.brand[language],
          width: 100,
          renderInView: true,
        },
        {
          id: "project_manager",
          content: translations.forms.formFields.projectManager[language],
          width: language === "en" ? 100 : 120,
          renderInView: true,
        },
        {
          id: "confirmation_agent",
          content: translations.forms.formFields.confirmationAgent[language],
          width: language === "en" ? 160 : 180,
          renderInView: true,
        },
        {
          id: "no_show_agent",
          content: translations.forms.formFields.noShowAgent[language],
          width: language === "en" ? 160 : 180,
          renderInView: true,
        },
        {
          id: "carton",
          content: translations.forms.formFields.carton[language],
          width: 100,
          renderInView: true,
        },
        {
          id: "mailing",
          content: translations.forms.formFields.mailing[language],
          width: 100,
          renderInView: true,
        },
        {
          id: "massif",
          content: translations.forms.formFields.massif[language],
          width: 100,
          renderInView: true,
        },
        {
          id: "web",
          content: translations.forms.formFields.web[language],
          width: 100,
          renderInView: true,
        },
        {
          id: "banner",
          content: translations.forms.formFields.banner[language],
          width: 100,
          renderInView: true,
        },
        {
          id: "news_letter",
          content: translations.forms.formFields.newsletter[language],
          width: 100,
          renderInView: true,
        },
        {
          id: "facebook",
          content: translations.forms.formFields.facebook[language],
          width: 100,
          renderInView: true,
        },
        {
          id: "ad_words",
          content: translations.forms.formFields.adwords[language],
          width: 100,
          renderInView: true,
        },
        {
          id: "sms",
          content: "SMS",
          width: 100,
          renderInView: true,
        },
        {
          id: "invoice",
          content: translations.forms.formFields.invoice[language],
          width: 100,
          renderInView: true,
        },
        {
          id: "amount_animator",
          content: translations.forms.formFields.amountAnimator[language],
          width: language === "en" ? 100 : 140,
          renderInView: true,
        },
        {
          id: "invoice_animator",
          content: translations.forms.formFields.invoiceAnimator[language],
          width: language === "en" ? 100 : 140,
          renderInView: true,
        },
        {
          id: "commission_paid",
          content: translations.forms.formFields.commissionPaid[language],
          width: language === "en" ? 100 : 140,
          renderInView: true,
        },
        {
          id: "call_centre",
          content: translations.forms.formFields.callCentre[language],
          width: 100,
          renderInView: true,
        },
        {
          id: "instructions",
          content: translations.forms.formFields.instructions[language],
          width: 100,
          renderInView: true,
        },
        {
          id: "animator",
          content: translations.forms.formFields.animator[language],
          width: language === "en" ? 150 : 180,
          renderInView: true,
        },
        {
          id: "fidgi_contest",
          content: translations.forms.formFields.fidgi_contest[language],
          width: language === "en" ? 150 : 180,
          renderInView: true,
        },
        // {
        //   id: "status",
        //   content: translations.usersPage.createUser.status[language],
        //   showIf: userType !== "Employee" && userType !== "Manager",
        //   style: {
        //     position: "-webkit-sticky",
        //     position: "sticky",
        //     right: calculateStatusRightPosition(
        //       language,
        //       userType,
        //       StatusCondition,
        //       StatusCondition2,
        //       StatusCondition3,
        //       StatusCondition4
        //     ),
        //   },
        //   width: 100,
        //   renderInView: true,
        // },
        {
          id: "actions",
          content: pageTranslations["eventsTableHeader"].actions[language],
          showIf:
            userData?.roles[0].permissions.some(
              (item) => item.name === "Create Parent Form"
            ) ||
            userData?.roles[0].permissions.some(
              (item) => item.name === "Private Event Index"
            ) ||
            userData?.roles[0].permissions.some(
              (item) => item.name === "Private Event Destroy"
            ),
          style: {
            position: "-webkit-sticky",
            position: "sticky",
            right: 0,
          },
          width: 100,
          className: "text-center",
          colSpan: 5,
          renderInView: true,
        },
      ],
    };
  };
  const FindPath = (content, language) => {
    // findPathsToValue function did not return the path that's why i add static path.

    const fullPath = "forms.formFields.week.en";
    // console.log("Full Path:", fullPath);

    if (!fullPath) {
      // console.error(`No path found for content: ${content}`);
      return content;
    }

    // Step 2: Remove the last segment of the path to get the base path
    const trimmedPathArray = fullPath.split('.').slice(0, -1);
    const basePath = trimmedPathArray.join('.'); // Base path without the last segment
    // console.log("Base Path:", basePath);  // Log the base path

    // Step 3: Access the translation dynamically using reduce
    const translation = basePath
      .split('.')   // Split basePath into an array of keys
      .reduce((obj, key) => (obj && obj[key] ? obj[key] : undefined), translations);

    // Check if the translation exists for the provided language
    const result = translation ? translation[language] : undefined;

    // console.log("Translation Found:", result);

    if (!result) {
      // console.error(`No translation found at path: ${basePath} for language: ${language}`);
      return content;
    }

    return result;
  };
  const data = useGetViewsData("event");
  const [tableViews, setTableViews] = useState([]);
  const [currentView, setCurrentView] = useState(getColumns());
  const [viewData, setViewData] = useState(null);

  const hasPrivateEventDestroy =
    userData &&
    userData.roles[0].permissions.some(
      (item) => item.name === "Private Event Destroy"
    );

  const hasCreateParentForm =
    userData &&
    userData.roles[0].permissions.some(
      (item) => item.name === "Create Parent Form"
    );

  const hasPrivateEventShow =
    userData &&
    userData.roles[0].permissions.some(
      (item) => item.name === "Private Event Index"
    );
  const hasProspectiveIndex =
    userData &&
    userData.roles[0].permissions.some(
      (item) => item.name === "Prospective Index"
    );
  const StatusCondition =
    (hasPrivateEventDestroy && !hasCreateParentForm && !hasPrivateEventShow) ||
    (!hasPrivateEventDestroy && hasCreateParentForm && !hasPrivateEventShow) ||
    (!hasPrivateEventDestroy && !hasCreateParentForm && hasPrivateEventShow);
  const StatusCondition2 =
    (hasPrivateEventDestroy && hasCreateParentForm && !hasPrivateEventShow) ||
    (!hasPrivateEventDestroy && hasCreateParentForm && hasPrivateEventShow) ||
    (!hasPrivateEventDestroy && hasCreateParentForm && hasPrivateEventShow);
  const StatusCondition3 =
    !hasPrivateEventDestroy && !hasCreateParentForm && !hasPrivateEventShow;
  const StatusCondition4 =
    !hasPrivateEventDestroy && !hasCreateParentForm && hasPrivateEventShow;

  const shouldRenderActionsColumn =
    currentView?.columns?.some(
      (column) => column.id === "actions" && column.renderInView !== false
    );


  const isNotRestrictedUser =
    userType &&
    (
      !["Employee", "Manager", "Animator", "Agent", "Accountant"].includes(userType) ||
      internalUsers.includes(userType) && !["Agent"].includes(userType) ||
      externalUsers.includes(userType)
    );

  const shouldShowActions =
    shouldRenderActionsColumn && isNotRestrictedUser;


  const repOptions =
    users &&
    users.representatives.length > 0 &&
    users.representatives.map((user) => ({
      value: user.id,
      label: user.name,
    }));
  const dealerOptions =
    dealerships &&
    dealerships.length > 0 &&
    dealerships.map((dealer) => ({
      value: dealer.id,
      label: dealer.name,
    }));
  const groupOptions =
    groups &&
    groups.length > 0 &&
    groups.map((dealer) => ({
      value: dealer.id,
      label: dealer.name,
    }));
  const agentOptions =
    users?.agents?.map((user) => ({
      value: user?.id,
      label: user?.name,
    })) || [];

  function formatDate(date) {
    const datesArray = date.split(" / ");
    const lastDate = datesArray[datesArray.length - 1];

    return lastDate;
  }

  const allfields = [
    {
      content: translations.forms.privateEventformFields.month[language],
      name: "month",
      type: "month_name",
      filterType: "",
      value: "",
    },
    {
      content: translations.forms.formFields.week[language],
      name: "week",
      type: "text",
      filterType: "",
      value: "",
    },
    
     {
      content: translations.commonFields.name[language],
      name: "nom_vp",
      type: "text",
      filterType: "",
      value: "",
    },
    {
      content: translations.commonFields.group[language],
      name: "group",
      type: "dropdown",
      filterType: "",
      value: "",
    },
    {
      content: translations.quickCreationModal.dealership[language],
      name: "dealership",
      type: "dropdown",
      filterType: "",
      value: "",
    },
    {
      content: translations.forms.formFields.projectManager[language],
      name: "project_manager",
      type: "dropdown",
      filterType: "",
      value: "",
    },
    {
      content: translations.forms.formFields.sales_representative[language],
      name: "sales_rep",
      type: "dropdown",
      filterType: "",
      value: "",
    },

    {
      content: translations.forms.privateEventformFields.package[language],
      name: "package",
      type: "dropdown",
      filterType: "",
      value: "",
    },
    

    {
      content: translations.forms.privateEventformFields.dateRange[language],
      name: "date_range",
      type: "date_range",
      filterType: "date_range",
      value: "",
      component: [
        {
          content:
            translations.forms.privateEventformFields.startDate[language],
          name: "start_date",
          type: "date",
          filterType: "",
          value: "",
        },
        {
          content: translations.forms.privateEventformFields.endDate[language],
          name: "end_date",
          type: "date",
          filterType: "",
          value: "",
        },
      ],
    },
    {
      content: translations.forms.formFields.animator[language],
      name: "animator",
      type: "dropdown",
      filterType: "",
      value: "",
    },
    {
      content: translations.forms.formFields.fidgi_contest[language],
      name: "fidgi_contest",
      type: "dropdown",
      filterType: "",
      value: "",
      // Fidgi Contest is a boolean event attribute, not a user assignment.
      options: fidgiContestOptions,
      filterKey: "fidgi_contest",
    },
    {
      content: translations.forms.formFields.mailing[language],
      name: "mailing",
      type: "text",
      filterType: "",
      value: "",
    },
    {
      content: translations.forms.formFields.web[language],
      name: "web",
      type: "text",
      filterType: "",
      value: "",
    },
    {
      content: translations.forms.formFields.banner[language],
      name: "banner",
      type: "text",
      filterType: "",
      value: "",
    },
    {
      content: translations.forms.formFields.newsletter[language],
      name: "news_letter",
      type: "text",
      filterType: "",
      value: "",
    },
    {
      content: translations.forms.formFields.facebook[language],
      name: "facebook",
      type: "text",
      filterType: "",
      value: "",
    },
    {
      content: translations.forms.formFields.adwords[language],
      name: "ad_words",
      type: "text",
      filterType: "",
      value: "",
    },
    {
      content: translations.forms.formFields.clients[language],
      name: "clients",
      type: "text",
      filterType: "",
      value: "",
    },
    {
      content: translations.forms.formFields.inactive[language],
      name: "inactive",
      type: "text",
      filterType: "",
      value: "",
    },
    {
      content: translations.forms.formFields.conquestSection.title[language],
      name: "conquest",
      type: "text",
      filterType: "",
      value: "",
    },
    {
      content: translations.forms.formFields.massif[language],
      name: "massif",
      type: "text",
      filterType: "",
      value: "",
    },
    {
      content: translations.forms.formFields.amount[language],
      name: "amount",
      type: "text",
      filterType: "",
      value: "",
    },
    {
      content: translations.forms.formFields.confirmationAgent[language],
      name: "confirmation_agent",
      type: "dropdown",
      filterType: "",
      value: "",
    },
    {
      content: translations.forms.formFields.noShowAgent[language],
      name: "no_show_agent",
      type: "dropdown",
      filterType: "",
      value: "",
    },
    {
      content: translations.forms.formFields.carton[language],
      name: "carton",
      type: "text",
      filterType: "",
      value: "",
    },
    {
      content: "SMS",
      name: "sms",
      type: "text",
      filterType: "",
      value: "",
    },
    {
      content: translations.quickCreationModal.brand[language],
      name: "brand",
      type: "dropdown",
      filterType: "",
      value: "",
    },
    {
      content: translations.forms.formFields.amountAnimator[language],
      name: "amount_animator",
      type: "text",
      filterType: "",
      value: "",
    },
    {
      content: translations.forms.formFields.invoiceAnimator[language],
      name: "invoice_animator",
      type: "text",
      filterType: "",
      value: "",
    },
    {
      content: translations.forms.formFields.commissionPaid[language],
      name: "commission_paid",
      type: "text",
      filterType: "",
      value: "",
    },
    {
      content: translations.forms.formFields.instructions[language],
      name: "instructions",
      type: "text",
      filterType: "",
      value: "",
    },
     {
      content: translations.forms.formFields.callCentre[language],
      name: "call_centre",
      type: "text",
      filterType: "",
      value: "",
    },

    {
      content:
        translations.forms.privateEventformFields.promoAndRequestSection
          .comments[language],
      name: "comments",
      type: "text",
      filterType: "",
      value: "",
    },
  ];

  const textOptions = [
    {
      label: translations.commonFields.queryFilters.contain[language],
      value: "like",
    },
    {
      label: translations.commonFields.queryFilters.notContain[language],
      value: "not like",
    },
    {
      label: translations.commonFields.queryFilters.equal[language],
      value: "=",
    },
    {
      label: translations.commonFields.queryFilters.notEqual[language],
      value: "!=",
    },
  ];
  const weekOptions = [
    {
      label: translations.commonFields.queryFilters.contain[language],
      value: "like",
    },
    {
      label: translations.commonFields.queryFilters.notContain[language],
      value: "not like",
    },
    {
      label: translations.commonFields.queryFilters.equal[language],
      value: "=",
    },
    {
      label: translations.commonFields.queryFilters.notEqual[language],
      value: "!=",
    },
    {
      label: translations.commonFields.queryFilters.between[language],
      value: "between",
    },
  ];

  const textOptions2 = [
    {
      label: translations.commonFields.queryFilters.equal[language],
      value: "=",
    },
    {
      label: translations.commonFields.queryFilters.notEqual[language],
      value: "!=",
    },
  ];
  const animatorOptions =
    users?.animaters?.length > 0
      ? [
        {
          label: translations.dropdown.animatorOptions.op1[language],
          value: "1.1",
        },
        {
          label: translations.dropdown.animatorOptions.op2[language],
          value: "1.2",
        },
        ...users.animaters.map((user) => ({
          value: user.id,
          label: user.name,
        })),
      ]
      : [];

  const fetchData2 = async (scrollType, week) => {
    const tbody = document.getElementById("tbody");
    try {
      const res = await fetch(ApiUrl + "/api/user/private-events-index", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          setweek: week,
          scrollType: scrollType,
          [getYearFilterKey(filterOption)]:
            selectedYear ? selectedYear : "",
          dealership_id:
            JSON.parse(localStorage.getItem("dealershipFilter")) &&
              JSON.parse(localStorage.getItem("dealershipFilter")).length > 0
              ? JSON.parse(localStorage.getItem("dealershipFilter"))?.map(
                (option) => option?.value
              )
              : selectedDealershipOption?.map((option) => option.value) || [],
              headerstate:
  JSON.parse(localStorage.getItem("provinceFilter")) &&
  JSON.parse(localStorage.getItem("provinceFilter")).length > 0
    ? JSON.parse(localStorage.getItem("provinceFilter"))?.map(
        (option) => option?.value
      )
    : selectedProvince?.map((option) => option.value) || [],
          // ...filtersData,
          ...(JSON.parse(localStorage.getItem("eventsFilterPostData")) || {}),
          type: filterOption ? filterOption : "",
        }),
      });

      const data = await res.json();

      if (data.status === "success") {
        // const newData = data.private_events;
        // const updatedEvents = { ...events };
        // if (Object.keys(newData) && Object.keys(newData).length > 0) {
        //   Object.keys(newData).length > 0 &&
        //     Object.keys(newData).forEach((week) => {
        //       if (updatedEvents[week]) {
        //         const uniqueNewEntries = newData[week].filter(
        //           (newEntry) =>
        //             !updatedEvents[week].some(
        //               (existingEntry) => existingEntry.id === newEntry.id
        //             )
        //         );
        //         updatedEvents[week] = [
        //           ...updatedEvents[week],
        //           ...uniqueNewEntries,
        //         ];
        //       } else {
        //         updatedEvents[week] = newData[week];
        //       }
        //     });
        // }

        // if (Object.keys(newData).length === 0) {
        //   setDataEnd(true);
        // }
        // const sortedUpdatedEvents =
        //   Object.keys(updatedEvents) &&
        //   Object.keys(updatedEvents).length > 0 &&
        //   Object.keys(updatedEvents)
        //     .sort(
        //       (a, b) => parseInt(a.split(" ")[1]) - parseInt(b.split(" ")[1])
        //     )
        //     .reduce((sortedObj, week) => {
        //       sortedObj[week] = updatedEvents[week];
        //       return sortedObj;
        //     }, {});

        // setEvents(sortedUpdatedEvents);
        // let totalEventss = 0;

        // for (const week in sortedUpdatedEvents) {
        //   if (sortedUpdatedEvents.hasOwnProperty(week)) {
        //     totalEventss += sortedUpdatedEvents[week].length;
        //   }
        // }

        // if (totalEventss !== totalEvents) {
        //   setStats(data);
        //   setTotalEvents(totalEventss);
        // }
        // setDeleteStates(
        //   sortedUpdatedEvents &&
        //   Object.keys(sortedUpdatedEvents).map((key) =>
        //     sortedUpdatedEvents[key].map((item) => ({ [item.id]: false }))
        //   )
        // );
         setEvents((prevEvents) => {
    const newData = data.private_events;
    const updatedEvents = { ...prevEvents };

    if (newData && Object.keys(newData).length > 0) {
      Object.keys(newData).forEach((week) => {
        if (updatedEvents[week]) {
          const uniqueNewEntries = newData[week].filter(
            (newEntry) =>
              !updatedEvents[week].some(
                (existingEntry) => existingEntry.id === newEntry.id
              )
          );
          updatedEvents[week] = [
            ...updatedEvents[week],
            ...uniqueNewEntries,
          ];
        } else {
          updatedEvents[week] = newData[week];
        }
      });
    }

    if (Object.keys(newData).length === 0) {
      setDataEnd(true);
    }

    const sortedUpdatedEvents = Object.keys(updatedEvents)
      .sort(
        (a, b) => parseInt(a.split(" ")[1]) - parseInt(b.split(" ")[1])
      )
      .reduce((sortedObj, week) => {
        sortedObj[week] = updatedEvents[week];
        return sortedObj;
      }, {});

    // ✅ Update dependent states here after merge is correct
    let totalEventss = 0;
    for (const week in sortedUpdatedEvents) {
      totalEventss += sortedUpdatedEvents[week].length;
    }

    if (totalEventss !== totalEvents) {
      setStats(data);
      setTotalEvents(totalEventss);
    }

    setDeleteStates(
      Object.keys(sortedUpdatedEvents).map((key) =>
        sortedUpdatedEvents[key].map((item) => ({ [item.id]: false }))
      )
    );

    return sortedUpdatedEvents;
  });
      } else {
        toast.error(data.message);
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
      toast.error(translations.alertMessages.wentWrong[language]);
    } finally {
    }
  };
  useEffect(() => {
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const hasAdvancedFilters = eventsFilterData && eventsFilterData.length > 0;
        const hasNonDefaultListFilter = filterOption && filterOption !== "currentYear";
        const shouldPostFilters = hasAdvancedFilters || hasNonDefaultListFilter;
        const url = shouldPostFilters
          ? `${ApiUrl}/api/user/private-events-index`
          : `${ApiUrl}/api/user/private-events-index?page=${pageNo}`;

        const options = {
          method: shouldPostFilters ? "POST" : "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: shouldPostFilters
            ? JSON.stringify({
                ...(eventsFilterPostData || {}),
                type: filterOption,
                dealership_ids: selectedDealershipOption?.map((option) => option.value) || [],
                headerstate: selectedProvince?.map((option) => option.value) || [],
              })
            : null,
        };

        const res = await fetch(url, options);
        const data = await res.json();
        if (data.status === "success") {
          const newData = data.private_events;
          const newTotal = data.private_events?.total;

          let totalEventss = 0;

          for (const week in newData) {
            if (newData.hasOwnProperty(week)) {
              totalEventss += newData[week].length;
            }
          }

          Promise.all([
            setEvents(newData),

            setStats(data),

            setTotalEvents(totalEventss),

            setEventsSearch(newData),
            setTotal(newTotal),
            setrepOptions2(
              data?.data.representative.length > 0 &&
              data.data.representative.map((user) => ({
                value: user.id,
                label: user.name,
              }))
            ),
            setagents(
              data?.data.agents.length > 0 &&
              data.data.agents.map((user) => ({
                value: user.id,
                label: user.name,
              }))
            ),
            setmanagers(
              data?.data.projectManagers.length > 0 &&
              data.data.projectManagers.map((user) => ({
                value: user.id,
                label: user.name,
              }))
            ),
            setpackageOptions(
              data?.data.packages.length > 0 &&
              data.data.packages.map((user) => ({
                value: user.id,
                label: user.name,
              }))
            ),
            setPageCache((prevCache) => ({
              ...prevCache,
              [pageNo]: { cachedResponse: newData, cachedTotal: newTotal },
            })),
            setDeleteStates(
              newData &&
              Object.keys(newData).map((key) =>
                newData[key].map((item) => ({ [item.id]: false }))
              )
            ),
          ]).then(() => {
            setDataLoaded(true);
          });
        } else {
          toast.error(data.message);
        }
        setLoading(false);
      } catch (err) {
        setLoading(false);
        toast.error(translations.alertMessages.wentWrong[language]);
      } finally {
      }
    };

    if (!activeSearch && token && selectedDealershipOption?.length === 0 && selectedProvince?.length === 0) {
      fetchData();
    }

    const userData = JSON.parse(localStorage.getItem("userData"));
    setIsDarkMode(userData.theme_mode !== "light" ? true : false);
  }, []);

  useEffect(() => {
    if (eventTrigger) {
      const newData = eventTrigger.data;
      const newTotal = eventTrigger.total;

      setPageCache((prevCache) => ({
        ...prevCache,
        [pageNo]: { cachedResponse: newData, cachedTotal: newTotal },
      }));

      setEvents(newData);
      setEventsSearch(newData);
      setTotal(newTotal);
    }
  }, [eventTrigger]);

  const SCROLL_TRIGGER_OFFSET = 1000;

  const fetchDataOnScroll = async (direction) => {
    if (isFetchingRef.current || !allowScrollFetch || dataEnd) {
      return;
    }

    isFetchingRef.current = true;
    setIsFetching(true);
    try {
      const lastWeekNum =
        Object.keys(events)[Object.keys(events).length - 1].split(" ")[1];

      await fetchData2("down", lastWeekNum);
    } catch (error) {
      console.error("Fetch error:", error);
    } finally {
      isFetchingRef.current = false;
      setIsFetching(false);

      setAllowScrollFetch(false);
      setTimeout(() => {
        setAllowScrollFetch(true);
      }, 1000);
    }
  };
  const debouncedHandleScroll = useMemo(
    () =>
      debounce(() => {
        if (!initialScrollDone || !allowScrollFetch) return;

        const container = containerRef.current;

        const bottomMarker = bottomMarkerRef.current;

        if (!container || !bottomMarker) return;

        const currentScrollTop = container.scrollTop;
        const currentScrollLeft = container.scrollLeft;

        const isVerticalScroll = currentScrollTop !== lastScrollTopRef.current;
        const shouldCheckBottom = isNearBottom(container, bottomMarker);

        lastScrollTopRef.current = currentScrollTop;
        // console.log(
        //   isVerticalScroll,
        //   currentScrollTop,
        //   lastScrollTopRef,
        //   "Vertical"
        // );

        if (isVerticalScroll) {
          const containerRect = container.getBoundingClientRect();
          const bottomMarkerRect = bottomMarker.getBoundingClientRect();
          const distanceToBottomMarker =
            bottomMarkerRect.bottom - containerRect.bottom;
          if (isVerticalScroll || shouldCheckBottom) {
            // console.log(selectedDealershipOption?.length , selectedOptionRef.current, "selectedDealershipOption");
            // console.log(selectedDealershipOption?.length === 0 , selectedDealershipOption.length ,initialScrollDone, "selectedDealershipOption");
            // if (shouldCheckBottom && !isFetchingRef.current && selectedDealershipOption?.length === 0 && !selectedOptionRef.current) {
            if (shouldCheckBottom && !isFetchingRef.current) {
              fetchDataOnScroll("down");
            }
          }
        }
      }, 300),
    [initialScrollDone, allowScrollFetch, dataEnd, events]
  );

  const isNearBottom = (container, bottomMarker) => {
    const containerRect = container.getBoundingClientRect();
    const bottomMarkerRect = bottomMarker.getBoundingClientRect();
    const distanceToBottomMarker =
      bottomMarkerRect.bottom - containerRect.bottom;

    const hasVerticalScrollbar =
      container.scrollHeight > container.clientHeight;
    const isAtBottom =
      hasVerticalScrollbar &&
      Math.abs(
        container.scrollHeight - container.scrollTop - container.clientHeight
      ) < 2;

    return (
      hasVerticalScrollbar &&
      (distanceToBottomMarker < SCROLL_TRIGGER_OFFSET || isAtBottom)
    );
  };

  const handleScroll = useCallback(debouncedHandleScroll, [
    debouncedHandleScroll,
  ]);

  useEffect(() => {
    const container = containerRef.current;

    if (container) {
      container.addEventListener("scroll", handleScroll);

      return () => {
        container.removeEventListener("scroll", handleScroll);
      };
    }
  }, [handleScroll]);

  useEffect(() => {
    if (dataLoaded) {
      const scrollTimer = setTimeout(() => {
        // if (selectedDealershipOption?.length === 0 && !selectedOptionRef.current && eventsFilterData?.length === 0)
        // if (eventsFilterData === null || eventsFilterData?.length === 0) {
        autoScrollMid();
        // }
        setDataLoaded(false);
      }, 100);

      return () => clearTimeout(scrollTimer);
    }
  }, [dataLoaded]);

  const autoScrollMid = () => {
    if (typeof window === "undefined") return;

    const container = containerRef.current;
    if (!container) return;
    requestAnimationFrame(() => {
      try {
        const bottomScrollPos = container.scrollHeight - container.clientHeight;

        container.scrollTo({
          top: Math.max(0, bottomScrollPos - 300),
          behavior: "smooth",
        });
        setPrevScrollPos(bottomScrollPos);
        setInitialScrollDone(true);
      } catch (error) {
        console.error("Scroll error:", error);
      }
    });
  };

  const handleDelete = async (id, index, accordionIndex) => {
    const page =
      events.length > 1 ? pageNo : pageNo - 1 > 0 ? pageNo - 1 : pageNo;
    const searchParam = key ? "&search_parameter=" + key : "";
    try {
      setLoading(true);
      const res = await fetch(
        ApiUrl +
        "/api/user/private-event-destroy/" +
        id +
        "/" +
        filterOption +
        "?page=" +
        page,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = await res.json();
      if (data.status === "success") {
        toast.success(translations.alertMessages.eventDeletion[language]);
        const updatedEvents = { ...events };
        for (let week in updatedEvents) {
          updatedEvents[week] = updatedEvents[week]
            .filter((event) => event.id !== id)
            .map((event) => event);
        }
        const sortedUpdatedEvents =
          Object.keys(updatedEvents) &&
          Object.keys(updatedEvents).length > 0 &&
          Object.keys(updatedEvents)
            .sort(
              (a, b) => parseInt(a.split(" ")[1]) - parseInt(b.split(" ")[1])
            )
            .reduce((sortedObj, week) => {
              sortedObj[week] = updatedEvents[week];
              return sortedObj;
            }, {});

        setEvents(sortedUpdatedEvents);
        const newDeleteStates = [...deleteStates];
        newDeleteStates[accordionIndex][index][id] = false;
        setDeleteStates(newDeleteStates);
      } else {
        toast.error(data.message);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toast.error(translations.alertMessages.wentWrong[language]);
    }
  };

  const handleCopy = async (isParentForm) => {
    // console.log("handle copy value",isParentForm)
    const page =
      events.length > 1 ? pageNo : pageNo - 1 > 0 ? pageNo - 1 : pageNo;
    const searchParam = key ? "&search_parameter=" + key : "";
    try {
      setLoading(true);
      const res = await fetch(
        ApiUrl + "/api/user/copy-parentform?page=" + page + "" + searchParam,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            [!isParentForm ? "child_id" : "parent_id"]: parentId,

            event_id: eventId,
            drive_dealership_id: formDealerID || ""
          }),
        }
      );
      const data = await res.json();
      if (data.status === "success") {
        setDisplayComponent("edit-form");
        window.history.pushState(
          {
            id: "gallery",
            randomData: window.Math.random(),
          },
          "title",
          `/event-portal?page=edit-form&event_id=${eventId}&form_id=${data.event_url}`
        );
      } else {
        toast.error(data.message);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toast.error(translations.alertMessages.wentWrong[language]);
    }
  };

  const handleSearch = async (pageNo, initial) => {
    if (!initial && searchCache[pageNo]) {
      const { cachedResponse, cachedTotal } = searchCache[pageNo];
      // console.log("here0");

      setEvents(cachedResponse);
      setDeleteStates(
        cachedResponse &&
        Object.keys(cachedResponse).map((key) =>
          cachedResponse[key].map((item) => ({ [item.id]: false }))
        )
      );
      setTotal(cachedTotal);
    } else {
      try {
        const res = await fetch(
          ApiUrl + "/api/user/private-events-index/" + key + "?page=" + pageNo,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const data = await res.json();
        if (data.status === "success") {
          setActiveSearch(true);

          const newData = data.private_events;
          const newTotal = data.private_events.total;

          setSearchCache((prevCache) => ({
            ...prevCache,
            [pageNo]: { cachedResponse: newData, cachedTotal: newTotal },
          }));

          setEvents(newData);
          let totalEventss = 0;

          for (const week in newData) {
            if (newData.hasOwnProperty(week)) {
              totalEventss += newData[week].length;
            }
          }
          if (totalEventss !== totalEvents) {
            setStats(data);
            setTotalEvents(totalEventss);
          }
          setEventsSearch(newData);
          setTotal(newTotal);
          setDeleteStates(
            newData &&
            Object.keys(newData).map((key) =>
              newData[key].map((item) => ({ [item.id]: false }))
            )
          );
        } else {
          toast.error(data.message);
        }
      } catch (error) {
        toast.error(translations.alertMessages.wentWrong[language]);
      }
    }
  };

  const filterEvents = async (filterData) => {
    setIsLoading(true);
    setAllowScrollFetch(false);
    try {
      const res = await fetch(ApiUrl + "/api/user/private-events-index/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({...filterData,dealership_ids: selectedDealershipOption ? selectedDealershipOption?.map((option) => option.value) : [],
          headerstate: selectedProvince ? selectedProvince?.map((option) => option.value) : []
        }),
      });
      const data = await res.json();
      if (data.status === "success") {
        toast.success(data.message);

        const newData = data.private_events;
        const newTotal = data.private_events.total;
        containerRef.current.scrollTo({
          top: 0,
          behavior: "smooth",
        });

        const sortedUpdatedEvents =
          Object.keys(newData) &&
          Object.keys(newData).length > 0 &&
          Object.keys(newData)
            .sort(
              (a, b) => parseInt(a.split(" ")[1]) - parseInt(b.split(" ")[1])
            )
            .reduce((sortedObj, week) => {
              sortedObj[week] = newData[week];
              return sortedObj;
            }, {});

        setEvents(sortedUpdatedEvents);
        let totalEventss = 0;

        for (const week in sortedUpdatedEvents) {
          if (sortedUpdatedEvents.hasOwnProperty(week)) {
            totalEventss += sortedUpdatedEvents[week].length;
          }
        }
        if (totalEventss !== totalEvents) {
          setStats(data);
          setTotalEvents(totalEventss);
        }
        setTotal(newTotal);

        if (key) {
          setSearchCache({
            [pageNo]: {
              cachedResponse: newData,
              cachedTotal: newTotal,
            },
          });
        } else {
          setPageCache({
            [pageNo]: {
              cachedResponse: newData,
              cachedTotal: newTotal,
            },
          });
          setDeleteStates(
            sortedUpdatedEvents &&
            Object.keys(sortedUpdatedEvents).map((key) =>
              sortedUpdatedEvents[key].map((item) => ({ [item.id]: false }))
            )
          );
        }
      } else {
        toast.error(data.message);
      }
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      toast.error(translations.alertMessages.wentWrong[language]);
    } finally {
      setAllowScrollFetch(true);
    }
  };
const getCorrectYear = (filterPost) => {
  const currentYear = new Date().getFullYear();
  const { type, previousYear, cancelYear, pendingYear } = filterPost;

  if (type === "pending" && pendingYear && !isNaN(Number(pendingYear))) {
    return Number(pendingYear);
  }

  if (type === "cancel" && cancelYear && !isNaN(Number(cancelYear))) {
    return Number(cancelYear);
  }

  if (type === "previousYear" && previousYear && !isNaN(Number(previousYear))) {
    return Number(previousYear);
  }

  // Case 2: If type is a number-like string (e.g. "2023")
  if (type && !isNaN(Number(type))) {
    return Number(type);
  }

  // Case 3: type logic
  if (type === "currentYear") return currentYear;
  if (type === "future") return currentYear + 1;
  if (type === "previousYear") return currentYear - 1;

  if (cancelYear && !isNaN(Number(cancelYear))) {
    return Number(cancelYear);
  }

  if (pendingYear && !isNaN(Number(pendingYear))) {
    return Number(pendingYear);
  }

  if (previousYear && !isNaN(Number(previousYear))) {
    return Number(previousYear);
  }

  return currentYear; // fallback
};
  const getFilteredEvents = async (filterPost, checkedFieldsData) => {
    setAllowScrollFetch(false);
    const savedFilter = JSON.parse(localStorage.getItem("eventsFilterPostData")) || {};
const hasMonthName = checkedFieldsData?.some(
    (field) => field.type === "month_name"  
  );
  // Append to filterPost (without mutating original object)
  const finalFilter = {
    ...filterPost, 
    type: filterPost.type ? filterPost.type : (savedFilter.type || "")
  }
// console.log("dsajkkalsdf",hasMonthName,savedFilter, finalFilter,filterPost)
     const year = getCorrectYear(finalFilter);

  // If month start/end exists → rebuild with correct year
  if (hasMonthName && finalFilter.start_date && finalFilter.end_date) {
    const start = new Date(finalFilter.start_date);
    const end = new Date(finalFilter.end_date);

    start.setFullYear(year);
    end.setFullYear(year);

    finalFilter.start_date = start.toISOString().split("T")[0];
    finalFilter.end_date = end.toISOString().split("T")[0];
  }
    try {
      const res = await fetch(ApiUrl + "/api/user/private-events-index", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(finalFilter),
      });
      const data = await res.json();
      if (data.status === "success") {
        toast.success(data.message);
        setSelectedDealership([]);
        localStorage.removeItem("dealershipFilter");
        setSelectedProvince([]);
        localStorage.removeItem("provinceFilter");
        localStorage.setItem(
          "eventsFilterPostData",
          JSON.stringify(finalFilter)
        );
        localStorage.setItem(
          "eventsFilterData",
          JSON.stringify(checkedFieldsData)
        );
        setFiltersData(finalFilter);
        const newData = data.private_events;
        const newTotal = data.private_events.total;
        const sortedUpdatedEvents =
          Object.keys(newData) &&
          Object.keys(newData).length > 0 &&
          Object.keys(newData)
            .sort(
              (a, b) => parseInt(a.split(" ")[1]) - parseInt(b.split(" ")[1])
            )
            .reduce((sortedObj, week) => {
              sortedObj[week] = newData[week];
              return sortedObj;
            }, {});
        let totalEventss = 0;

        for (const week in sortedUpdatedEvents) {
          if (sortedUpdatedEvents.hasOwnProperty(week)) {
            totalEventss += sortedUpdatedEvents[week].length;
          }
        }
        if (totalEventss !== totalEvents) {
          setStats(data);
          setTotalEvents(totalEventss);
        }
        setEvents(sortedUpdatedEvents);
        setTotal(newTotal);

        if (key) {
          setSearchCache({
            [pageNo]: {
              cachedResponse: newData,
              cachedTotal: newTotal,
            },
          });
        } else {
          setPageCache({
            [pageNo]: {
              cachedResponse: newData,
              cachedTotal: newTotal,
            },
          });
          setDeleteStates(
            sortedUpdatedEvents &&
            Object.keys(sortedUpdatedEvents).map((key) =>
              sortedUpdatedEvents[key].map((item) => ({ [item.id]: false }))
            )
          );
        }
      } else {
        toast.error(data.message);
      }
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      toast.error(translations.alertMessages.wentWrong[language]);
    } finally {
      setAllowScrollFetch(true);
    }
  };

  const handlePageChange = (page) => {
    if (activeSearch) handleSearch(page);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setPageCache((prevCache) => ({
        ...prevCache,
        pageNo: pageNo,
      }));
      setPageNo(1);
      setSearchCache({});
    }, 500);

    return () => clearTimeout(timer);
  }, [key]);

  useEffect(() => {
    const getBrands = async () => {
      try {
        const res = await fetch(ApiUrl + "/api/user/get-brands", {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        const data = await res.json();

        if (data.status === "success") {
          //transform brand data to have value
          const updatedDataList = data.list_of_brands.map((obj)=>{
            return {
              ...obj, 
              value: obj.name,
              label: obj.name
            }
          })
          setBrands(updatedDataList);
        } else {
          toast.error(data.message);
        }
      } catch (error) {
        console.error("Error fetching brands", error);
      }
    };
    const getFiltersData = async () => {
      try {
        const res = await fetch(ApiUrl + "/api/user/get-fillter", {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        const data = await res.json();

        if (data.status === "success") {
          const filteredFields = allfields.filter(
            (field) => data.fillter[field.name] === 1
          );

          // setCheckedFields(filteredFields);
        } else {
          toast.error(data.message);
        }
      } catch (error) {
        console.error("Error fetching brands", error);
      }
    };
    getBrands();
    // getFiltersData();
    if (data?.user_views) {
      setTableViews([...data?.user_views]);
      const currentViewObj = data?.user_views.find(
        (item) => item.current === "1"
      );
      setCurrentView({
        ...currentViewObj,
        columns: currentViewObj?.columns || [],
      });
    }
  }, [token, data]);

  const changeDropdowns = async (bodyData,columnKey = "") => {
    // console.log("lkasjdfklas",bodyData,columnKey)
    setIsLoading(true);
    try {
      const res = await fetch(ApiUrl + "/api/user/change-status", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(bodyData),
      });
      const data = await res.json();
      if (data.status === "success") {
        toast.success(data.message);
        const updatedEvents = { ...events };
        // for (let week in updatedEvents) {
        //   // updatedEvents[week] = updatedEvents[week].map((event) =>
        //   //   event.id === bodyData.id
        //   //     ? {
        //   //       ...event,
        //   //       [Object.keys(bodyData)[1]]:
        //   //         bodyData[Object.keys(bodyData)[1]],
        //   //     }
        //   //     : event
        //   // );
        //   updatedEvents[week] = updatedEvents[week].filter(
        //     (event) =>
        //       !(
        //         event.id === bodyData.id &&
        //         (event.status?.toLowerCase() === "pending" || bodyData.status?.toLowerCase() === "pending") &&
        //         !(event.status?.toLowerCase() === "pending" && bodyData.status?.toLowerCase() === "pending")
        //       )
        //   );
        // }

for (let week in updatedEvents) {

  // Apply filter first
  if(columnKey != "animator"){
  updatedEvents[week] = updatedEvents[week].filter(
    (event) =>
      !(
        event.id === bodyData.id &&
        (event.status?.toLowerCase() === "pending" ||
          bodyData.status?.toLowerCase() === "pending") &&
        !(
          event.status?.toLowerCase() === "pending" &&
          bodyData.status?.toLowerCase() === "pending"
        )
      )
  );
  }

  // Then update
  
  updatedEvents[week] = updatedEvents[week].map((event) =>
    event.id === bodyData.id
      ? {
          ...event,
          [Object.keys(bodyData)[1]]: bodyData[Object.keys(bodyData)[1]],
        }
      : event
  );
}

        setEvents(updatedEvents);
        setDeleteStates(
          updatedEvents &&
          Object.keys(updatedEvents).map((key) =>
            updatedEvents[key].map((item) => ({ [item.id]: false }))
          )
        );

        if (key) {
          setSearchCache({
            [pageNo]: {
              cachedResponse: updatedEvents,
              cachedTotal: events.total,
            },
          });
        } else {
          setPageCache({
            [pageNo]: {
              cachedResponse: updatedEvents,
              cachedTotal: events.total,
            },
          });
        }
      } 
      else {
        toast.error(data.message);
      }
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      toast.error(translations.alertMessages.wentWrong[language]);
    } finally {
    }
  };
  const checkParent = async (event_Id) => {
    setIsLoading(true);
    try {
      const res = await fetch(
        ApiUrl + "/api/user/check-parentform/" + event_Id,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = await res.json();
      // {
      //   console.log("sdfkljakjsdf",data)
      // }
      if (data.status === "success") {
        if (data?.parentForm && data?.parentForm.length > 0) {
          const options =
            data?.parentForm &&
            data?.parentForm.length > 0 &&
            data.parentForm.map((item) => {
              return { label: item?.indexed_date, value: item.id };
            });
          setParentForms(options);
        }
        if (data?.clientForm && data?.clientForm.length > 0) {
          const options =
            data?.clientForm &&
            data?.clientForm.length > 0 &&
            data.clientForm.map((item) => {
              return { label: item?.indexed_date, value: item?.parent_id ? item?.parent_id : item?.child_id , parent_form: item?.parent_id ? true : false, };
            });
          setParentForms(options);
          setClientForms(true);
        }

        setEventId(event_Id);

        var createModal = new window.bootstrap.Modal(
          document.getElementById("createForm")
        );
        createModal.show();
      } else {
        setDisplayComponent("create-event");

        window.history.pushState(
          {
            id: "gallery",
            randomData: window.Math.random(),
          },
          "title",
          "/event-portal?page=create-event&parent_id=" +
          event_Id +
          "&event-navigate=true&getFormData=false"
        );
      }
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      toast.error(translations.alertMessages.wentWrong[language]);
    } finally {
    }
  };
  const getDealershipData = async (dealership_Id) => {
    setIsLoading(true);
    try {
      const res = await fetch(
        ApiUrl + "/api/user/dealer-ship-detail/" + dealership_Id,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = await res.json();
      if (data.status === "success") {
        seteditID(dealership_Id);
        setOldData(data.dealer_ship);
        var createModal = new window.bootstrap.Modal(
          document.getElementById("AddDealerModal")
        );
        createModal.show();
      } else {
        toast.error(data.message);
      }
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      toast.error(translations.alertMessages.wentWrong[language]);
    } finally {
    }
  };

  const moveColumn = (event) => {
    const { active, over } = event;

    if (!over || active.id === over.id) return;

    const oldIndex = currentView.columns.findIndex(
      (col) => col.id === active.id
    );
    const newIndex = currentView.columns.findIndex((col) => col.id === over.id);

    const reorderedColumns = arrayMove(currentView.columns, oldIndex, newIndex);
    const updatedData = { ...currentView, columns: reorderedColumns };
    setCurrentView((prevView) => ({ ...prevView, columns: reorderedColumns }));
    if (updatedData.type !== "default event") {
      updateView(updatedData);
    }
  };

  const handleResize = (columnId, newWidth) => {
    columnWidthsRef.current[columnId] = newWidth;
    // const newColumns = columns.map((col) =>
    //   col.id === columnId ? { ...col, width: newWidth } : col
    // );
    // setColumns(newColumns);
    // Immediate visual update
    requestAnimationFrame(() => {
      const columnElement = document.getElementById(columnId);

      if (columnElement) columnElement.style.width = `${newWidth}px`;
    });

    // Mark that a state update is needed
    if (!pendingStateUpdate.current) {
      pendingStateUpdate.current = true;
      debouncedUpdate(setCurrentView);
    }
  };

  // Debounce for smoother updates instead of throttle
  const debouncedUpdate = debounce((setCurrentView) => {
    const updatedData = {
      ...currentView,
      columns: currentView.columns.map((col) =>
        col.id in columnWidthsRef.current
          ? { ...col, width: columnWidthsRef.current[col.id] }
          : col
      ),
    };
    setCurrentView((prevColumns) => ({
      ...prevColumns,
      columns: prevColumns.columns.map((col) =>
        col.id in columnWidthsRef.current
          ? { ...col, width: columnWidthsRef.current[col.id] }
          : col
      ),
    }));
    if (updatedData.type !== "default event") {
      updateView(updatedData);
    }
    pendingStateUpdate.current = false; // Reset flag after update
  }, 16); // Adjust delay as needed

  const updateView = async (updatedData) => {
    try {
      const res = await fetch(ApiUrl + "/api/user/views", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(updatedData),
      });
      const data = await res.json();
      if (data.status === "success") {
        // toast.success(data?.message);
        const viewData2 = {
          ...data.userView,
          columns: JSON.parse(data.userView.columns),
        };
        setTableViews((prev) =>
          prev.map((item) => {
            if (item.id === updatedData.id) {
              return viewData2;
            }
            return item;
          })
        );
      } else {
        toast.error(translations.alertMessages.wentWrong[language]);
      }
    } catch (error) {
      toast.error(translations.alertMessages.wentWrong[language]);
    }
  };

  // Cleanup debounce on unmount
  useEffect(() => {
    return () => debouncedUpdate.cancel();
  }, [data]);

  // const exportData = (fileType) => {
  //   if (!currentView || !currentView.columns) {
  //     console.error("Current view is not set or missing columns.");
  //     return;
  //   }

  //   // Extract column keys from `currentView.columns`
  //   const selectedColumns = currentView.columns
  //     .slice(0, -1)
  //     .filter((item) => item.renderInView !== false)
  //     .map((col) => ({
  //       key: col.id, // Assuming column `id` matches the data field name
  //       header: col.content || col.id, // Column name in the exported file
  //     }));

  //   const selectedData =
  //     events && Object.keys(events).length > 0
  //       ? Object.keys(events).flatMap((weekKey) => {
  //         return events[weekKey].map((client) => {
  //           let rowData = {};


  //             // Include "Week" column
  //             // rowData["Week"] = weekKey;

  //             // Add only the selected columns
  //             selectedColumns.forEach(({ key, header }) => {
  //               if (
  //                 ["dealership", "package", "animator", "sales_rep"].includes(
  //                   key
  //                 )
  //               ) {
  //                 rowData[header] = client[key]?.name || "";
  //               } else
  //                 rowData[header] = client[key]?.name
  //                   ? client[key].name
  //                   : client[key] || ""; // Match data based on column key
  //             });

  //             return rowData;
  //           });
  //         })
  //       : [];

  //   // Create worksheet
  //   const worksheet = XLSX.utils.json_to_sheet(selectedData);
  //   const workbook = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(workbook, worksheet, "Exported Data");

  //   // Determine file type (CSV or XLSX)
  //   if (fileType === "csv") {
  //     const csvData = XLSX.utils.sheet_to_csv(worksheet);
  //     const blob = new Blob([csvData], { type: "text/csv" });
  //     const link = document.createElement("a");
  //     link.href = URL.createObjectURL(blob);
  //     link.download = `Export_Events_${format(new Date(), "dd/MM/yyyy")}.csv`;
  //     document.body.appendChild(link);
  //     link.click();
  //     document.body.removeChild(link);
  //   } else {
  //     XLSX.writeFile(
  //       workbook,
  //       `Export_Events_${format(new Date(), "dd/MM/yyyy")}.xlsx`
  //     );
  //   }
  // };

  // Helper function to translate column headers
  const getTranslatedColumnHeader = (columnId) => {
    const columnTranslationMap = {
      "week": translations.forms.formFields.week[language],
      "nom_vp": translations.commonFields.name[language],
      "group": translations.commonFields.group[language],
      "dealership": translations.quickCreationModal.dealership[language],
      "package": translations.forms.privateEventformFields.package[language],
      "start_date": translations.forms.privateEventformFields.startDate[language],
      "end_date": translations.forms.privateEventformFields.endDate[language],
      "clients": translations.forms.formFields.clients[language],
      "inactive": translations.forms.formFields.inactive[language],
      "conquest": translations.forms.formFields.conquestSection.title[language],
      "massif": translations.forms.formFields.massif[language],
      "amount": translations.forms.formFields.amount[language],
      "sales_rep": translations.forms.formFields.sales_representative[language],
      "animator": translations.forms.formFields.animator[language],
      "fidgi_contest": translations.forms.formFields.fidgi_contest[language],
      "brand": translations.quickCreationModal.brand[language],
      "project_manager": translations.forms.formFields.projectManager[language],
      "confirmation_agent": translations.forms.formFields.confirmationAgent[language],
      "no_show_agent": translations.forms.formFields.noShowAgent[language],
      "carton": translations.forms.formFields.carton[language],
      "sms": "SMS",
      "mailing": translations.forms.formFields.mailing[language],
      "web": translations.forms.formFields.web[language],
      "banner": translations.forms.formFields.banner[language],
      "news_letter": translations.forms.formFields.newsletter[language],
      "facebook": translations.forms.formFields.facebook[language],
      "ad_words": translations.forms.formFields.adwords[language],
      "amount_animator": translations.forms.formFields.amountAnimator[language],
      "invoice_animator": translations.forms.formFields.invoiceAnimator[language],
      "commission_paid": translations.forms.formFields.commissionPaid[language],
      "instructions": translations.forms.formFields.instructions[language],
      "call_centre": translations.forms.formFields.callCentre[language],
      "fidgi_contest": translations.forms.formFields.fidgi_contest[language],
      "created_by": translations.forms.formFields.createdBy[language],
      "invoice": translations.forms.formFields.invoice[language],
      "mailing_amount": translations.viewBillingPage.mailingAmount[language],

    };
    
    return columnTranslationMap[columnId] || columnId;
  };

  const exportData = (fileType) => {
    if (!currentView || !currentView.columns) {
      console.error("Current view is not set or missing columns.");
      return;
    }

    // Use selectedWeeks if available and non-empty, otherwise export all
    const dataSource =
      Array.isArray(selectedWeeks) && selectedWeeks.length > 0
        ? selectedWeeks
        : Object.keys(events || {});

    if (!dataSource || dataSource.length === 0) {
      console.warn("No data available to export.");
      return;
    }
// console.log("exporting data", {  currentView })
    // Extract visible columns with translated headers
    const selectedColumns = currentView.columns
      .slice(0, -1)
      .filter((item) => item.renderInView !== false)
      .map((col) => ({
        key: col.id,
        header: getTranslatedColumnHeader(col.id),
      }));

    // Prepare export data
    const selectedData = dataSource.flatMap((weekKey) =>
      events[weekKey]?.map((event, index) => {
        const rowData = {};
    
        selectedColumns.forEach(({ key, header }) => {
          // Handle special fields with custom display logic
          if (key === "dealership") {
            rowData[header] = event?.dealership?.name || "";
          } else if (key === "package") {
            rowData[header] = event?.package?.name || "";
          } else if (key === "sales_rep") {
            rowData[header] = event?.sales_rep?.name || "";
          } else if (key === "animator") {
            const matchedAnimator = animatorOptions.find(
              (option) =>
                option.value?.toString() === event?.animator_id?.toString()
            );
            rowData[header] = matchedAnimator
              ? matchedAnimator.label
              : ""; 
          } else if (key === "call_centre") {
            if (event?.call_centre === "internal") {
              rowData[header] = language === "fr" ? "Interne" : "Internal";
            } else if (event?.call_centre === "external") {
              rowData[header] = language === "fr" ? "Externe" : "External";
            } else {
              rowData[header] = event?.call_centre || "";
            }
          } else {
            // Handle Yes/No translation
            if (event[key] === "Yes") {
              rowData[header] = language === "fr" ? "Oui" : "Yes";
            } else if (event[key] === "No") {
              rowData[header] = language === "fr" ? "Non" : "No";
            } else {
              rowData[header] = event[key]?.name || event[key] || "";
            }
          }
        });
    
        return rowData;
      }) || []
    );

    // Create worksheet and workbook
    const worksheet = XLSX.utils.json_to_sheet(selectedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Exported Data");

    // Handle file export
    const filename = `${language === 'fr' ? 'Exportation_Events' : 'Export_Events'}_${format(new Date(), "dd/MM/yyyy")}`;

    if (fileType === "csv") {
      const csvData = XLSX.utils.sheet_to_csv(worksheet);
      const blob = new Blob([csvData], { type: "text/csv" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `${filename}.csv`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      XLSX.writeFile(workbook, `${filename}.xlsx`);
    }
  };

  const exportSelecedData = () => {
    if (!currentView || !currentView.columns) {
      // console.error("Current view is not set or missing columns.");
      return;
    }

    // Extract column keys from `currentView.columns`
    const selectedColumns = currentView.columns
      .slice(0, -1)
      .filter((item) => item.renderInView !== false)
      .map((col) => ({
        key: col.id, // Assuming column `id` matches the data field name
        header: col.content || col.id, // Column name in the exported file
      }));

    const selectedData =
      events && Object.keys(events).length > 0
        ? selectedWeeks
          .flatMap((weekKey) => {
            return events[weekKey]?.map((client) => {
              let rowData = {};


              // Include "Week" column
              // rowData["Week"] = weekKey;

              // Add only the selected columns
              selectedColumns.forEach(({ key, header }) => {
                if (
                  ["dealership", "package", "animator", "sales_rep"].includes(
                    key
                  )
                ) {
                  rowData[header] = client[key]?.name || "";
                } else
                  rowData[header] = client[key]?.name
                    ? client[key].name
                    : client[key] || ""; // Match data based on column key
              });

              return rowData;
            });
          })
        : [];

    // Create worksheet
    const worksheet = XLSX.utils.json_to_sheet(selectedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Exported Data");

    // Determine file type (CSV or XLSX)

    const csvData = XLSX.utils.sheet_to_csv(worksheet);
    const blob = new Blob([csvData], { type: "text/csv" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `Export_Events_${format(new Date(), "dd/MM/yyyy")}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const  downloadReport = async (eventId,eventName) =>{
    setIsLoading(true);

    try {
      const url = `${ApiUrl}/api/user/download-event-report-pdf/${eventId}`;
      const method = "GET";
      const res = await fetch(url, {
        method,
        headers: {
          // "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        responseType: "blob",
      });
      const blob = await res.blob(); // Get the binary data
      const text = await blob.slice(0, 10).text();

    if (!text.startsWith("%PDF")) {
      setIsLoading(false);
      toast.error(translations.alertMessages.pdfFailed[language]);
      return;
    }
    const now = new Date();

const pad = (n) => String(n).padStart(2, "0");

const timestamp =
  now.getFullYear().toString() +
  pad(now.getMonth() + 1) +
  pad(now.getDate()) +
  "_" +
  pad(now.getHours()) +
  pad(now.getMinutes()) +
  pad(now.getSeconds());
    let fileName = `${eventName ? eventName : "Event-Report"}_${timestamp}.pdf`
      const urlBlob = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = urlBlob;
      // link.setAttribute("download", "Event-Report-" + eventId + ".pdf"); 
      link.setAttribute("download",fileName); 
      document.body.appendChild(link);
      link.click();
      link.remove();
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      toast.error(translations.alertMessages.wentWrong[language]);
    }
  }

  const handleSelectAllChange = () => {
    if (selectAll) {
      // Deselect all
      setSelectedWeeks([]);
    } else {
      // Select all
      const allWeeks = Object.keys(events);
      setSelectedWeeks(allWeeks);
    }
    setSelectAll(!selectAll);
  };

  const handleCheckboxChange = (weekKey) => {
    setSelectedWeeks((prevSelected) =>
      prevSelected.includes(weekKey)
        ? prevSelected.filter((key) => key !== weekKey)
        : [...prevSelected, weekKey]
    );
  };

    const FindPathForMobile = (content, language) => {
      // Step 1: Find the full path for the given content
      const fullPath = findPathsToValue(translations, content)?.[0];
      // console.log("Full Path:", fullPath);  // Log the full path
    
      if (!fullPath) {
        // console.error(`No path found for content: ${content}`);
        return content;
      }
    
      // Step 2: Remove the last segment of the path to get the base path
      const trimmedPathArray = fullPath.split('.').slice(0, -1);
      const basePath = trimmedPathArray.join('.'); // Base path without the last segment
      // console.log("Base Path:", basePath);  // Log the base path
    
      // Step 3: Access the translation dynamically using reduce
      const translation = basePath
        .split('.')   // Split basePath into an array of keys
        .reduce((obj, key) => (obj && obj[key] ? obj[key] : undefined), translations);
    
      // Check if the translation exists for the provided language
      const result = translation ? translation[language] : undefined;
    
      // console.log("Translation Found:", result);
    
      if (!result) {
        // console.error(`No translation found at path: ${basePath} for language: ${language}`);
        return content;
      }
    
      return result;
    };
    // console.log("mobile content", filterOption)
// The API applies the selected Current/Archive/Future/status filter. Grand
// totals must use the same records that are rendered in the weekly rows.
const displayedEvents = Object.values(events || {}).flatMap((weekEvents) =>
  Array.isArray(weekEvents) ? weekEvents : []
);

  return (
    <div className="Event Index Private">
      {!loading ? (
        <>
          <CreateFormModal
            isDarkMode={isDarkMode}
            handleCopy={handleCopy}
            parentId={parentId}
            setParentId={setParentId}
            eventId={eventId}
            setEventId={setEventId}
            setDisplayComponent={setDisplayComponent}
            parentForms={parentForms}
            setChildId={setChildId}
            formDealerID={formDealerID}
          />
          <EditEventModal
            dealerships={dealerships}
            eventNavigate={true}
            editID={editID}
            isEdit={true}
            oldData={oldData}
            setOldData={setOldData}
            setIsLoading={setIsLoading}
            brands={brands}
            isDarkMode={isDarkMode}
            repOptions={repOptions}
          />
          <FilterBar
            isDarkMode={isDarkMode}
            allfields={allfields}
            monthsList={monthsList}
            monthTranslations={monthTranslations}
            checkedFields={checkedFields}
            setCheckedFields={setCheckedFields}
            textOptions={textOptions}
            textOptions2={textOptions2}
            filterOption={filterOption}
            setFilterOption={setFilterOption}
            dealerOptions={dealerOptions}
            groupOptions={groupOptions}
            repOptions2={repOptions2}
            managers={managers}
            packageOptions={packageOptions}
            animatorOptions={animatorOptions}
            getFilteredEvents={getFilteredEvents}
            weekOptions={weekOptions}
            setFiltersData={setFiltersData}
            filtersData={filtersData}
            agentOptions={agentOptions}
            brandOptions={brands}
          />
          <AddViewModal
            isDarkMode={isDarkMode}
            // getColumns={
            //   (data?.user_views &&
            //     data.user_views?.find(
            //       (item) => item.type === "default event"
            //     )) ||
            //   {}
            // }
            getColumns={AllEventColoumnData}
            setTableViews={setTableViews}
            setIsLoading={setIsLoading}
            viewData={viewData}
            setViewData={setViewData}
            setCurrentView={setCurrentView}
          />
          <div className="container maincont">
            <div id="app" className="eventsContainer">
              <div className="row align-items-center justify-content-between event-header-wrapper" >
                <div className="col-3 d-flex align-items-center gap-3" style={{paddingRight: isMobile && "0px", paddingLeft: isMobile && '0px'}}>
                  <div>
                    <h2
                      id="h1"
                      className={`col-1${isDarkMode ? "darkthead col-1" : ""}`}
                      style={{fontSize: isMobile && "1.25rem" , marginBottom: isMobile && '0px'}}
                    >
                      {pageTranslations["title"].events[language]}
                    </h2>
                  </div>
                </div>
                <div className="col-9 d-flex align-items-center justify-content-end gap-1 header-section-wraper" style={{paddingRight: isMobile && "0px", paddingLeft: isMobile && '0px'}}>
                  {/* {userData &&
                    (userData.roles[0].permissions.some(
                      (item) => item.name === "Event Report"
                    ) ||
                      userData.roles[0].permissions.some(
                        (item) => item.name === "Contract And Billing"
                      )) && (
                      <div style={{ width: "250px" }}>
                        <Select
                          className="w-100 selectpicker"
                          aria-labelledby="dealership-name-quick"
                          options={[
                            userData &&
                              userData.roles[0].permissions.some(
                                (item) => item.name === "Event Report"
                              ) && {
                                label:
                                  translations.topAndsidebar.eventReports[
                                    language
                                  ],
                                value: "view-event-report",
                              },
                            userData &&
                              userData.roles[0].permissions.some(
                                (item) => item.name === "Contract And Billing"
                              ) && {
                                label:
                                  translations.topAndsidebar.billingReport[
                                    language
                                  ],
                                value: "view-billing-report",
                              },
                            !window.location.href.includes("page=events") && {
                              label:
                                translations.EventsPortal.title.events[
                                  language
                                ],
                              value: "events",
                            },
                          ].filter(Boolean)}
                          placeholder={
                            translations["dropdown"].select[language]
                          }
                          isSearchable={false}
                          value={{
                            label:
                              translations.EventsPortal.title.events[language],
                            value: "events",
                          }}
                          onChange={(selectedOption) => {
                            setDisplayComponent((prev) => {
                              setPrevDisplay(prev);
                              return `${selectedOption.value}`;
                            });
                            window.history.pushState(
                              {
                                id: "gallery",
                                randomData: window.Math.random(),
                              },
                              "title",
                              `/event-portal?page=${selectedOption.value}`
                            );
                          }}
                          styles={{
                            input: (provided) => ({
                              ...provided,
                              color: isDarkMode ? "#ffffff" : "black",
                            }),
                            control: (provided, state) => ({
                              ...provided,
                              backgroundColor: isDarkMode
                                ? "transparent"
                                : "white",
                              border: state.isFocused
                                ? "1px solid #80bdff"
                                : isDarkMode
                                ? "1px solid #495057"
                                : "1px solid #dee2e6",
                              boxShadow: state.isFocused
                                ? "0 0 0 0.2rem rgba(0, 123, 255, 0.25)"
                                : "none",
                              borderRadius: ".45rem",
                            }),
                            valueContainer: (provided) => ({
                              ...provided,
                              padding: "0.18rem 0.55rem",
                            }),
                            indicatorSeparator: (provided) => ({
                              ...provided,
                              display: "none",
                            }),
                            dropdownIndicator: (provided) => ({
                              ...provided,
                              padding: "0.375rem 0.75rem",
                              color: isDarkMode ? "#ffffff" : "#868686",
                            }),
                            menu: (provided) => ({
                              ...provided,
                              color: isDarkMode ? "#ffffff" : "black",
                              backgroundColor: isDarkMode ? "#1f2023" : "white",
                              margin: "0",
                              zIndex: "9999",
                            }),
                            placeholder: (provided) => ({
                              ...provided,
                              color: isDarkMode ? "#ffffff" : "#333333",
                            }),
                            singleValue: (provided) => ({
                              ...provided,
                              color: isDarkMode ? "#ffffff" : "",
                            }),
                            option: (provided, state) => ({
                              ...provided,
                              color: isDarkMode ? "#ffffff" : "black",
                              backgroundColor: state.isHovered
                                ? "#80bdff"
                                : isDarkMode
                                ? "#1f2023"
                                : "white",
                              ":hover": {
                                backgroundColor: isDarkMode
                                  ? "#34DBB4"
                                  : "#34DBB4",
                              },
                            }),
                          }}
                        />
                      </div>
                    )} */}
                  {!isMobile && (
                    <div className="header-btn-mobile">
                      {userData &&
                        userData.roles[0].permissions.some(
                          (item) => item.name === "Private Event Store"
                        ) && (
                          <div className="d-grid gap-2">
                            <button
                              type="button"
                              className="d-flex btn btn-primary align-items-center admin-btn gap-1"
                              onClick={() => {
                                setDisplayComponent((prev) => {
                                  return "create-privateEvent";
                                });
                                window.history.pushState(
                                  {
                                    id: "gallery",
                                    randomData: window.Math.random(),
                                  },
                                  "title",
                                  "/event-portal?page=create-privateEvent"
                                );
                              }}
                            >
                              <i className="bi bi-calendar2-event"></i>{" "}
                              {
                                translations.topAndsidebar.createPrivateEvent[
                                  language
                                ]
                              }
                            </button>
                          </div>
                        )}
                      {userData &&
                        userData.roles[0].permissions.some(
                          (item) => item.name === "Private Event Store"
                        ) && (
                          <div
                            className="btn-group"
                            role="group"
                            aria-label="Basic example"
                          >
                            <button
                              id="quickAdd"
                              type="submit"
                              className="btn btn-primary admin-btn"
                              data-bs-toggle="modal"
                              data-bs-target="#modalQuickAdd"
                              fdprocessedid="2rud2c"
                            >
                              <i className="bi bi-speedometer"></i>{" "}
                              {
                                translations.topAndsidebar.quickCreation[
                                  language
                                ]
                              }
                            </button>
                          </div>
                        )}
                    </div>
                  )}

                  {userType &&
                    internalUsers.includes(userType) &&
                    userType !== "Animator" &&
                    userType !== "Agent" &&
                    userType !== "Manager" && (
                      <span className="me-1 ms-1 fs-3 mb-1 hide-on-mobile">
                        |
                      </span>
                    )}
                  {/* mobile view */}
                  {
                    !isMobile &&
                    <div style={{ display: "flex" }} className="hide-on-desktop">
                    {userType && internalUsers.includes(userType) && (
                      <div className="" style={{ width: "160px" }}>
                        <Select
                          className="w-100 selectpicker"
                          aria-labelledby="dealership-name-quick"
                          options={filterOptions}
                          placeholder={
                            translations["dropdown"].select[language]
                          }
                          isSearchable={false}
                          value={
                            (filterOptions &&
                              filterOptions.length > 0 &&
                              filterOptions.find(
                                (option) => option.value === filterOption
                              )) || {
                              value: "",
                              label: translations["dropdown"].select[language],
                            }
                          }
                          onChange={(selectedOption) => {
                            setFilterOption(selectedOption.value);
                            setSelectedYear("");
                            const filteredFields = checkedFields.filter(
                              (field) =>
                                field?.value !== "" || field?.value.length > 0
                            );
                            
                            if (filteredFields && filteredFields.length > 0) {
                              const filteredData = filteredFields.reduce(
                                (acc, field) => {
                                  if (field.name === "month") return {...acc , start_date:field.start_date ,end_date:field.end_date};
                                  acc[
                                    field.filterKey ||
                                    (field.name === "fidgi_contest"
                                      ? field.name
                                      : field.type === "dropdown"
                                      ? field.name + "_id"
                                      : field.name)
                                  ] =
                                    field.type === "text"
                                      ? [field.value, field.filterType]
                                      : [field.value];
                                  return acc;
                                },
                                {}
                              );
                              const mergedData = {
                                ...filteredData,
                              };

                              mergedData.type = selectedOption.value;
                              getFilteredEvents(mergedData, checkedFields);
                            } else {
                              const data = { type: selectedOption.value };
                              const updated = {
                                ...(JSON.parse(localStorage.getItem("eventsFilterPostData")) || {}),
                                ...data,
                              };
                              localStorage.setItem(
                                "eventsFilterPostData",
                                JSON.stringify(updated)
                              );
                              filterEvents(data);
                            }
                          }}
                          styles={{
                            input: (provided) => ({
                              ...provided,
                              color: isDarkMode ? "#ffffff" : "black",
                            }),
                            control: (provided, state) => ({
                              ...provided,
                              backgroundColor: isDarkMode
                                ? "transparent"
                                : "white",
                              border: state.isFocused
                                ? "1px solid #80bdff"
                                : isDarkMode
                                ? "1px solid #495057"
                                : "1px solid #dee2e6",
                              boxShadow: state.isFocused
                                ? "0 0 0 0.2rem rgba(0, 123, 255, 0.25)"
                                : "none",
                              borderRadius: ".45rem",
                            }),
                            valueContainer: (provided) => ({
                              ...provided,
                              padding: "0.18rem 0.55rem",
                            }),
                            indicatorSeparator: (provided) => ({
                              ...provided,
                              display: "none",
                            }),
                            dropdownIndicator: (provided) => ({
                              ...provided,
                              padding: "0.375rem 0.75rem",
                              color: isDarkMode ? "#ffffff" : "#868686",
                            }),
                            menu: (provided) => ({
                              ...provided,
                              color: isDarkMode ? "#ffffff" : "black",
                              backgroundColor: isDarkMode ? "#1f2023" : "white",
                              margin: "0",
                              zIndex: "9999",
                            }),
                            placeholder: (provided) => ({
                              ...provided,
                              color: isDarkMode ? "#ffffff" : "#333333",
                            }),
                            singleValue: (provided) => ({
                              ...provided,
                              color: isDarkMode ? "#ffffff" : "",
                            }),
                            option: (provided, state) => ({
                              ...provided,
                              color: isDarkMode ? "#ffffff" : "black",
                              backgroundColor: state.isHovered
                                ? "#80bdff"
                                : isDarkMode
                                ? "#1f2023"
                                : "white",
                              ":hover": {
                                backgroundColor: isDarkMode
                                  ? "#34DBB4"
                                  : "#34DBB4",
                              },
                            }),
                          }}
                        />
                      </div>
                    )}

                    { userType &&
                      !externalUsers.includes(userType) &&
                      userType !== "Animator" && (
                        <>
                          {currentView &&
                            (currentView?.csv === "1" ||
                              currentView?.csv === true ||
                              currentView?.xlsx === "1" ||
                              currentView?.xlsx === true) &&
                            userData.roles[0].permissions.some(
                              (item) => item.name === "Event Data Export"
                            ) && (
                              <div
                                className="btn-group"
                                role="group"
                                aria-label="Basic example"
                              >
                                <div className="btn-group" role="group">
                                  {(currentView?.xlsx === true ||
                                    currentView?.xlsx === "1") && (
                                    <button
                                      type="button"
                                      className="d-flex btn btn-primary align-items-center justify-content-center admin-btn edit-button gap-1 mx-auto"
                                      style={{
                                        width: "100%",
                                        maxWidth: "150px",
                                        whiteSpace: "nowrap",
                                        textOverflow: "ellipsis",
                                        overflow: "hidden",
                                      }}
                                      onClick={() => {
                                        exportData("xlsx");
                                      }}
                                    >
                                      <i className={"bi bi-filetype-xlsx"}></i>{" "}
                                    </button>
                                  )}
                                  {(currentView?.csv === true ||
                                    currentView?.csv === "1") && (
                                    <button
                                      type="button"
                                      className="d-flex btn btn-danger align-items-center justify-content-center edit-button gap-1 mx-auto"
                                      style={{
                                        width: "100%",
                                        maxWidth: "150px",
                                        whiteSpace: "nowrap",
                                        textOverflow: "ellipsis",
                                        overflow: "hidden",
                                      }}
                                      onClick={() => {
                                        exportData("csv");
                                      }}
                                    >
                                      <i className={"bi bi-filetype-csv"}></i>{" "}
                                    </button>
                                  )}
                                </div>
                              </div>
                            )}
                        </>
                      )}
                  </div>
                  }
                  
                  <div className="header-btn-mobile-second">
                    {
                      !isMobile &&
                    
                    userType && internalUsers.includes(userType) && (
                      <div
                        className=""
                        style={{ width: "160px" }}
                      >
                        <Select
                          className="w-100 selectpicker"
                          aria-labelledby="dealership-name-quick"
                          options={filterOptions}
                          placeholder={
                            translations["dropdown"].select[language]
                          }
                          isSearchable={false}
                          value={
                            (filterOptions &&
                              filterOptions.length > 0 &&
                              filterOptions.find(
                                (option) => option.value === filterOption
                              )) || {
                              value: "",
                              label: translations["dropdown"].select[language],
                            }
                          }
                          onChange={(selectedOption) => {
                            setFilterOption(selectedOption.value);
                            setSelectedYear("");
                            const filteredFields = checkedFields.filter(
                              (field) =>
                                field?.value !== "" || field?.value.length > 0
                            );

                            if (filteredFields && filteredFields.length > 0) {
                              const filteredData = filteredFields.reduce(
                                (acc, field) => {
                                  if (field.name === "month") return {...acc , start_date:field.start_date ,end_date:field.end_date};
                                  acc[
                                    field.filterKey ||
                                    (field.name === "fidgi_contest"
                                      ? field.name
                                      : field.type === "dropdown"
                                      ? field.name + "_id"
                                      : field.name)
                                  ] =
                                    field.type === "text"
                                      ? [field.value, field.filterType]
                                      : [field.value];
                                  return acc;
                                },
                                {}
                              );
                              const mergedData = {
                                ...filteredData,
                              };

                              mergedData.type = selectedOption.value;
                              getFilteredEvents(mergedData, checkedFields);
                            } else {
                              const data = { type: selectedOption.value };
                              const updated = {
                                ...(JSON.parse(localStorage.getItem("eventsFilterPostData")) || {}),
                                ...data,
                              };
                              localStorage.setItem(
                                "eventsFilterPostData",
                                JSON.stringify(updated)
                              );
                              filterEvents(data);
                            }
                          }}
                          styles={{
                            input: (provided) => ({
                              ...provided,
                              color: isDarkMode ? "#ffffff" : "black",
                            }),
                            control: (provided, state) => ({
                              ...provided,
                              backgroundColor: isDarkMode
                                ? "transparent"
                                : "white",
                              border: state.isFocused
                                ? "1px solid #80bdff"
                                : isDarkMode
                                ? "1px solid #495057"
                                : "1px solid #dee2e6",
                              boxShadow: state.isFocused
                                ? "0 0 0 0.2rem rgba(0, 123, 255, 0.25)"
                                : "none",
                              borderRadius: ".45rem",
                            }),
                            valueContainer: (provided) => ({
                              ...provided,
                              padding: "0.18rem 0.55rem",
                            }),
                            indicatorSeparator: (provided) => ({
                              ...provided,
                              display: "none",
                            }),
                            dropdownIndicator: (provided) => ({
                              ...provided,
                              padding: "0.375rem 0.75rem",
                              color: isDarkMode ? "#ffffff" : "#868686",
                            }),
                            menu: (provided) => ({
                              ...provided,
                              color: isDarkMode ? "#ffffff" : "black",
                              backgroundColor: isDarkMode ? "#1f2023" : "white",
                              margin: "0",
                              zIndex: "9999",
                            }),
                            placeholder: (provided) => ({
                              ...provided,
                              color: isDarkMode ? "#ffffff" : "#333333",
                            }),
                            singleValue: (provided) => ({
                              ...provided,
                              color: isDarkMode ? "#ffffff" : "",
                            }),
                            option: (provided, state) => ({
                              ...provided,
                              color: isDarkMode ? "#ffffff" : "black",
                              backgroundColor: state.isHovered
                                ? "#80bdff"
                                : isDarkMode
                                ? "#1f2023"
                                : "white",
                              ":hover": {
                                backgroundColor: isDarkMode
                                  ? "#34DBB4"
                                  : "#34DBB4",
                              },
                            }),
                          }}
                        />
                      </div>
                    )
                    }
                    
                    { !isMobile && yearFilterTypes.includes(filterOption) && (
                      <div style={{ width: "250px" }}>
                        <Select
                          className="w-100 selectpicker"
                          aria-labelledby="dealership-name-quick"
                          options={getYearOptions(filterOption)}
                          placeholder={
                            translations["dropdown"].select[language]
                          }
                          isSearchable={false}
                          value={
                            getYearOptions(filterOption).find(
                              (option) => option.value === selectedYear
                            ) || {
                              value: "",
                              label: translations["dropdown"].select[language],
                            }
                          }
                          onChange={(selectedOption) => {
                            setSelectedYear(selectedOption.value);
                            const filteredFields = checkedFields.filter(
                              (field) =>
                                field?.value !== "" || field?.value.length > 0
                            );

                            if (filteredFields && filteredFields.length > 0) {
                              const filteredData = filteredFields.reduce(
                                (acc, field) => {
                                  if (field.name === "month") return {...acc , start_date:field.start_date ,end_date:field.end_date};
                                  acc[
                                    field.filterKey ||
                                    (field.name === "fidgi_contest"
                                      ? field.name
                                      : field.type === "dropdown"
                                      ? field.name + "_id"
                                      : field.name)
                                  ] =
                                    field.type === "text"
                                      ? [field.value, field.filterType]
                                      : [field.value];
                                  return acc;
                                },
                                {}
                              );

                              const mergedData = {
                                ...filteredData,
                              };
                              mergedData[getYearFilterKey(filterOption)] =
                                selectedOption.value;

                              getFilteredEvents(mergedData, checkedFields);
                            } else {
                              const data = {
                                type: filterOption,
                                [getYearFilterKey(filterOption)]: selectedOption.value,
                              };
                              const updated = {
                                ...(JSON.parse(localStorage.getItem("eventsFilterPostData")) || {}),
                                type: filterOption,
                                [getYearFilterKey(filterOption)]: selectedOption.value,
                              };
                              localStorage.setItem(
                                "eventsFilterPostData",
                                JSON.stringify(updated)
                              );
                              filterEvents(data);
                            }
                          }}
                          styles={{
                            input: (provided) => ({
                              ...provided,
                              color: isDarkMode ? "#ffffff" : "black",
                            }),
                            control: (provided, state) => ({
                              ...provided,
                              backgroundColor: isDarkMode
                                ? "transparent"
                                : "white",
                              border: state.isFocused
                                ? "1px solid #80bdff"
                                : isDarkMode
                                ? "1px solid #495057"
                                : "1px solid #dee2e6",
                              boxShadow: state.isFocused
                                ? "0 0 0 0.2rem rgba(0, 123, 255, 0.25)"
                                : "none",
                              borderRadius: ".45rem",
                            }),
                            valueContainer: (provided) => ({
                              ...provided,
                              padding: "0.18rem 0.55rem",
                            }),
                            indicatorSeparator: (provided) => ({
                              ...provided,
                              display: "none",
                            }),
                            dropdownIndicator: (provided) => ({
                              ...provided,
                              padding: "0.375rem 0.75rem",
                              color: isDarkMode ? "#ffffff" : "#868686",
                            }),
                            menu: (provided) => ({
                              ...provided,
                              color: isDarkMode ? "#ffffff" : "black",
                              backgroundColor: isDarkMode ? "#1f2023" : "white",
                              margin: "0",
                              zIndex: "9999",
                            }),
                            placeholder: (provided) => ({
                              ...provided,
                              color: isDarkMode ? "#ffffff" : "#333333",
                            }),
                            singleValue: (provided) => ({
                              ...provided,
                              color: isDarkMode ? "#ffffff" : "",
                            }),
                            option: (provided, state) => ({
                              ...provided,
                              color: isDarkMode ? "#ffffff" : "black",
                              backgroundColor: state.isHovered
                                ? "#80bdff"
                                : isDarkMode
                                ? "#1f2023"
                                : "white",
                              ":hover": {
                                backgroundColor: isDarkMode
                                  ? "#34DBB4"
                                  : "#34DBB4",
                              },
                            }),
                          }}
                        />
                      </div>
                    )}
                    {!isMobile && userType &&
                      !externalUsers.includes(userType) &&
                      userType !== "Animator" && (
                        <>
                          {currentView &&
                            (currentView?.csv === "1" ||
                              currentView?.csv === true ||
                              currentView?.xlsx === "1" ||
                              currentView?.xlsx === true) &&
                            userData.roles[0].permissions.some(
                              (item) => item.name === "Event Data Export"
                            ) && (
                              <div
                                className="btn-group hide-on-mobile"
                                role="group"
                                aria-label="Basic example"
                              >
                                <div className="btn-group" role="group">
                                  {(currentView?.xlsx === true ||
                                    currentView?.xlsx === "1") && (
                                    <button
                                      type="button"
                                      className="d-flex btn btn-primary align-items-center justify-content-center admin-btn edit-button gap-1 mx-auto"
                                      style={{
                                        width: "100%",
                                        maxWidth: "150px",
                                        whiteSpace: "nowrap",
                                        textOverflow: "ellipsis",
                                        overflow: "hidden",
                                      }}
                                      onClick={() => {
                                        exportData("xlsx");
                                      }}
                                    >
                                      <i className={"bi bi-filetype-xlsx"}></i>{" "}
                                    </button>
                                  )}
                                  {(currentView?.csv === true ||
                                    currentView?.csv === "1") && (
                                    <button
                                      type="button"
                                      className="d-flex btn btn-danger align-items-center justify-content-center edit-button gap-1 mx-auto"
                                      style={{
                                        width: "100%",
                                        maxWidth: "150px",
                                        whiteSpace: "nowrap",
                                        textOverflow: "ellipsis",
                                        overflow: "hidden",
                                      }}
                                      onClick={() => {
                                        exportData("csv");
                                      }}
                                    >
                                      <i className={"bi bi-filetype-csv"}></i>{" "}
                                    </button>
                                  )}
                                </div>
                              </div>
                            )}
                          {userType !== "Animator" &&
                            userType !== "Agent" &&
                            userType !== "Manager" && (
                              <div
                                className="btn-group template-name-mobile"
                                style={{ width: "250px" }}
                              >
                                <button
                                  type="button"
                                  className="btn btn-light dropdown-toggle"
                                  data-bs-toggle="dropdown"
                                  aria-expanded="false"
                                  // style={{ width: "125px" }}
                                  style={{
                                    width: "125px",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                  }}
                                >
                                  {/* {translations.EventsPortal.views.default[language]} */}
                                  {/* {currentView?.name} */}
                                  {language == "fr" &&
                                  currentView?.name === "Default View"
                                    ? "Vue par défaut"
                                    : currentView?.name}
                                </button>
                                <ul
                                  className="dropdown-menu"
                                  style={{
                                    minWidth: "250px",
                                    background: isDarkMode
                                      ? "#2b3035"
                                      : "#FFFFFF",
                                  }}
                                >
                                  <li
                                    style={{
                                      maxHeight: "200px",
                                      overflow: "auto",
                                    }}
                                  >
                                    {tableViews &&
                                      tableViews.map((view, index) => (
                                        <li
                                          className="w-100"
                                          key={index}
                                          style={{
                                            ":hover": {
                                              backgroundColor: isDarkMode
                                                ? "#343A3F"
                                                : "#34DBB4",
                                            },
                                          }}
                                        >
                                          <div
                                            className={`dropdown-item ${
                                              isDarkMode
                                                ? "views-hover-dark"
                                                : "views-hover"
                                            }  px-2 d-flex align-items-center justify-content-between w-100`}
                                            href="#"
                                            style={{
                                              ":hover": {
                                                background: isDarkMode
                                                  ? "#343A3F"
                                                  : "#34DBB4",
                                              },
                                            }}
                                          >
                                            <p
                                              className="w-100"
                                              style={{ cursor: "pointer" }}
                                              onClick={() => {
                                                const updatedData =
                                                  tableViews.map((item) =>
                                                    item.id === view.id
                                                      ? {
                                                          ...item,
                                                          current: true,
                                                        }
                                                      : {
                                                          ...item,
                                                          current: false,
                                                        }
                                                  );
                                                setTableViews(updatedData);
                                                setCurrentView({
                                                  ...view,
                                                  current: true,
                                                });
                                                updateView({
                                                  ...view,
                                                  current: true,
                                                });
                                              }}
                                            >
                                              {language == "fr" &&
                                              view.name === "Default View"
                                                ? "Vue par défaut"
                                                : language == "fr" &&
                                                  view.name ===
                                                    "Contract and Billing"
                                                ? "Contrat et facturation"
                                                : view.name}{" "}
                                            </p>
                                            <div
                                              className="d-flex align-items-center gap-2"
                                              style={{ fontSize: "18px" }}
                                            >
                                              <i
                                                className="bi bi-star-fill"
                                                style={{
                                                  color:
                                                    currentView?.id === view?.id
                                                      ? "gold"
                                                      : "#adb5bd",
                                                }}
                                              ></i>{" "}
                                              <i
                                                className="bi bi-pencil-fill"
                                                style={{
                                                  color:
                                                    view?.type ===
                                                      "default event" ||
                                                    view?.name ===
                                                      "Contract and Billing"
                                                      ? "#adb5bd"
                                                      : "#445775",
                                                  cursor:
                                                    view?.type ===
                                                      "default event" ||
                                                    view?.name ===
                                                      "Contract and Billing"
                                                      ? "default"
                                                      : "pointer",
                                                }}
                                                onClick={() => {
                                                  if (
                                                    view.type !==
                                                      "default event" &&
                                                    view?.name !==
                                                      "Contract and Billing"
                                                  ) {
                                                    const groupColumn = {
                                                      id: "group",
                                                      style: {
                                                        minWidth: "83px",
                                                      },
                                                      width: 83,
                                                      content: "Group",
                                                      renderInView: false,
                                                    };

                                                    const hasGroup =
                                                      view.columns?.some(
                                                        (col) =>
                                                          col.id === "group"
                                                      );
                                                    const fidgiContestColumn = {
                                                      id: "fidgi_contest",
                                                      style: {
                                                        minWidth: "100px",
                                                      },
                                                      width: 100,
                                                      content: "Fidgi Contest",
                                                      renderInView: false,
                                                    };
                                                    const hasFidgiContest = view.columns?.some((col) => col.id === "fidgi_contest");
                                                    const callCentreColumn = {
                                                      id: "call_centre",
                                                      style: {
                                                        minWidth: "100px",
                                                      },
                                                      width: 100,
                                                      content: "Call Centre",
                                                      renderInView: false,
                                                    };
                                                    const hasCallCentre = view.columns?.some((col) => col.id === "call_centre");
                                                    let updatedColumns = [...view.columns];
                                                    // const updatedColumns =
                                                    //   hasGroup
                                                    //     ? view.columns
                                                    //     : [
                                                    //         ...view.columns.slice(
                                                    //           0,
                                                    //           2
                                                    //         ),
                                                    //         groupColumn,
                                                    //         ...view.columns.slice(
                                                    //           2
                                                    //         ),
                                                    //       ];
                                                    if (!hasGroup) {
                                                      updatedColumns = [
                                                        ...updatedColumns.slice(0, 2),
                                                        groupColumn,
                                                        ...updatedColumns.slice(2),
                                                      ];
                                                    }

                                                    // add call_centre (after group OR same position logic)
                                                    if (!hasCallCentre) {
                                                      updatedColumns = [
                                                        ...updatedColumns.slice(0, 3), // adjust index if needed
                                                        callCentreColumn,
                                                        ...updatedColumns.slice(3),
                                                      ];
                                                    }

                                                      if (!hasFidgiContest) {
                                                      updatedColumns = [
                                                        ...updatedColumns.slice(0, 3), // adjust index if needed
                                                        fidgiContestColumn,
                                                        ...updatedColumns.slice(3),
                                                      ];
                                                    }

                                                    setViewData({
                                                      ...view,
                                                      columns: updatedColumns,
                                                      mode: "edit",
                                                    });
                                                    // setViewData({ ...view, mode: "edit" });
                                                    button.click();
                                                  }
                                                }}
                                              ></i>{" "}
                                              <i
                                                className="bi bi-trash-fill"
                                                style={{
                                                  color:
                                                    currentView?.id ===
                                                      view?.id ||
                                                    view.type ===
                                                      "default event" ||
                                                    view?.name ===
                                                      "Contract and Billing"
                                                      ? "#adb5bd"
                                                      : "#dc3545",
                                                  cursor:
                                                    currentView?.id ===
                                                      view?.id ||
                                                    view.type ===
                                                      "default event" ||
                                                    view?.name ===
                                                      "Contract and Billing"
                                                      ? "default"
                                                      : "pointer",
                                                }}
                                                onClick={() => {
                                                  if (
                                                    currentView?.id !==
                                                      view?.id &&
                                                    view.type !==
                                                      "default event" &&
                                                    view?.name !==
                                                      "Contract and Billing"
                                                  ) {
                                                    setViewData({
                                                      ...view,
                                                      mode: "delete",
                                                    });
                                                    button.click();
                                                  }
                                                }}
                                              ></i>{" "}
                                            </div>
                                          </div>
                                        </li>
                                      ))}
                                  </li>

                                  <li className="w-100 mt-2 px-2">
                                    <button
                                      type="button"
                                      className="btn btn-light w-100"
                                      data-bs-toggle="modal"
                                      data-bs-target="#addViewModal"
                                      fdprocessedid="2rud2c"
                                      id="openViewModal"
                                    >
                                      <i className="bi bi-plus"></i>{" "}
                                      {
                                        translations.EventsPortal.views
                                          .addNewView[language]
                                      }
                                    </button>
                                  </li>
                                </ul>
                              </div>
                            )}
                        </>
                      )}
                     {
                      isMobile &&
                      <div style={{gap: yearFilterTypes.includes(filterOption) ? "0px" : '5px'}} className=" d-flex header-btn-mobile-last">
                    { !yearFilterTypes.includes(filterOption) && userType && internalUsers.includes(userType) && (
                      <div className="" style={{ width: "125px" }}>
                        <Select
                          className="w-100 selectpicker"
                          aria-labelledby="dealership-name-quick"
                          options={filterOptions}
                          placeholder={
                            translations["dropdown"].select[language]
                          }
                          isSearchable={false}
                          value={
                            (filterOptions &&
                              filterOptions.length > 0 &&
                              filterOptions.find(
                                (option) => option.value === filterOption
                              )) || {
                              value: "",
                              label: translations["dropdown"].select[language],
                            }
                          }
                          onChange={(selectedOption) => {
                            setFilterOption(selectedOption.value);
                            setSelectedYear("");
                            const filteredFields = checkedFields.filter(
                              (field) =>
                                field?.value !== "" || field?.value.length > 0
                            );

                            if (filteredFields && filteredFields.length > 0) {
                              const filteredData = filteredFields.reduce(
                                (acc, field) => {
                                  if (field.name === "month") return {...acc , start_date:field.start_date ,end_date:field.end_date};
                                  acc[
                                    field.filterKey ||
                                    (field.name === "fidgi_contest"
                                      ? field.name
                                      : field.type === "dropdown"
                                      ? field.name + "_id"
                                      : field.name)
                                  ] =
                                    field.type === "text"
                                      ? [field.value, field.filterType]
                                      : [field.value];
                                  return acc;
                                },
                                {}
                              );
                              const mergedData = {
                                ...filteredData,
                              };

                              mergedData.type = selectedOption.value;

                              getFilteredEvents(mergedData, checkedFields);
                            } else {
                              const data = { type: selectedOption.value };
                              const updated = {
                                ...(JSON.parse(localStorage.getItem("eventsFilterPostData")) || {}),
                                ...data,
                              };
                              localStorage.setItem(
                                "eventsFilterPostData",
                                JSON.stringify(updated)
                              );
                              filterEvents(data);
                            }
                          }}
                          styles={{
                            input: (provided) => ({
                              ...provided,
                              color: isDarkMode ? "#ffffff" : "black",
                            }),
                            control: (provided, state) => ({
                              ...provided,
                              backgroundColor: isDarkMode
                                ? "transparent"
                                : "white",
                              border: state.isFocused
                                ? "1px solid #80bdff"
                                : isDarkMode
                                ? "1px solid #495057"
                                : "1px solid #dee2e6",
                              boxShadow: state.isFocused
                                ? "0 0 0 0.2rem rgba(0, 123, 255, 0.25)"
                                : "none",
                              borderRadius: ".45rem",
                            }),
                            valueContainer: (provided) => ({
                              ...provided,
                              padding: "0.18rem 0.55rem",
                            }),
                            indicatorSeparator: (provided) => ({
                              ...provided,
                              display: "none",
                            }),
                            dropdownIndicator: (provided) => ({
                              ...provided,
                              padding: "0.375rem 0.4rem",
                              color: isDarkMode ? "#ffffff" : "#868686",
                            }),
                            menu: (provided) => ({
                              ...provided,
                              color: isDarkMode ? "#ffffff" : "black",
                              backgroundColor: isDarkMode ? "#1f2023" : "white",
                              margin: "0",
                              zIndex: "9999",
                            }),
                            placeholder: (provided) => ({
                              ...provided,
                              color: isDarkMode ? "#ffffff" : "#333333",
                            }),
                            singleValue: (provided) => ({
                              ...provided,
                              color: isDarkMode ? "#ffffff" : "",
                            }),
                            option: (provided, state) => ({
                              ...provided,
                              color: isDarkMode ? "#ffffff" : "black",
                              backgroundColor: state.isHovered
                                ? "#80bdff"
                                : isDarkMode
                                ? "#1f2023"
                                : "white",
                              ":hover": {
                                backgroundColor: isDarkMode
                                  ? "#34DBB4"
                                  : "#34DBB4",
                              },
                            }),
                          }}
                        />
                      </div>
                    )}
                    { yearFilterTypes.includes(filterOption) && (
                      <div style={{ width:  "130px" , display:'flex',alignItems:'center'}}>
                     
                        <Select
                          className="w-100 selectpicker"
                          aria-labelledby="dealership-name-quick"
                          options={getYearOptions(filterOption)}
                          placeholder={
                            translations["dropdown"].select[language]
                          }
                          isSearchable={false}
                          value={
                            getYearOptions(filterOption).find(
                              (option) => option.value === selectedYear
                            ) || {
                              value: "",
                              label: translations["dropdown"].select[language],
                            }
                          }
                          onChange={(selectedOption) => {
                            setSelectedYear(selectedOption.value);
                            const filteredFields = checkedFields.filter(
                              (field) =>
                                field?.value !== "" || field?.value.length > 0
                            );

                            if (filteredFields && filteredFields.length > 0) {
                              const filteredData = filteredFields.reduce(
                                (acc, field) => {
                                  if (field.name === "month") return {...acc , start_date:field.start_date ,end_date:field.end_date};
                                  acc[
                                    field.filterKey ||
                                    (field.name === "fidgi_contest"
                                      ? field.name
                                      : field.type === "dropdown"
                                      ? field.name + "_id"
                                      : field.name)
                                  ] =
                                    field.type === "text"
                                      ? [field.value, field.filterType]
                                      : [field.value];
                                  return acc;
                                },
                                {}
                              );

                              const mergedData = {
                                ...filteredData,
                              };
                              mergedData[getYearFilterKey(filterOption)] =
                                selectedOption.value;

                              getFilteredEvents(mergedData, checkedFields);
                            } else {
                              const data = {
                                type: filterOption,
                                [getYearFilterKey(filterOption)]: selectedOption.value,
                              };
                              const updated = {
                                ...(JSON.parse(localStorage.getItem("eventsFilterPostData")) || {}),
                                type: filterOption,
                                [getYearFilterKey(filterOption)]: selectedOption.value,
                              };
                              localStorage.setItem(
                                "eventsFilterPostData",
                                JSON.stringify(updated)
                              );
                              filterEvents(data);
                            }
                          }}
                          styles={{
                            input: (provided) => ({
                              ...provided,
                              color: isDarkMode ? "#ffffff" : "black",
                            }),
                            control: (provided, state) => ({
                              ...provided,
                              backgroundColor: isDarkMode
                                ? "transparent"
                                : "white",
                              border: state.isFocused
                                ? "1px solid #80bdff"
                                : isDarkMode
                                ? "1px solid #495057"
                                : "1px solid #dee2e6",
                              boxShadow: state.isFocused
                                ? "0 0 0 0.2rem rgba(0, 123, 255, 0.25)"
                                : "none",
                              borderRadius: ".45rem",
                            }),
                            valueContainer: (provided) => ({
                              ...provided,
                              padding: "0.18rem 0.55rem",
                            }),
                            indicatorSeparator: (provided) => ({
                              ...provided,
                              display: "none",
                            }),
                            dropdownIndicator: (provided) => ({
                              ...provided,
                              padding: "0.375rem 0.75rem",
                              color: isDarkMode ? "#ffffff" : "#868686",
                            }),
                            menu: (provided) => ({
                              ...provided,
                              color: isDarkMode ? "#ffffff" : "black",
                              backgroundColor: isDarkMode ? "#1f2023" : "white",
                              margin: "0",
                              zIndex: "9999",
                            }),
                            placeholder: (provided) => ({
                              ...provided,
                              color: isDarkMode ? "#ffffff" : "#333333",
                            }),
                            singleValue: (provided) => ({
                              ...provided,
                              color: isDarkMode ? "#ffffff" : "",
                            }),
                            option: (provided, state) => ({
                              ...provided,
                              color: isDarkMode ? "#ffffff" : "black",
                              backgroundColor: state.isHovered
                                ? "#80bdff"
                                : isDarkMode
                                ? "#1f2023"
                                : "white",
                              ":hover": {
                                backgroundColor: isDarkMode
                                  ? "#34DBB4"
                                  : "#34DBB4",
                              },
                            }),
                          }}
                        />
                            <i
    className="bi bi-x"
    onClick={() => {setFilterOption(filterOptions[0].value); const data = { type: filterOptions[0].value };
                              filterEvents(data)}}
    style={{
     
    
      fontSize: "20px",
      cursor: "pointer",
      color: isDarkMode ? "white" : "black",
      zIndex: 20,
    }}
  ></i>
                      </div>
                    )}
                     <div className="header-btn-mobile header-btn-mobile-last ">
                    {userData &&
                      userData.roles[0].permissions.some(
                        (item) => item.name === "Private Event Store"
                      ) && (
                        <div className="d-grid gap-2" >
                          <button
                            type="button"
                            className="d-flex btn  align-items-center btn btn-outline-secondary gap-1"
                            style={{
                              // backgroundColor:'unset',
                              // borderColor:'black'
                            }}
                            onClick={() => {
                              setDisplayComponent((prev) => {
                                return "create-privateEvent";
                              });
                              window.history.pushState(
                                {
                                  id: "gallery",
                                  randomData: window.Math.random(),
                                },
                                "title",
                                "/event-portal?page=create-privateEvent"
                              );
                            }}
                          >
                            <i className={`bi bi-plus-square `}
                            // ${filterOption !== "cancel" &&
                            //  filterOption !== "previousYear" && "me-1"} 
                            //  `}
                             ></i>{" "}
                            {/* {
                              translations.topAndsidebar.createPrivateEvent[
                                language
                              ]
                            } */}
                            
                           {/* {filterOption !== "cancel" &&
                      filterOption !== "previousYear" && "Add"}  */}
                          </button>
                        </div>
                      )}
                    
                  </div>
                    
                  </div>
                     }
                     <div style={{display:'flex', height:'fit-content'  }}>
                     {isMobile && userType &&
                      !externalUsers.includes(userType) &&
                      userType !== "Animator" && (
                        <>
                          {currentView &&
                            (currentView?.csv === "1" ||
                              currentView?.csv === true ||
                              currentView?.xlsx === "1" ||
                              currentView?.xlsx === true) &&
                            userData.roles[0].permissions.some(
                              (item) => item.name === "Event Data Export"
                            ) && (
                              <div
                                className="btn-group"
                                role="group"
                                aria-label="Basic example"
                              >
                                <div className="btn-group" role="group">
                                  {(currentView?.xlsx === true ||
                                    currentView?.xlsx === "1") && (
                                    <button
                                      type="button"
                                      className="d-flex btn btn-success align-items-center justify-content-center  edit-button gap-1 mx-auto"
                                      style={{
                                        width: "100%",
                                        maxWidth: "150px",
                                        whiteSpace: "nowrap",
                                        textOverflow: "ellipsis",
                                        overflow: "hidden",
                                        borderTopRightRadius:'0px',
                                        borderBottomRightRadius:'0px'
                                      }}
                                      onClick={() => {
                                        exportData("xlsx");
                                      }}
                                    >
                                      <i className={"bi bi-filetype-xlsx"}></i>{" "}
                                    </button>
                                  )}
                                  {/* {(currentView?.csv === true ||
                                    currentView?.csv === "1") && (
                                    <button
                                      type="button"
                                      className="d-flex btn btn-danger align-items-center justify-content-center edit-button gap-1 mx-auto"
                                      style={{
                                        width: "100%",
                                        maxWidth: "150px",
                                        whiteSpace: "nowrap",
                                        textOverflow: "ellipsis",
                                        overflow: "hidden",
                                      }}
                                      onClick={() => {
                                        exportData("csv");
                                      }}
                                    >
                                      <i className={"bi bi-filetype-csv"}></i>{" "}
                                    </button>
                                  )} */}
                                </div>
                              </div>
                            )}
                        </>
                      )}
                     
                    {userType &&
                      userType !== "Employee" &&
                      userType !== "Manager" && (
                        <div
                          className="btn-group"
                          role="group"
                          aria-label="Basic example"
                        >
                          <button
                            id=""
                            type="button"
                            className="btn btn-primary admin-btn"
                            data-bs-target="#filtersidebar"
                            data-bs-toggle="offcanvas"
                            aria-bs-controls="offcanvasmain"
                            style={{
                              borderTopLeftRadius:isMobile && '0px',
                              borderBottomLeftRadius:isMobile && '0px'
                            }}
                          >
                            <i className="bi bi-search"></i>{" "}
                          </button>
                        </div>
                      )}
                      </div>
                  </div>
                </div>
                {/* {isMobile && (
                  <>
                  <div style={{gap:'5px'}} className=" d-flex header-btn-mobile-last">
                    {userType && internalUsers.includes(userType) && (
                      <div className="" style={{ width: "160px" }}>
                        <Select
                          className="w-100 selectpicker"
                          aria-labelledby="dealership-name-quick"
                          options={filterOptions}
                          placeholder={
                            translations["dropdown"].select[language]
                          }
                          isSearchable={false}
                          value={
                            (filterOptions &&
                              filterOptions.length > 0 &&
                              filterOptions.find(
                                (option) => option.value === filterOption
                              )) || {
                              value: "",
                              label: translations["dropdown"].select[language],
                            }
                          }
                          onChange={(selectedOption) => {
                            setFilterOption(selectedOption.value);
                            setSelectedYear("");
                            const filteredFields = checkedFields.filter(
                              (field) =>
                                field?.value !== "" || field?.value.length > 0
                            );

                            if (filteredFields && filteredFields.length > 0) {
                              const filteredData = filteredFields.reduce(
                                (acc, field) => {
                                  acc[
                                    field.filterKey ||
                                    (field.name === "fidgi_contest"
                                      ? field.name
                                      : field.type === "dropdown"
                                      ? field.name + "_id"
                                      : field.name)
                                  ] =
                                    field.type === "text"
                                      ? [field.value, field.filterType]
                                      : [field.value];
                                  return acc;
                                },
                                {}
                              );
                              const mergedData = {
                                ...filteredData,
                              };

                              mergedData.type = selectedOption.value;

                              getFilteredEvents(mergedData, checkedFields);
                            } else {
                              const data = { type: selectedOption.value };
                              filterEvents(data);
                            }
                          }}
                          styles={{
                            input: (provided) => ({
                              ...provided,
                              color: isDarkMode ? "#ffffff" : "black",
                            }),
                            control: (provided, state) => ({
                              ...provided,
                              backgroundColor: isDarkMode
                                ? "transparent"
                                : "white",
                              border: state.isFocused
                                ? "1px solid #80bdff"
                                : isDarkMode
                                ? "1px solid #495057"
                                : "1px solid #dee2e6",
                              boxShadow: state.isFocused
                                ? "0 0 0 0.2rem rgba(0, 123, 255, 0.25)"
                                : "none",
                              borderRadius: ".45rem",
                            }),
                            valueContainer: (provided) => ({
                              ...provided,
                              padding: "0.18rem 0.55rem",
                            }),
                            indicatorSeparator: (provided) => ({
                              ...provided,
                              display: "none",
                            }),
                            dropdownIndicator: (provided) => ({
                              ...provided,
                              padding: "0.375rem 0.75rem",
                              color: isDarkMode ? "#ffffff" : "#868686",
                            }),
                            menu: (provided) => ({
                              ...provided,
                              color: isDarkMode ? "#ffffff" : "black",
                              backgroundColor: isDarkMode ? "#1f2023" : "white",
                              margin: "0",
                              zIndex: "9999",
                            }),
                            placeholder: (provided) => ({
                              ...provided,
                              color: isDarkMode ? "#ffffff" : "#333333",
                            }),
                            singleValue: (provided) => ({
                              ...provided,
                              color: isDarkMode ? "#ffffff" : "",
                            }),
                            option: (provided, state) => ({
                              ...provided,
                              color: isDarkMode ? "#ffffff" : "black",
                              backgroundColor: state.isHovered
                                ? "#80bdff"
                                : isDarkMode
                                ? "#1f2023"
                                : "white",
                              ":hover": {
                                backgroundColor: isDarkMode
                                  ? "#34DBB4"
                                  : "#34DBB4",
                              },
                            }),
                          }}
                        />
                      </div>
                    )}
                    {  (filterOption === "cancel" ||
                      filterOption === "previousYear") && (
                      <div style={{ width: "200px" }}>
                        <Select
                          className="w-100 selectpicker"
                          aria-labelledby="dealership-name-quick"
                          options={
                            filterOption === "previousYear"
                              ? Array.from(
                                  { length: 5 },
                                  (_, i) => new Date().getFullYear() - 1 - i
                                ).map((item) => {
                                  return { label: item, value: item };
                                })
                              : Array.from(
                                  { length: 5 },
                                  (_, i) => new Date().getFullYear() - i
                                ).map((item) => {
                                  return { label: item, value: item };
                                })
                          }
                          placeholder={
                            translations["dropdown"].select[language]
                          }
                          isSearchable={false}
                          value={
                            (filterOption === "previousYear"
                              ? Array.from({ length: 5 }, (_, i) => {
                                  const year = new Date().getFullYear() - 1 - i;
                                  return { label: year, value: year };
                                })
                              : Array.from({ length: 5 }, (_, i) => {
                                  const year = new Date().getFullYear() - i;
                                  return { label: year, value: year };
                                })
                            ).find(
                              (option) => option.value === selectedYear
                            ) || {
                              value: "",
                              label: translations["dropdown"].select[language],
                            }
                          }
                          onChange={(selectedOption) => {
                            setSelectedYear(selectedOption.value);
                            const filteredFields = checkedFields.filter(
                              (field) =>
                                field?.value !== "" || field?.value.length > 0
                            );

                            if (filteredFields && filteredFields.length > 0) {
                              const filteredData = filteredFields.reduce(
                                (acc, field) => {
                                  acc[
                                    field.filterKey ||
                                    (field.name === "fidgi_contest"
                                      ? field.name
                                      : field.type === "dropdown"
                                      ? field.name + "_id"
                                      : field.name)
                                  ] =
                                    field.type === "text"
                                      ? [field.value, field.filterType]
                                      : [field.value];
                                  return acc;
                                },
                                {}
                              );

                              const mergedData = {
                                ...filteredData,
                              };
                              if (filterOption === "cancel")
                                mergedData.cancelYear = selectedOption.value;
                              else
                                mergedData.previousYear = selectedOption.value;

                              getFilteredEvents(mergedData, checkedFields);
                            } else {
                              const data = {
                                type: filterOption,
                                [filterOption === "cancel"
                                  ? "cancelYear"
                                  : "previousYear"]: selectedOption.value,
                              };
                              filterEvents(data);
                            }
                          }}
                          styles={{
                            input: (provided) => ({
                              ...provided,
                              color: isDarkMode ? "#ffffff" : "black",
                            }),
                            control: (provided, state) => ({
                              ...provided,
                              backgroundColor: isDarkMode
                                ? "transparent"
                                : "white",
                              border: state.isFocused
                                ? "1px solid #80bdff"
                                : isDarkMode
                                ? "1px solid #495057"
                                : "1px solid #dee2e6",
                              boxShadow: state.isFocused
                                ? "0 0 0 0.2rem rgba(0, 123, 255, 0.25)"
                                : "none",
                              borderRadius: ".45rem",
                            }),
                            valueContainer: (provided) => ({
                              ...provided,
                              padding: "0.18rem 0.55rem",
                            }),
                            indicatorSeparator: (provided) => ({
                              ...provided,
                              display: "none",
                            }),
                            dropdownIndicator: (provided) => ({
                              ...provided,
                              padding: "0.375rem 0.75rem",
                              color: isDarkMode ? "#ffffff" : "#868686",
                            }),
                            menu: (provided) => ({
                              ...provided,
                              color: isDarkMode ? "#ffffff" : "black",
                              backgroundColor: isDarkMode ? "#1f2023" : "white",
                              margin: "0",
                              zIndex: "9999",
                            }),
                            placeholder: (provided) => ({
                              ...provided,
                              color: isDarkMode ? "#ffffff" : "#333333",
                            }),
                            singleValue: (provided) => ({
                              ...provided,
                              color: isDarkMode ? "#ffffff" : "",
                            }),
                            option: (provided, state) => ({
                              ...provided,
                              color: isDarkMode ? "#ffffff" : "black",
                              backgroundColor: state.isHovered
                                ? "#80bdff"
                                : isDarkMode
                                ? "#1f2023"
                                : "white",
                              ":hover": {
                                backgroundColor: isDarkMode
                                  ? "#34DBB4"
                                  : "#34DBB4",
                              },
                            }),
                          }}
                        />
                      </div>
                    )}
                    {userType &&
                      !externalUsers.includes(userType) &&
                      userType !== "Animator" && (
                        <>
                          {currentView &&
                            (currentView?.csv === "1" ||
                              currentView?.csv === true ||
                              currentView?.xlsx === "1" ||
                              currentView?.xlsx === true) &&
                            userData.roles[0].permissions.some(
                              (item) => item.name === "Event Data Export"
                            ) && (
                              <div
                                className="btn-group"
                                role="group"
                                aria-label="Basic example"
                              >
                                <div className="btn-group" role="group">
                                  {(currentView?.xlsx === true ||
                                    currentView?.xlsx === "1") && (
                                    <button
                                      type="button"
                                      className="d-flex btn btn-primary align-items-center justify-content-center admin-btn edit-button gap-1 mx-auto"
                                      style={{
                                        width: "100%",
                                        maxWidth: "150px",
                                        whiteSpace: "nowrap",
                                        textOverflow: "ellipsis",
                                        overflow: "hidden",
                                      }}
                                      onClick={() => {
                                        exportData("xlsx");
                                      }}
                                    >
                                      <i className={"bi bi-filetype-xlsx"}></i>{" "}
                                    </button>
                                  )}
                                  {(currentView?.csv === true ||
                                    currentView?.csv === "1") && (
                                    <button
                                      type="button"
                                      className="d-flex btn btn-danger align-items-center justify-content-center edit-button gap-1 mx-auto"
                                      style={{
                                        width: "100%",
                                        maxWidth: "150px",
                                        whiteSpace: "nowrap",
                                        textOverflow: "ellipsis",
                                        overflow: "hidden",
                                      }}
                                      onClick={() => {
                                        exportData("csv");
                                      }}
                                    >
                                      <i className={"bi bi-filetype-csv"}></i>{" "}
                                    </button>
                                  )}
                                </div>
                              </div>
                            )}
                        </>
                      )}
                  </div>
                  <div className="header-btn-mobile header-btn-mobile-last ">
                    {userData &&
                      userData.roles[0].permissions.some(
                        (item) => item.name === "Private Event Store"
                      ) && (
                        <div className="d-grid gap-2" >
                          <button
                            type="button"
                            className="d-flex btn btn-primary align-items-center admin-btn gap-1"
                            onClick={() => {
                              setDisplayComponent((prev) => {
                                return "create-privateEvent";
                              });
                              window.history.pushState(
                                {
                                  id: "gallery",
                                  randomData: window.Math.random(),
                                },
                                "title",
                                "/event-portal?page=create-privateEvent"
                              );
                            }}
                          >
                            <i className="bi bi-calendar2-event"></i>{" "}
                            {
                              translations.topAndsidebar.createPrivateEvent[
                                language
                              ]
                            }
                          </button>
                        </div>
                      )}
                    {userData &&
                      userData.roles[0].permissions.some(
                        (item) => item.name === "Private Event Store"
                      ) && (
                        <div
                          className="btn-group"
                          role="group"
                          aria-label="Basic example"
                        >
                          <button
                            id="quickAdd"
                            type="submit"
                            className="btn btn-primary admin-btn"
                            data-bs-toggle="modal"
                            data-bs-target="#modalQuickAdd"
                            fdprocessedid="2rud2c"
                          >
                            <i className="bi bi-speedometer"></i>{" "}
                            {translations.topAndsidebar.quickCreation[language]}
                          </button>
                        </div>
                      )}
                  </div>
                  
                  </>
                )} */}
              </div>
              <div className="headersec row">
                <div className="my-3 col-12">
                  <div className="d-flex flex-wrap gap-3 align-items-center">
                    {eventsFilterData &&
                      eventsFilterData?.length > 0 &&
                      eventsFilterData?.map((item, index) => (
                        <div
                          key={index}
                          className="d-flex py-1 px-2 gap-2 align-items-center justify-content-between custom-tooltip"
                          style={{
                            border: isDarkMode
                              ? "1px solid #495057"
                              : "1px solid #dee2e6",
                            borderRadius: "0.275rem",
                            minWidth: "150px",
                            maxWidth: "250px",
                          }}
                          data-bs-toggle="tooltip"
                          data-bs-html="true"
                          title={`${item?.content}: ${
                            Array.isArray(item?.value)
                              ? item.value
                                  .map((id) => {
                                    // pick the correct options list
                                    if (item.name === "month") {
            // For arrays of month indexes, find the label in monthsList
            return monthsList[id]?.label || id;
          }
                                    let options;
                                    switch (item.name) {
                                      case "dealership":
                                        options = dealerOptions;
                                        break;
                                      case "group":
                                        options = groupOptions;
                                        break;
                                      case "project_manager":
                                        options = managers;
                                        break;
                                      case "sales_rep":
                                        options = repOptions2;
                                        break;
                                      case "package":
                                        options = packageOptions;
                                        break;
                                      case "no_show_agent":
                                      case "confirmation_agent":
                                        options = agentOptions;
                                        break;
                                      default:
                                        options = animatorOptions;
                                    }

                                    // ensure options is always an array
                                    const arr = Array.isArray(options)
                                      ? options
                                      : [];
                                    const match = arr.find(
                                      (option) =>
                                        option.value?.toString() ===
                                        id?.toString()
                                    );
                                    console.log("mathcsdf",match,arr,options)

                                    return match?.label || id;
                                  })
                                  .join(", ")
                                  : item.name === "month"
      ? item.label || item.value
    : item?.value
                              
                          }`}
                        >
                          <span className="custom-tooltiptext">
                            {`${item?.content} : ${
                              Array.isArray(item?.value)
                                ? item.value
                                    .map((id) => {
                                       if (item.name === "month") {
            // For arrays of month indexes, find the label in monthsList
            return monthsList[id]?.label || id;
          }
                                      let options = item.options;
                                      if (!options) {
                                      switch (item.name) {
                                        case "dealership":
                                          options = dealerOptions;
                                          break;
                                        case "group":
                                          options = groupOptions;
                                          break;
                                        case "project_manager":
                                          options = managers;
                                          break;
                                        case "sales_rep":
                                          options = repOptions2;
                                          break;
                                        case "package":
                                          options = packageOptions;
                                          break;
                                        case "no_show_agent":
                                        case "confirmation_agent":
                                          options = agentOptions;
                                          break;
                                        default:
                                          options = animatorOptions;
                                      }
                                      }

                                      const arr = Array.isArray(options)
                                        ? options
                                        : [];
                                      const match = arr.find(
                                        (option) =>
                                          option.value?.toString() ===
                                          id?.toString()
                                      );

                                      return match?.label || id;
                                    })
                                    .join(", ")
                                    : item.name === "month"
      ? item.label || item.value
                                : item?.value
                            }`}
                          </span>

                          <div
                            className="d-flex align-items-center gap-2 justify-content-start"
                            style={{ width: "90%" }}
                          >
                            {/* Content */}
                            <div className="text-truncate">
                              <span>
                                {item?.content}{" "}
                                {translations.commonWords.is[language]}{" "}
                              </span>
                            </div>
                            {/* Value */}
                            <div
                              className="text-truncate"
                              style={{
                                maxWidth: "60%",
                                overflow: "hidden",
                                whiteSpace: "nowrap",
                                textOverflow: "ellipsis",
                              }}
                            >
                              {Array.isArray(item?.value)
                                ? item.value
                                    .map((id) => {
                                       if (item.name === "month") {
            // For arrays of month indexes, find the label in monthsList
            return monthsList[id]?.label || id;
          }
                                      let options;
                                      switch (item.name) {
                                        case "dealership":
                                          options = dealerOptions;
                                          break;
                                        case "group":
                                          options = groupOptions;
                                          break;
                                        case "project_manager":
                                          options = managers;
                                          break;
                                        case "sales_rep":
                                          options = repOptions2;
                                          break;
                                        case "package":
                                          options = packageOptions;
                                          break;
                                        case "no_show_agent":
                                        case "confirmation_agent":
                                          options = agentOptions;
                                          break;
                                        default:
                                          options = animatorOptions;
                                      }

                                      const arr = Array.isArray(options)
                                        ? options
                                        : [];
                                      const match = arr.find(
                                        (option) =>
                                          option.value?.toString() ===
                                          id?.toString()
                                      );

                                      return match?.label || id;
                                    })
                                    .join(", ")
                                    : item.name === "month"
      ? item.label || item.value
                                : item?.value}
                            </div>
                          </div>
                          <span
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              // let updatedCheckedFields = checkedFields.filter(
                              //   (field) => field.name !== item.name
                              // );
                              // console.log("lkdsjfklasjdf",updatedCheckedFields,checkedFields,item,filtersData)
                              let updatedCheckedFields = checkedFields.filter(
                                (field) => field.name !== item.name
                              );
                              if (item.name === "date_range") {
                                updatedCheckedFields =
                                  updatedCheckedFields.filter(
                                    (field) =>
                                      field.name !== "start_date" &&
                                      field.name !== "end_date"
                                  );
                              }
                              if (item.name === "month") {
                                updatedCheckedFields =
                                  updatedCheckedFields.filter(
                                    (field) =>
                                      field.name !== "start_date" &&
                                      field.name !== "end_date"
                                  );
                              }
                              setCheckedFields(updatedCheckedFields);

                              // const keysToRemove = [item.name];
                              const keysToRemove =
                                item.type === "date_range" || item.name == "month"
                                  ? ["start_date", "end_date"]
                                  : [
                                      item.filterKey ||
                                      (item.name === "fidgi_contest"
                                        ? item.name
                                        : item.type === "dropdown"
                                        ? item.name + "_id"
                                        : item.name),
                                    ];
                              const updatedFiltersData =  Object.fromEntries(
                                Object.entries(filtersData).filter(
                                  ([key]) => !keysToRemove.includes(key)
                                )
                              );
                              // console.log("lkdsjfklasjdf>>>",keysToRemove,updatedFiltersData,filtersData,updatedCheckedFields)

                              setFiltersData(updatedFiltersData);
                              getFilteredEvents(
                                updatedFiltersData,
                                updatedCheckedFields
                              );
                            }}
                          >
                            <i
                              className="bi bi-x-circle-fill"
                              style={{
                                color: isDarkMode ? "#495057" : "#868686",
                              }}
                            ></i>
                          </span>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
              {/* <div
                              className="row align-items-center"
                              style={{ minHeight: "44px" }}
                            >
                              <div className="col-3">
                                {selectedWeeks && selectedWeeks.length > 0 && (
                                  <button
                                    type="button"
                                    className="client-btn d-flex align-items-center gap-2"
                                    onClick={exportSelecedData}
                                  >
                                    <i className="bi bi-upload"></i>
                                    {translations.commonWords.export[language]}{" "}
                                  </button>
                                )}
                              </div>
                            </div> */}
              <DndContext
                sensors={sensors}
                collisionDetection={closestCenter}
                onDragEnd={moveColumn}
              >
                <SortableContext
                  items={
                    currentView &&
                    currentView?.columns?.slice(1, -2)?.map((col) => col.id)
                  }
                  strategy={horizontalListSortingStrategy}
                  disabled={
                    userType === "Animator" ||
                    (userType && externalUsers.includes(userType))
                      ? true
                      : false
                  }
                >
                  <div
                    className=""
                    ref={containerRef}
                    style={{
                      // display: "flex",
                      // flexDirection: "column",
                      overflowX: "auto",
                      // padding: "20px",
                      maxWidth: "100%",
                      whiteSpace: "nowrap",
                      // maxHeight: "calc(100vh - 200px)",
                      maxHeight: `calc(100vh - ${
                        eventsFilterData?.length > 0 ? isMobile ? "240px" : "240px" : isMobile ? "200px" : "200px"
                      } )`,
                    }}
                  >
                    <div ref={topMarkerRef} style={{ height: "1px" }} />
                    <table
                      className="align-content-center responsive-table"
                      style={{
                        // width: "max-content",
                        minWidth: "100%",
                        borderCollapse: "collapse",
                        tableLayout: "fixed",
                      }}
                    >
                      <thead
                        style={{
                          position: "sticky",
                          top: "-1px",
                          zIndex: "999",
                        }}
                      >
                        <tr
                          style={{
                            background: isDarkMode ? "#1b1f22" : "#ffffff",
                          }}
                        >
                          {/* First Column */}

                          {(currentView?.csv == "1" ||
                            currentView?.xlsx == "1") &&
                            userData.roles[0].permissions.some(
                              (item) => item.name === "Event Data Export"
                            ) && (
                              <th
                                scope="col"
                                className={`${isDarkMode ? "darkthead" : ""}`}
                                style={{ textAlign: "center" }}
                              >
                                <input
                                  type="checkbox"
                                  className=""
                                  checked={selectAll}
                                  onChange={handleSelectAllChange}
                                  style={{ cursor: "pointer" }}
                                />
                              </th>
                            )}

                          <th
                            key={currentView?.columns[0].id}
                            scope="col"
                            className={`${isDarkMode ? "darkthead" : ""} ${
                              currentView?.columns[0]?.className || ""
                            }`}
                            style={{
                              ...currentView?.columns[0].style,
                              zIndex: "1",
                              width: `${currentView?.columns[0].width}px`,
                              background: isDarkMode ? "#1b1f22" : "#ffffff",
                            }}
                            colSpan={currentView?.columns[0].colSpan}
                          >
                            {FindPath(
                              currentView?.columns[0].content,
                              language
                            )}
                          </th>

                          {/* Draggable Columns (Excluding First & Last Two) */}
                          {currentView?.columns
                            .slice(1, -1)
                            .filter((header) => header.renderInView !== false)
                            .map((header) =>
                              header.showIf !== false ? (
                                <DraggableHeaderCell
                                  key={header.id}
                                  column={header}
                                  isDarkMode={isDarkMode}
                                  onResize={handleResize}
                                  type="event"
                                />
                              ) : null
                            )}

                          {/* Last Two Columns */}
                          <>
                            {/* <th
                            scope="col"
                            className={`${isDarkMode ? "darkthead" : ""} ${
                              currentView.columns[
                                currentView.columns.length - 2
                              ]?.className || ""
                            }`}
                            style={{
                              ...currentView.columns[
                                currentView.columns.length - 2
                              ]?.style,
                              width: `${
                                currentView.columns[
                                  currentView.columns.length - 2
                                ]?.width
                              }px`,
                              background: isDarkMode ? "#1b1f22" : "#ffffff",
                            }}
                            colSpan={
                              currentView.columns[
                                currentView.columns.length - 2
                              ]?.colSpan
                            }
                          >
                            {
                              currentView.columns[
                                currentView.columns.length - 2
                              ]?.content
                            }
                          </th> */}
                          </>
                          {shouldShowActions && (
                            <th
                              scope="col"
                              className={`${isDarkMode ? "darkthead" : ""} ${
                                currentView?.columns[
                                  currentView?.columns.length - 1
                                ]?.className || ""
                              }`}
                              style={{
                                ...currentView?.columns[
                                  currentView?.columns.length - 1
                                ]?.style,
                                width: `${
                                  currentView?.columns[
                                    currentView?.columns.length - 1
                                  ]?.width
                                }px`,
                                background: isDarkMode ? "#343a3f" : "#ffffff",
                              }}
                              colSpan={
                                currentView?.columns[
                                  currentView?.columns.length - 1
                                ]?.colSpan 
                              }
                            >
                              {
                                currentView?.columns[
                                  currentView?.columns.length - 1
                                ]?.content
                              }
                            </th>
                          )}
                        </tr>
                      </thead>

                      <tbody className="event-table" id="tbody">
                        {events && Object.keys(events).length > 0 ? (
                          Object.keys(events).map((key, accordionIndex) => {
                            const eventList = events[key];
                            return (
                              <React.Fragment
                                key={accordionIndex}
                                style={{
                                  marginBottom: "1px",
                                }}
                              >
                                {eventList.map((event, index) => {
                                  const isLastElement =
                                    index === eventList.length - 1;
                                  return (
                                    <>
                                      <tr
                                        key={index}
                                        className="align-middle"
                                        style={{
                                          position: "relative",
                                          zIndex: 10 + eventList.length - index,

                                          background: `${
                                            clickedRow?.key === key &&
                                            clickedRow?.index === index
                                              ? "yellow"
                                              : userType !== "Employee" &&
                                                userType !== "Manager" &&
                                                event?.call_campaign == "early"
                                              ? isDarkMode
                                                ? "#327DDA"
                                                : "rgb(108 174 255)"
                                              : index % 2 === 0
                                              ? isDarkMode
                                                ? "#2B3035"
                                                : "#F8F9FA"
                                              : isDarkMode
                                              ? "#343A3F"
                                              : "#E9ECEF"
                                          }`,
                                        }}
                                        onClick={() => {
                                          setClickedRow((prev) =>
                                            prev?.key === key &&
                                            prev?.index === index
                                              ? null
                                              : { key, index }
                                          );
                                        }}
                                      >
                                        {index === 0 &&
                                          (currentView?.csv == "1" ||
                                            currentView?.xlsx == "1") &&
                                          userData.roles[0].permissions.some(
                                            (item) =>
                                              item.name === "Event Data Export"
                                          ) && (
                                            <td
                                              className="fw-bold text-center first-col"
                                              style={{
                                                borderBottom:
                                                  "1px solid #dee2e6",
                                                backgroundColor: "#ced4da66",
                                                position: "-webkit-sticky",
                                                position: "sticky",
                                                left: "0px",

                                                zIndex: "99",
                                              }}
                                              rowSpan={eventList.length}
                                            >
                                              <input
                                                type="checkbox"
                                                className=""
                                                checked={selectedWeeks.includes(
                                                  key
                                                )}
                                                onChange={() =>
                                                  handleCheckboxChange(key)
                                                }
                                                style={{ cursor: "pointer" }}
                                              />
                                            </td>
                                          )}
                                        {!isMobile && index === 0 && (
                                          <td
                                            style={{
                                              borderBottom: "1px solid #dee2e6",
                                              backgroundColor:
                                                "rgba(67, 86, 116, 1)",
                                              position: "-webkit-sticky",
                                              position: "sticky",
                                              left: "0px",
                                              width: "57px",
                                              zIndex: "99",
                                              // borderRight:'1px solid #dee2e6'
                                            }}
                                            rowSpan={eventList.length}
                                            className="text-center dlrname fw-bold"
                                            id="weekCol"
                                          >
                                            {key.split(" ")[1]}
                                            {/* {event?.week} */}
                                          </td>
                                        )}
                                        {/* {isMobile && (
                                          <div>

                                          
                                          <span
                                            style={{
                                              // borderBottom: "1px solid #dee2e6",
                                              backgroundColor:
                                                "rgba(67, 86, 116, 1)",
                                              // position: "-webkit-sticky",
                                              // position: "sticky",
                                              // left: "0px",
                                              width: "100px",
                                              zIndex: "99",
                                              borderRadius:'50px',
                                              padding:'5px 10px',
                                              // borderRight:'1px solid #dee2e6'
                                            }}
                                            rowSpan={eventList.length}
                                            className="text-center dlrname fw-bold"
                                            id="weekCol"
                                          >
                                            <span>Week</span>{" "}<span>{key.split(" ")[1]}</span>
                                          </span>
                                          </div>
                                        )} */}

                                        {/* Render the columns dynamically */}
                                        {/* {console.log("askljfklasjdf", event)} */}
                                        {currentView &&
                                          currentView?.columns &&
                                          currentView?.columns
                                            .slice(1, -1)
                                            .filter(
                                              (header) =>
                                                header.renderInView !== false
                                            )
                                            .map((col, indexkey) => {
                                              if (col.showIf === false)
                                                return null; // Skip columns with showIf: false

                                              const columnKey = col.id;

                                              return isMobile ? (
                                                <>
                                                  {indexkey === 0 && (
                                                    <div className="d-flex justify-content-between">
                                                      <div
                                                        className="d-flex dlrname fw-bold"
                                                        style={{
                                                          gap: "6px",
                                                          height: "fit-content",
                                                          width: "80%",
                                                          flexWrap: "wrap",
                                                        }}
                                                      >
                                                        <span
                                                          style={{
                                                            // borderBottom: "1px solid #dee2e6",
                                                            backgroundColor:
                                                              "rgba(67, 86, 116, 1) !important",
                                                            // position: "-webkit-sticky",
                                                            // position: "sticky",
                                                            // left: "0px",
                                                            // width: "90px",
                                                            zIndex: "99",
                                                            borderRadius:
                                                              "50px",
                                                            padding: "0px 10px",
                                                            // borderRight:'1px solid #dee2e6'
                                                            fontSize: "0.8rem",
                                                          }}
                                                          // rowSpan={eventList.length}

                                                          className="text-center dlrname fw-semibold "
                                                          id="weekCol"
                                                        >
                                                          <span> {FindPath(
                              currentView?.columns[0].content,
                              language
                            )}</span>{" "}
                                                          <span>
                                                            {/* {event?.week} */}
                                                            {key.split(" ")[1]}
                                                          </span>
                                                        </span>

                                                        {event?.dealership
                                                          ?.name && (
                                                          <span
                                                            style={{
                                                              backgroundColor:
                                                                "#33DBB4",
                                                              // borderBottom: "1px solid #dee2e6",

                                                              // position: "-webkit-sticky",
                                                              // position: "sticky",
                                                              // left: "0px",
                                                              // width: "100px",
                                                              // zIndex: "99",
                                                              borderRadius:
                                                                "50px",

                                                              // borderRight:'1px solid #dee2e6'
                                                              padding:
                                                                "0px 10px",
                                                              fontSize:
                                                                "0.8rem",
                                                            }}
                                                            // rowSpan={eventList.length}
                                                            className="text-center dlrname fw-semibold"
                                                          >
                                                            <span>
                                                              {
                                                                event?.dealership?.name.split(
                                                                  " "
                                                                )[0]
                                                              }
                                                            </span>
                                                          </span>
                                                        )}

                                                        {event?.dealership
                                                          ?.group?.name && (
                                                          <span
                                                            style={{
                                                              // borderBottom: "1px solid #dee2e6",
                                                              backgroundColor:
                                                                "#33DBB4",
                                                              // position: "-webkit-sticky",
                                                              // position: "sticky",
                                                              // left: "0px",

                                                              zIndex: "99",
                                                              borderRadius:
                                                                "50px",
                                                              padding:
                                                                "0px 10px",
                                                              fontSize:
                                                                "0.8rem",
                                                              // borderRight:'1px solid #dee2e6'
                                                            }}
                                                            // rowSpan={eventList.length}
                                                            className="text-center dlrname fw-semibold"
                                                          >
                                                            <span>
                                                              {
                                                                event?.dealership?.group?.name.split(
                                                                  " "
                                                                )[0]
                                                              }
                                                            </span>
                                                          </span>
                                                        )}
                                                      </div>
                                                      <div>
                                                        {event?.amount && (
                                                          <p
                                                            className="fw-bold fs-6"
                                                            style={{
                                                              color:
                                                                clickedRow?.key ===
                                                                  key &&
                                                                clickedRow?.index ===
                                                                  index &&
                                                                "black",
                                                            }}
                                                          >
                                                            ${event?.amount}
                                                          </p>
                                                        )}
                                                        {event?.invoice && (
                                                          <>
                                                            <p
                                                              className={`${
                                                                isDarkMode
                                                                  ? "text-white"
                                                                  : "text-muted"
                                                              } small `}
                                                              style={{
                                                                color:
                                                                  clickedRow?.key ===
                                                                    key &&
                                                                  clickedRow?.index ===
                                                                    index &&
                                                                  "black",
                                                              }}
                                                            >
                                                              {/* Invoice */}
                                                              {translations.forms.formFields.invoice[language]}
                                                              
                                                            </p>
                                                            <p
                                                              className={`${
                                                                isDarkMode
                                                                  ? "text-white"
                                                                  : "text-muted"
                                                              } small `}
                                                              style={{
                                                                color:
                                                                  clickedRow?.key ===
                                                                    key &&
                                                                  clickedRow?.index ===
                                                                    index &&
                                                                  "black",
                                                              }}
                                                            >
                                                              #{event?.invoice}
                                                            </p>
                                                          </>
                                                        )}
                                                      </div>
                                                    </div>
                                                  )}
                                                  {[
                                                    "carton",
                                                    "web",
                                                    "banner",
                                                    "news_letter",
                                                    "facebook",
                                                    "ad_words",
                                                    "sms",
                                                    "mailing",
                                                    "group",
                                                    "package",
                                                    "end_date",
                                                    "clients",
                                                    "inactive",
                                                    "conquest",
                                                    "amount",
                                                    
                                                  ].includes(
                                                    columnKey
                                                  ) ? null : (
                                                    <td
                                                      // id={columnKey}
                                                      id={
                                                        clickedRow?.key ===
                                                          key &&
                                                        clickedRow?.index ===
                                                          index
                                                          ? "highlight-text"
                                                          : columnKey
                                                      }
                                                      key={col.id}
                                                      style={{
                                                        // borderRight:'1px solid #dee2e6',
                                                        //  width: `${col.width}px`,
                                                        minWidth: `${col.width}px`,
                                                        // maxWidth: `${col.width + (col.id === "animator" ? 250 : 150)}px`,
                                                        // width:'100%',
                                                        width: `${
                                                          columnKey == "nom_vp"
                                                            ? "80%"
                                                            : "100%"
                                                        }`,
                                                        marginTop: `${
                                                          columnKey == "nom_vp"
                                                            ? event?.invoice
                                                              ? "-30px"
                                                              : "0px"
                                                            : "0px"
                                                        }`,
                                                        // overflow: "hidden",
                                                        // textOverflow: "ellipsis",
                                                        whiteSpace: "normal",
                                                        // borderRight: "1px solid",

                                                        background: `${
                                                          clickedRow?.key ===
                                                            key &&
                                                          clickedRow?.index ===
                                                            index
                                                            ? "yellow"
                                                            : userType !==
                                                                "Employee" &&
                                                              userType !==
                                                                "Manager" &&
                                                              event?.call_campaign ==
                                                                "early"
                                                            ? isDarkMode
                                                              ? "#327DDA"
                                                              : "rgb(108 174 255)"
                                                            : index % 2 === 0
                                                            ? isDarkMode
                                                              ? "#2B3035"
                                                              : "#F8F9FA"
                                                            : isDarkMode
                                                            ? "#343A3F"
                                                            : "#E9ECEF"
                                                        }`,
                                                        // borderBottom: isLastElement
                                                        //   ? "1px solid #dee2e6"
                                                        //   : "0px solid",
                                                        borderBottom: "none",
                                                        ...col.style, // Apply column-specific styles
                                                      }}
                                                      className={`dlrname  ${
                                                        columnKey ==
                                                          "dealership" &&
                                                        "remove-space-from-top"
                                                      }`}
                                                      onClick={
                                                        columnKey ===
                                                        "dealership"
                                                          ? () => {
                                                              if (
                                                                userData &&
                                                                userData.roles[0].permissions.some(
                                                                  (item) =>
                                                                    item.name ===
                                                                    "Edit Dealership"
                                                                )
                                                              ) {
                                                                getDealershipData(
                                                                  event
                                                                    ?.dealership
                                                                    ?.id
                                                                );
                                                              }
                                                            }
                                                          : undefined
                                                      }
                                                    >
                                                      {
                                                        columnKey ===
                                                        "animator" ? (
                                                          <div
                                                            className="d-flex align-items-center"
                                                            style={{
                                                              minWidth: "186px",
                                                              width: "100%",
                                                              display: "flex",
                                                              justifyContent:
                                                                "space-between",
                                                              // marginRight: '30px',
                                                              // paddingLeft: '15px'
                                                            }}
                                                          >
                                                            <p
                                                              style={{
                                                                fontWeight:
                                                                  "700",
                                                                width: "50%",
                                                                fontSize:
                                                                  ".875em",
                                                              }}
                                                              className={`${
                                                                isDarkMode
                                                                  ? "text-white"
                                                                  : "text-muted"
                                                              } `}
                                                            >
                                                              {/* {col?.content} */}
                                                              {FindPathForMobile(col?.content, language)}
                                                            </p>

                                                            {/* <div
                                                          style={{
                                                            width: "10px",
                                                            height: "10px",
                                                            backgroundColor:
                                                              event?.animator_id?.toString() ===
                                                                "1.1"
                                                                ? "red"
                                                                : event?.animator_id?.toString() ===
                                                                  "1.2"
                                                                  ? "orange"
                                                                  : "",
                                                            borderRadius: "50%",
                                                            marginRight: "8px",
                                                          }}
                                                        ></div> */}
                                                            <span
                                                              style={{
                                                                width: "60%",
                                                              }}
                                                            >
                                                              <Select
                                                                className=" w-100 selectpicker"
                                                                aria-labelledby="dealership-name-quick"
                                                                isClearable
                                                                isDisabled={
                                                                  userData &&
                                                                  !userData.roles[0].permissions.some(
                                                                    (item) =>
                                                                      item.name ===
                                                                      "Animator DropDown"
                                                                  )
                                                                }
                                                                options={
                                                                  animatorOptions
                                                                }
                                                                placeholder={
                                                                  translations[
                                                                    "dropdown"
                                                                  ].select[
                                                                    language
                                                                  ]
                                                                }
                                                                menuPortalTarget={
                                                                  document.body
                                                                }
                                                                isSearchable={
                                                                  true
                                                                }
                                                                value={
                                                                  (animatorOptions &&
                                                                    animatorOptions.length >
                                                                      0 &&
                                                                    animatorOptions.find(
                                                                      (
                                                                        option
                                                                      ) =>
                                                                        option.value?.toString() ===
                                                                        event?.animator_id?.toString()
                                                                    )) || {
                                                                    value: "",
                                                                    label:
                                                                      translations[
                                                                        "dropdown"
                                                                      ].select[
                                                                        language
                                                                      ],
                                                                  }
                                                                }
                                                                onChange={(
                                                                  selectedOption
                                                                ) => {
                                                                  changeDropdowns(
                                                                    {
                                                                      id: event.id,
                                                                      animator_id:
                                                                        selectedOption
                                                                          ? selectedOption?.value
                                                                          : null,
                                                                    },columnKey
                                                                  );
                                                                }}
                                                                maxMenuHeight={
                                                                  "130px"
                                                                }
                                                                styles={{
                                                                  menuPortal: (
                                                                    base
                                                                  ) => ({
                                                                    ...base,
                                                                    zIndex: 9999,
                                                                  }),
                                                                  input: (
                                                                    provided
                                                                  ) => ({
                                                                    ...provided,
                                                                    color:
                                                                      isDarkMode
                                                                        ? "#ffffff"
                                                                        : "black",
                                                                  }),
                                                                  control: (
                                                                    provided,
                                                                    state
                                                                  ) => ({
                                                                    ...provided,
                                                                    backgroundColor:
                                                                      isDarkMode
                                                                        ? userData &&
                                                                          userData.roles[0].permissions.some(
                                                                            (
                                                                              item
                                                                            ) =>
                                                                              item.name ===
                                                                              "Animator DropDown"
                                                                          )
                                                                          ? "transparent"
                                                                          : "#ced4da66"
                                                                        : userData &&
                                                                          userData.roles[0].permissions.some(
                                                                            (
                                                                              item
                                                                            ) =>
                                                                              item.name ===
                                                                              "Animator DropDown"
                                                                          )
                                                                        ? "white"
                                                                        : "#ced4da66",
                                                                    border:
                                                                      state.isFocused
                                                                        ? "1px solid #80bdff"
                                                                        : isDarkMode
                                                                        ? "1px solid #495057"
                                                                        : "1px solid #dee2e6",
                                                                    boxShadow:
                                                                      state.isFocused
                                                                        ? "0 0 0 0.2rem rgba(0, 123, 255, 0.25)"
                                                                        : "none",
                                                                    borderRadius:
                                                                      ".45rem",
                                                                  }),
                                                                  valueContainer:
                                                                    (
                                                                      provided
                                                                    ) => ({
                                                                      ...provided,
                                                                      padding:
                                                                        "0.18rem 0.55rem",
                                                                      width:
                                                                        "120px",
                                                                    }),
                                                                  indicatorSeparator:
                                                                    (
                                                                      provided
                                                                    ) => ({
                                                                      ...provided,
                                                                      display:
                                                                        "none",
                                                                    }),
                                                                  dropdownIndicator:
                                                                    (
                                                                      provided
                                                                    ) => ({
                                                                      ...provided,
                                                                      padding:
                                                                        "0.375rem 0.75rem",
                                                                      color:
                                                                        clickedRow?.key ===
                                                                          key &&
                                                                        clickedRow?.index ===
                                                                          index
                                                                          ? "black"
                                                                          : isDarkMode
                                                                          ? "#ffffff"
                                                                          : "#868686",
                                                                      display:
                                                                        userData &&
                                                                        userData.roles[0].permissions.some(
                                                                          (
                                                                            item
                                                                          ) =>
                                                                            item.name ===
                                                                            "Animator DropDown"
                                                                        )
                                                                          ? "block"
                                                                          : "none",
                                                                    }),
                                                                  menu: (
                                                                    provided
                                                                  ) => ({
                                                                    ...provided,
                                                                    color:
                                                                      isDarkMode
                                                                        ? "#ffffff"
                                                                        : "black",
                                                                    backgroundColor:
                                                                      isDarkMode
                                                                        ? "#1f2023"
                                                                        : "white",
                                                                    margin: "0",
                                                                  }),
                                                                  placeholder: (
                                                                    provided
                                                                  ) => ({
                                                                    ...provided,
                                                                    color:
                                                                      isDarkMode
                                                                        ? "#ffffff"
                                                                        : "#333333",
                                                                  }),
                                                                  singleValue: (
                                                                    provided
                                                                  ) => ({
                                                                    ...provided,
                                                                    color:
                                                                      clickedRow?.key ===
                                                                        key &&
                                                                      clickedRow?.index ===
                                                                        index
                                                                        ? "black"
                                                                        : isDarkMode
                                                                        ? "#ffffff"
                                                                        : "black",
                                                                  }),
                                                                  option: (
                                                                    provided,
                                                                    state
                                                                  ) => ({
                                                                    ...provided,
                                                                    color:
                                                                      isDarkMode
                                                                        ? "#ffffff"
                                                                        : "black",
                                                                    backgroundColor:
                                                                      state.isHovered
                                                                        ? "#80bdff"
                                                                        : isDarkMode
                                                                        ? "#1f2023"
                                                                        : "white",
                                                                    ":hover": {
                                                                      backgroundColor:
                                                                        isDarkMode
                                                                          ? "#34DBB4"
                                                                          : "#34DBB4",
                                                                    },
                                                                  }),
                                                                }}
                                                              />
                                                            </span>
                                                          </div>
                                                        ) : columnKey ===
                                                          "dealership" ? (
                                                          <div style={{}}>
                                                            <div
                                                              style={{
                                                                width: "10px",
                                                                // height: "10px",
                                                                // backgroundColor: event?.dealership?.activeX_key ? "#3E8DBC" : "",
                                                                backgroundColor:
                                                                  event
                                                                    ?.dealership
                                                                    ?.activeX_key
                                                                    ? event
                                                                        ?.dealership
                                                                        ?.activeX_first_name ||
                                                                      event
                                                                        ?.dealership
                                                                        ?.activeX_last_name
                                                                      ? "#3E8DBC"
                                                                      : "orange"
                                                                    : "",
                                                                borderRadius:
                                                                  "50%",
                                                                marginRight:
                                                                  "8px",
                                                                flexShrink: 0,
                                                              }}
                                                              // title={!event?.dealership?.activeX_key ? language == "fr" ? "La clé ActiviX est manquante" : "ActiviX key is missing" : ""}
                                                            />
                                                            {event?.dealership
                                                              ?.name && (
                                                                <>
                                                              {
                                                                event?.dealership?.group?.name === "Olivier" && (
                                                                  <span
                                                                    style={{
                                                                      display: "inline-block",
                                                                      width: "10px",
                                                                      height: "10px",
                                                                      backgroundColor: "orange",
                                                                      borderRadius: "50%",
                                                                      marginRight: "8px",
                                                                    }}
                                                                  />
                                                                )
                                                              }
                                                              <span
                                                                className={`${
                                                                  isDarkMode
                                                                    ? "text-white"
                                                                    : "text-muted"
                                                                } small`}
                                                              >
                                                                {
                                                                  event
                                                                    ?.dealership
                                                                    ?.name
                                                                }
                                                              </span>
                                                              </>
                                                            )}
                                                            {event?.package
                                                              ?.name && (
                                                              <>
                                                                <span
                                                                  className={`${
                                                                    isDarkMode
                                                                      ? "text-white"
                                                                      : "text-muted"
                                                                  } small `}
                                                                >
                                                                  .
                                                                </span>{" "}
                                                                <span
                                                                  className={`${
                                                                    isDarkMode
                                                                      ? "text-white"
                                                                      : "text-muted"
                                                                  } small `}
                                                                >
                                                                  {
                                                                    event
                                                                      ?.package
                                                                      ?.name
                                                                  }
                                                                </span>
                                                              </>
                                                            )}
                                                          </div>
                                                        ) : // event?.dealership?.name
                                                        // :
                                                        // columnKey ===
                                                        //   "group" ? (
                                                        //     null
                                                        //     //  <>
                                                        //     //   {/* <p style={{fontWeight:'600'}}>{col?.content}</p>
                                                        //     //   <p >{(event?.dealership?.group?.name) ? event?.dealership?.group?.name : ""}</p> */}
                                                        //     //   </>

                                                        //   // event?.dealership?.name
                                                        // )

                                                        //   :
                                                        //   columnKey ===
                                                        //     "package" ? (
                                                        //       null
                                                        //       //  <>
                                                        //       // {/* <p style={{fontWeight:'600'}}>{col?.content}</p>
                                                        //       // <p >{event?.package?.name}</p> */}
                                                        //       // </>

                                                        //   )
                                                        columnKey ===
                                                          "sales_rep" ? (
                                                          <>
                                                            <p
                                                              style={{
                                                                fontWeight:
                                                                  "700",
                                                                width: "50%",
                                                                fontSize:
                                                                  ".875em",
                                                              }}
                                                              className={`${
                                                                isDarkMode
                                                                  ? "text-white"
                                                                  : "text-muted"
                                                              } `}
                                                            >
                                                              {/* {col?.content} */}
                                                              {FindPathForMobile(col?.content, language)}
                                                            </p>
                                                            <p
                                                              style={{
                                                                width: "50%",
                                                                fontSize:
                                                                  ".875em",
                                                              }}
                                                            >
                                                              {
                                                                event?.sales_rep
                                                                  ?.name
                                                              }
                                                            </p>
                                                          </>
                                                        ) : event[columnKey]
                                                            ?.name ? (
                                                          <>
                                                            <p
                                                              style={{
                                                                fontWeight:
                                                                  "700",
                                                                width: "50%",
                                                                fontSize:
                                                                  ".875em",
                                                              }}
                                                              className={`${
                                                                isDarkMode
                                                                  ? "text-white"
                                                                  : "text-muted"
                                                              } `}
                                                            >
                                                              {/* {col?.content} */}
                                                              {FindPathForMobile(col?.content, language)}
                                                            </p>
                                                            <p
                                                              style={{
                                                                width: "50%",
                                                                fontSize:
                                                                  ".875em",
                                                              }}
                                                            >
                                                              {
                                                                event[columnKey]
                                                                  ?.name
                                                              }
                                                            </p>
                                                          </>
                                                        ) : columnKey ==
                                                          "start_date" ? (
                                                          <span
                                                            className="mobile-label2"
                                                            style={{
                                                              width: "100%",
                                                            }}
                                                          >
                                                            <p
                                                              style={{
                                                                fontWeight:
                                                                  "700",
                                                                width: "40%",
                                                                fontSize:
                                                                  ".875em",
                                                              }}
                                                              className={`${
                                                                isDarkMode
                                                                  ? "text-white"
                                                                  : "text-muted"
                                                              } `}
                                                            >
                                                              {/* {"Dates"} */}
                                                              {translations.forms.datesBtn[language]}
                                                            </p>

                                                            <p
                                                              style={{
                                                                width: "60%",
                                                                fontSize:
                                                                  ".875em",
                                                              }}
                                                            >
                                                              <>
                                                                {
                                                                  event?.start_date
                                                                }{" "}
                                                                <i className="bi bi-arrow-right"></i>{" "}
                                                                {
                                                                  event?.end_date
                                                                }
                                                              </>
                                                            </p>
                                                          </span>
                                                        ) : columnKey ===
                                                          "end_date" ? null : columnKey ===
                                                          "nom_vp" ? (
                                                          <p
                                                            style={{
                                                              fontWeight: "700",
                                                              fontSize: "1rem",
                                                            }}
                                                          >
                                                            {event[columnKey]}
                                                          </p>
                                                        ) : (
                                                          <p
                                                            style={{
                                                              fontWeight: "700",
                                                              width: "50%",
                                                              fontSize:
                                                                ".875em",
                                                            }}
                                                            className={`${
                                                              isDarkMode
                                                                ? "text-white"
                                                                : "text-muted"
                                                            } `}
                                                          >
                                                            {/* {col?.content} */}
                                                            {FindPathForMobile(col?.content, language)}
                                                          </p>
                                                        )
                                                        // null
                                                      }
                                                    </td>
                                                  )}
                                                </>
                                              ) : (
                                                <td
                                                  // id={columnKey}
                                                  id={
                                                    clickedRow?.key === key &&
                                                    clickedRow?.index === index
                                                      ? "highlight-text"
                                                      : columnKey
                                                  }
                                                  key={col.id}
                                                  style={{
                                                    // borderRight:'1px solid #dee2e6',
                                                    //  width: `${col.width}px`,
                                                    minWidth: `${col.width}px`,
                                                    maxWidth: `${
                                                      col.width +
                                                      (col.id === "animator"
                                                        ? 250
                                                        : 150)
                                                    }px`,
                                                    // overflow: "hidden",
                                                    // textOverflow: "ellipsis",
                                                    whiteSpace: "normal",
                                                    // borderRight: "1px solid",

                                                    background: `${
                                                      clickedRow?.key === key &&
                                                      clickedRow?.index ===
                                                        index
                                                        ? "yellow"
                                                        : userType !==
                                                            "Employee" &&
                                                          userType !==
                                                            "Manager" &&
                                                          event?.call_campaign ==
                                                            "early"
                                                        ? isDarkMode
                                                          ? "#327DDA"
                                                          : "rgb(108 174 255)"
                                                        : index % 2 === 0
                                                        ? isDarkMode
                                                          ? "#2B3035"
                                                          : "#F8F9FA"
                                                        : isDarkMode
                                                        ? "#343A3F"
                                                        : "#E9ECEF"
                                                    }`,
                                                    borderBottom: isLastElement
                                                      ? "1px solid #dee2e6"
                                                      : "0px solid",
                                                    ...col.style, // Apply column-specific styles
                                                  }}
                                                  className="dlrname"
                                                  onClick={
                                                    columnKey === "dealership"
                                                      ? () => {
                                                          if (
                                                            userData &&
                                                            userData.roles[0].permissions.some(
                                                              (item) =>
                                                                item.name ===
                                                                "Edit Dealership"
                                                            )
                                                          ) {
                                                            getDealershipData(
                                                              event?.dealership
                                                                ?.id
                                                            );
                                                          }
                                                        }
                                                      : undefined
                                                  }
                                                >
                                                  {columnKey === "animator" ? (
                                                    <div
                                                      className="d-flex align-items-center"
                                                      style={{
                                                        minWidth: "186px",
                                                        maxWidth: "300px",
                                                        marginRight: "30px",
                                                        paddingLeft: "15px",
                                                      }}
                                                    >
                                                      <div
                                                        style={{
                                                          width: "10px",
                                                          height: "10px",
                                                          backgroundColor:
                                                            event?.animator_id?.toString() ===
                                                            "1.1"
                                                              ? "red"
                                                              : event?.animator_id?.toString() ===
                                                                "1.2"
                                                              ? "orange"
                                                              : "",
                                                          borderRadius: "50%",
                                                          marginRight: "8px",
                                                        }}
                                                      ></div>

                                                      <Select
                                                        className="w-100 selectpicker"
                                                        aria-labelledby="dealership-name-quick"
                                                        isClearable
                                                        isDisabled={
                                                          userData &&
                                                          !userData.roles[0].permissions.some(
                                                            (item) =>
                                                              item.name ===
                                                              "Animator DropDown"
                                                          )
                                                        }
                                                        options={
                                                          animatorOptions
                                                        }
                                                        placeholder={
                                                          translations[
                                                            "dropdown"
                                                          ].select[language]
                                                        }
                                                        menuPortalTarget={
                                                          document.body
                                                        }
                                                        isSearchable={true}
                                                        value={
                                                          (animatorOptions &&
                                                            animatorOptions.length >
                                                              0 &&
                                                            animatorOptions.find(
                                                              (option) =>
                                                                option.value?.toString() ===
                                                                event?.animator_id?.toString()
                                                            )) || {
                                                            value: "",
                                                            label:
                                                              translations[
                                                                "dropdown"
                                                              ].select[
                                                                language
                                                              ],
                                                          }
                                                        }
                                                        onChange={(
                                                          selectedOption
                                                        ) => {
                                                          changeDropdowns({
                                                            id: event.id,
                                                            animator_id:
                                                              selectedOption
                                                                ? selectedOption?.value
                                                                : null,
                                                          },columnKey);
                                                        }}
                                                        maxMenuHeight={"130px"}
                                                        styles={{
                                                          menuPortal: (
                                                            base
                                                          ) => ({
                                                            ...base,
                                                            zIndex: 9999,
                                                          }),
                                                          input: (
                                                            provided
                                                          ) => ({
                                                            ...provided,
                                                            color: isDarkMode
                                                              ? "#ffffff"
                                                              : "black",
                                                          }),
                                                          control: (
                                                            provided,
                                                            state
                                                          ) => ({
                                                            ...provided,
                                                            backgroundColor:
                                                              isDarkMode
                                                                ? userData &&
                                                                  userData.roles[0].permissions.some(
                                                                    (item) =>
                                                                      item.name ===
                                                                      "Animator DropDown"
                                                                  )
                                                                  ? "transparent"
                                                                  : "#ced4da66"
                                                                : userData &&
                                                                  userData.roles[0].permissions.some(
                                                                    (item) =>
                                                                      item.name ===
                                                                      "Animator DropDown"
                                                                  )
                                                                ? "white"
                                                                : "#ced4da66",
                                                            border:
                                                              state.isFocused
                                                                ? "1px solid #80bdff"
                                                                : isDarkMode
                                                                ? "1px solid #495057"
                                                                : "1px solid #dee2e6",
                                                            boxShadow:
                                                              state.isFocused
                                                                ? "0 0 0 0.2rem rgba(0, 123, 255, 0.25)"
                                                                : "none",
                                                            borderRadius:
                                                              ".45rem",
                                                          }),
                                                          valueContainer: (
                                                            provided
                                                          ) => ({
                                                            ...provided,
                                                            padding:
                                                              "0.18rem 0.55rem",
                                                            width: "120px",
                                                          }),
                                                          indicatorSeparator: (
                                                            provided
                                                          ) => ({
                                                            ...provided,
                                                            display: "none",
                                                          }),
                                                          dropdownIndicator: (
                                                            provided
                                                          ) => ({
                                                            ...provided,
                                                            padding:
                                                              "0.375rem 0.75rem",
                                                            color:
                                                              clickedRow?.key ===
                                                                key &&
                                                              clickedRow?.index ===
                                                                index
                                                                ? "black"
                                                                : isDarkMode
                                                                ? "#ffffff"
                                                                : "#868686",
                                                            display:
                                                              userData &&
                                                              userData.roles[0].permissions.some(
                                                                (item) =>
                                                                  item.name ===
                                                                  "Animator DropDown"
                                                              )
                                                                ? "block"
                                                                : "none",
                                                          }),
                                                          menu: (provided) => ({
                                                            ...provided,
                                                            color: isDarkMode
                                                              ? "#ffffff"
                                                              : "black",
                                                            backgroundColor:
                                                              isDarkMode
                                                                ? "#1f2023"
                                                                : "white",
                                                            margin: "0",
                                                          }),
                                                          placeholder: (
                                                            provided
                                                          ) => ({
                                                            ...provided,
                                                            color: isDarkMode
                                                              ? "#ffffff"
                                                              : "#333333",
                                                          }),
                                                          singleValue: (
                                                            provided
                                                          ) => ({
                                                            ...provided,
                                                            color:
                                                              clickedRow?.key ===
                                                                key &&
                                                              clickedRow?.index ===
                                                                index
                                                                ? "black"
                                                                : isDarkMode
                                                                ? "#ffffff"
                                                                : "black",
                                                          }),
                                                          option: (
                                                            provided,
                                                            state
                                                          ) => ({
                                                            ...provided,
                                                            color: isDarkMode
                                                              ? "#ffffff"
                                                              : "black",
                                                            backgroundColor:
                                                              state.isHovered
                                                                ? "#80bdff"
                                                                : isDarkMode
                                                                ? "#1f2023"
                                                                : "white",
                                                            ":hover": {
                                                              backgroundColor:
                                                                isDarkMode
                                                                  ? "#34DBB4"
                                                                  : "#34DBB4",
                                                            },
                                                          }),
                                                        }}
                                                      />
                                                    </div>
                                                  ) : columnKey ===
                                                    "dealership" ? (
                                                    <div
                                                      style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                      }}
                                                    >
                                                      <div
                                                        style={{
                                                          width: "10px",
                                                          height: "10px",
                                                          // backgroundColor: event?.dealership?.activeX_key ? "#3E8DBC" : "",
                                                          backgroundColor: event
                                                            ?.dealership
                                                            ?.activeX_key
                                                            ? event?.dealership
                                                                ?.activeX_first_name ||
                                                              event?.dealership
                                                                ?.activeX_last_name
                                                              ? "#3E8DBC"
                                                              : "orange"
                                                            : "",
                                                          borderRadius: "50%",
                                                          marginRight: "8px",
                                                          flexShrink: 0,
                                                        }}
                                                        // title={!event?.dealership?.activeX_key ? language == "fr" ? "La clé ActiviX est manquante" : "ActiviX key is missing" : ""}
                                                      />
                                                      {
                                                        event?.dealership?.group?.name == "Olivier" &&
                                                        <div
                                                          style={{
                                                            width: "10px",
                                                            height: "10px",
                                                            backgroundColor: "orange",
                                                            borderRadius: "50%",
                                                            marginRight: "8px",
                                                          }}
                                                        />
                                                      }
                                                        
                                                      <span>
                                                        {
                                                          event?.dealership
                                                            ?.name
                                                        }
                                                      </span>
                                                    </div>
                                                  ) : // event?.dealership?.name
                                                  columnKey === "group" ? (
                                                    event?.dealership?.group
                                                      ?.name ? (
                                                      event?.dealership?.group
                                                        ?.name
                                                    ) : (
                                                      ""
                                                    )
                                                  ):
                                                  
                                                   columnKey === "call_centre" ? (
                                                  
                                                    event?.call_centre ? (
                                                    <span className="capitalize-text" >{language == "fr" ? event?.call_centre == "internal" ? "Interne" : "Externe" : event?.call_centre == "internal" ? "Internal" : "External"}</span>

                                                    ): null
                                                  ):
                                                  columnKey === "fidgi_contest" ? (
                                                    <div
                                                      className="d-flex align-items-center"
                                                      style={{
                                                        minWidth: "186px",
                                                        maxWidth: "300px",
                                                        marginRight: "30px",
                                                        paddingLeft: "15px",
                                                      }}
                                                    >
                                                      <Select
                                                        className="w-120 selectpicker"
                                                        aria-labelledby="fidgi_contest-dropdown"
                                                        // no clear (cancel) button per request
                                                        isClearable={false}
                                                        isDisabled={
                                                          userData &&
                                                          !userData.roles[0].permissions.some(
                                                            (item) =>
                                                              item.name ===
                                                              "Animator DropDown"
                                                          )
                                                        }
                                                        options={fidgiContestOptions}
                                                        placeholder={
                                                          translations[
                                                            "dropdown"
                                                          ].select[language]
                                                        }
                                                        menuPortalTarget={
                                                          document.body
                                                        }
                                                        isSearchable={true}
                                                        value={
                                                          (fidgiContestOptions &&
                                                            fidgiContestOptions.find(
                                                              (option) =>
                                                                option.value ===
                                                                event?.fidgi_contest
                                                            )) || {
                                                            value: "",
                                                            label:
                                                              translations[
                                                                "dropdown"
                                                              ].select[
                                                                language
                                                              ],
                                                          }
                                                        }
                                                        onChange={(
                                                          selectedOption
                                                        ) => {
                                                          changeDropdowns({
                                                            id: event.id,
                                                            fidgi_contest:
                                                              selectedOption
                                                                ? selectedOption?.value
                                                                : null,
                                                          }, "fidgi_contest");
                                                        }}
                                                        maxMenuHeight={"130px"}
                                                        styles={{
                                                          menuPortal: (base) => ({
                                                            ...base,
                                                            zIndex: 9999,
                                                          }),
                                                          input: (provided) => ({
                                                            ...provided,
                                                            color: isDarkMode
                                                              ? "#ffffff"
                                                              : "black",
                                                          }),
                                                          control: (provided, state) => ({
                                                            ...provided,
                                                            backgroundColor:
                                                              isDarkMode
                                                                ? userData &&
                                                                  userData.roles[0].permissions.some(
                                                                    (item) =>
                                                                      item.name ===
                                                                      "Animator DropDown"
                                                                  )
                                                                  ? "transparent"
                                                                  : "#ced4da66"
                                                                : userData &&
                                                                  userData.roles[0].permissions.some(
                                                                    (item) =>
                                                                      item.name ===
                                                                      "Animator DropDown"
                                                                  )
                                                                ? "white"
                                                                : "#ced4da66",
                                                            border: state.isFocused
                                                              ? "1px solid #80bdff"
                                                              : isDarkMode
                                                              ? "1px solid #495057"
                                                              : "1px solid #dee2e6",
                                                            boxShadow: state.isFocused
                                                              ? "0 0 0 0.2rem rgba(0, 123, 255, 0.25)"
                                                              : "none",
                                                            borderRadius: ".45rem",
                                                          }),
                                                          valueContainer: (provided) => ({
                                                            ...provided,
                                                            padding: "0.18rem 0.55rem",
                                                            width: "200px",
                                                          }),
                                                          indicatorSeparator: (provided) => ({
                                                            ...provided,
                                                            display: "none",
                                                          }),
                                                          dropdownIndicator: (provided) => ({
                                                            ...provided,
                                                            padding: "0.375rem 0.75rem",
                                                            color:
                                                              clickedRow?.key === key &&
                                                              clickedRow?.index === index
                                                                ? "black"
                                                                : isDarkMode
                                                                ? "#ffffff"
                                                                : "#868686",
                                                            display:
                                                              userData &&
                                                              userData.roles[0].permissions.some(
                                                                (item) =>
                                                                  item.name ===
                                                                  "Animator DropDown"
                                                              )
                                                                ? "block"
                                                                : "none",
                                                          }),
                                                          menu: (provided) => ({
                                                            ...provided,
                                                            color: isDarkMode ? "#ffffff" : "black",
                                                            backgroundColor: isDarkMode
                                                              ? "#1f2023"
                                                              : "white",
                                                            margin: "0",
                                                          }),
                                                          placeholder: (provided) => ({
                                                            ...provided,
                                                            color: isDarkMode ? "#ffffff" : "#333333",
                                                          }),
                                                          singleValue: (provided) => ({
                                                            ...provided,
                                                            color:
                                                              clickedRow?.key === key &&
                                                              clickedRow?.index === index
                                                                ? "black"
                                                                : isDarkMode
                                                                ? "#ffffff"
                                                                : "black",
                                                          }),
                                                          option: (provided, state) => ({
                                                            ...provided,
                                                            color: isDarkMode ? "#ffffff" : "black",
                                                            backgroundColor: state.isHovered
                                                              ? "#80bdff"
                                                              : isDarkMode
                                                              ? "#1f2023"
                                                              : "white",
                                                            ":hover": {
                                                              backgroundColor: isDarkMode ? "#34DBB4" : "#34DBB4",
                                                            },
                                                          }),
                                                        }}
                                                      />
                                                    </div>
                                                  )
                                                  
                                                  : // event?.dealership?.name
                                                  columnKey === "package" ? (
                                                    event?.package?.name
                                                  ) : columnKey ===
                                                    "sales_rep" ? (
                                                    event?.sales_rep?.name
                                                  ) : event[columnKey]?.name ? (
                                                    event[columnKey]?.name
                                                  ) : // event[columnKey] || ""

                                                  event[columnKey] == "Yes" ? (
                                                    language == "fr" ? (
                                                      "Oui"
                                                    ) : (
                                                      "Yes"
                                                    )
                                                  ) : event[columnKey] ==
                                                    "No" ? (
                                                    language == "fr" ? (
                                                      "Non"
                                                    ) : (
                                                      "No"
                                                    )
                                                  ) : (
                                                    event[columnKey] || ""
                                                  )}
                                                </td>
                                              );
                                            })}
                                        {/* {isMobile &&
                                          userType !== "animator" &&
                                          userType !== "Employee" &&
                                          userType !== "Manager" && (
                                            <div
                                              style={{ display: "flex" }}
                                              className="mobile-label2"
                                            >
                                              <td className="pb-0">
                                                <div className="mobile-badges-row">
                                                  {[
                                                    {
                                                      key: "carton",
                                                      label: "Carton",
                                                    },
                                                    {
                                                      key: "web",
                                                      label: "Web",
                                                    },
                                                    {
                                                      key: "banner",
                                                      label: "Banner",
                                                    },
                                                    {
                                                      key: "news_letter",
                                                      label: "Newsletter",
                                                    },
                                                    {
                                                      key: "facebook",
                                                      label: "Facebook",
                                                    },
                                                    {
                                                      key: "ad_words",
                                                      label: "Adwords",
                                                    },
                                                    {
                                                      key: "sms",
                                                      label: "SMS",
                                                    },
                                                    {
                                                      key: "mailing",
                                                      label: "Mailing",
                                                    },
                                                  ].map(({ key, label }) => (
                                                    <span
                                                      key={key}
                                                      className="mobile-label mobile-only-row chip chip-off"
                                                      style={{
                                                        backgroundColor:
                                                          isDarkMode
                                                            ? "#2b3035"
                                                            : "#f8f9fa",
                                                        color: isDarkMode
                                                          ? "#f8f9fa"
                                                          : "rgb(52, 58, 63)",
                                                        border: isDarkMode
                                                          ? "1px solid white"
                                                          : "1px solid rgba(0, 0, 0, .08)",
                                                      }}
                                                    >
                                                       {FindPathForMobile(label, language)}:{" "}
                                                      {event[key] === "Yes"
                                                        ? language === "fr"
                                                          ? "Oui"
                                                          : "Yes"
                                                        : language === "fr"
                                                        ? "Non"
                                                        : "No"}
                                                    </span>
                                                  ))}
                                                  
                                                </div>
                                              </td>
                                            </div>
                                          )} */}
                  
                                        {shouldShowActions ? isMobile ? (
                                          <>
                                            <td
                                              style={{
                                                // background:
                                                //   clickedRow?.key === key &&
                                                //   clickedRow?.index === index
                                                //     ? "yellow"
                                                //     : userType !== "Employee" &&
                                                //         userType !==
                                                //           "Manager" &&
                                                //         event?.call_campaign ==
                                                //           "early"
                                                //       ? isDarkMode
                                                //         ? "#327DDA"
                                                //         : "rgb(108 174 255)"
                                                //       : index % 2 === 0
                                                //         ? isDarkMode
                                                //           ? "#343A3F"
                                                //           : "#F8F9FA"
                                                //         : isDarkMode
                                                //           ? "#343A3F"
                                                //           : "#E9ECEF",
                                                // borderBottom: isLastElement
                                                //   ? "1px solid #dee2e6"
                                                //   : "0px solid",
                                                position: "sticky",
                                                right: "0px",
                                                // width commented intentionally per your request
                                              }}
                                              colSpan={
                                                currentView?.columns[
                                                  currentView?.columns.length -
                                                    1
                                                ]?.colSpan
                                              }
                                            >
                                              <div
                                                className="d-flex justify-content-end align-items-center"
                                                style={{
                                                  flexDirection: "column",
                                                  alignItems: "flex-end",
                                                  gap: "8px",
                                                  // padding: "8px",
                                                  width: "100%",
                                                }}
                                              >
                                                {/* Toggle Buttons (Collapsed / Expanded View) */}
                                                <div style={{ width: "100%" }}>
                                                  {userType &&
                                                    internalUsers.includes(
                                                      userType
                                                    ) &&
                                                    userType !== "Animator" &&
                                                    userType !== "Agent" && (
                                                      <div
                                                        style={{
                                                          width: "100%",
                                                          display: "flex",
                                                          gap: "5px",
                                                        }}
                                                      >
                                                        <button
                                                          type="button"
                                                          className="btn btn-light d-flex align-items-center justify-content-center gap-1 "
                                                          style={{
                                                            width: "88%", // leave space for chevron
                                                            whiteSpace:
                                                              "nowrap",
                                                            overflow: "hidden",
                                                            textOverflow:
                                                              "ellipsis",
                                                            border:
                                                              "1px solid #ccc",
                                                            display: "flex",
                                                            alignItems:
                                                              "center",
                                                            gap: "6px",
                                                          }}
                                                          onClick={(e) => {
                                                            e.stopPropagation();
                                                            setDisplayComponent(
                                                              "edit-event"
                                                            );
                                                            setEditEventID(
                                                              event.id
                                                            );
                                                            window.history.pushState(
                                                              {
                                                                id: "gallery",
                                                                randomData:
                                                                  window.Math.random(),
                                                              },
                                                              "title",
                                                              "/event-portal?page=edit-event&parent_id=" +
                                                                event.id
                                                            );
                                                          }}
                                                          // kept no onClick here as you had separate chevron toggle — if you want Edit to toggle too, add the same onClick
                                                        >
                                                          <i
                                                            className="bi bi-pencil"
                                                            aria-hidden="true"
                                                          ></i>
                                                          <span
                                                            style={{
                                                              overflow:
                                                                "hidden",
                                                              textOverflow:
                                                                "ellipsis",
                                                            }}
                                                          >
                                                            {/* Edit */}
                                                            {translations.commonFields.editBtn[language]}
                                                          </span>
                                                        </button>

                                                        <span
                                                          style={{
                                                            width: "12%",
                                                            display: "flex",
                                                            justifyContent:
                                                              "center",
                                                            alignItems:
                                                              "center",
                                                            border:
                                                              "1px solid #ccc",
                                                            cursor: "pointer",
                                                            userSelect: "none",
                                                          }}
                                                          onClick={(e) => {
                                                            e.stopPropagation();
                                                            setOpenRow(
                                                              openRow ===
                                                                event.id
                                                                ? null
                                                                : event.id
                                                            );
                                                          }}
                                                          role="button"
                                                          // aria-pressed={openRow === event.id}
                                                          // aria-label={openRow === event.id ? "Close actions" : "Open actions"}
                                                        >
                                                          <i
                                                            className={`bi ${
                                                              openRow ===
                                                              event.id
                                                                ? "bi-chevron-up"
                                                                : "bi-chevron-down"
                                                            }`}
                                                            aria-hidden="true"
                                                          ></i>
                                                        </span>
                                                      </div>
                                                    )}

                                                  {(openRow === event.id ||
                                                    userType === "Manager" ||
                                                    userType ===
                                                      "Animator") && (
                                                    <div
                                                      style={{
                                                        width: "100%",
                                                        background: isDarkMode
                                                          ? "#2B3035"
                                                          : "#ffffff",
                                                        border:
                                                          "1px solid #dee2e6",
                                                        borderTop: "none",
                                                        padding: "10px 0px",
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        alignItems: "center",
                                                        gap: "8px",
                                                        border: "none",
                                                        backgroundColor:
                                                          "unset",
                                                      }}
                                                    >
                                                      <div
                                                        className="d-flex justify-content-end align-items-center"
                                                        style={{
                                                          flexDirection:
                                                            "column",
                                                          width: "100%",
                                                        }}
                                                      >
                                                        {userType &&
                                                          internalUsers.includes(
                                                            userType
                                                          ) &&
                                                          userType !==
                                                            "Animator" &&
                                                          userType !==
                                                            "Agent" &&
                                                          userType !==
                                                            "Accountant" &&
                                                          currentView?.name !==
                                                            "Contract and Billing" && (
                                                            <div
                                                              style={{
                                                                width: "100%",
                                                                background: `${
                                                                  clickedRow?.key ===
                                                                    key &&
                                                                  clickedRow?.index ===
                                                                    index
                                                                    ? "yellow"
                                                                    : userType !==
                                                                        "Employee" &&
                                                                      userType !==
                                                                        "Manager" &&
                                                                      event?.call_campaign ==
                                                                        "early"
                                                                    ? isDarkMode
                                                                      ? "#327DDA"
                                                                      : "rgb(108 174 255)"
                                                                    : index %
                                                                        2 ===
                                                                      0
                                                                    ? isDarkMode
                                                                      ? "#343A3F"
                                                                      : "#F8F9FA"
                                                                    : isDarkMode
                                                                    ? "#343A3F"
                                                                    : "#E9ECEF"
                                                                }`,

                                                                marginTop:
                                                                  "5px",
                                                              }}
                                                            >
                                                              <div
                                                                className="btn-group"
                                                                role="group"
                                                                aria-label="Basic example"
                                                                style={{
                                                                  width: "100%",
                                                                  gap: "10px",
                                                                }}
                                                              >
                                                                {}
                                                                {userType !==
                                                                  "Representative" && (
                                                                  <button
                                                                    type="button"
                                                                    className="d-flex btn btn-light align-items-center justify-content-center edit-button gap-1 mx-auto"
                                                                    style={{
                                                                      borderRadius:
                                                                        "6px",
                                                                      width:
                                                                        "13%",
                                                                      // maxWidth:
                                                                      //   "150px",
                                                                      whiteSpace:
                                                                        "nowrap",
                                                                      textOverflow:
                                                                        "ellipsis",
                                                                      overflow:
                                                                        "hidden",
                                                                    }}
                                                                    onClick={() => {
                                                                      if (
                                                                        event.copy ===
                                                                        "0"
                                                                      ) {
                                                                        checkParent(
                                                                          event.id
                                                                        );
                                                                        setformDealerID(
                                                                          event
                                                                            ?.dealership
                                                                            ?.id
                                                                        );
                                                                      } else {
                                                                        setDisplayComponent(
                                                                          "create-event"
                                                                        );

                                                                        window.history.pushState(
                                                                          {
                                                                            id: "gallery",
                                                                            randomData:
                                                                              window.Math.random(),
                                                                          },
                                                                          "title",
                                                                          "/event-portal?page=create-event&parent_id=" +
                                                                            event.id +
                                                                            "&event-navigate=true&getFormData=false"
                                                                        );
                                                                      }
                                                                    }}
                                                                  >
                                                                    <i
                                                                      className={
                                                                        "bi bi-plus-circle"
                                                                      }
                                                                    ></i>{" "}
                                                                  </button>
                                                                )}
                                                                {userType &&
                                                                  internalUsers.includes(
                                                                    userType
                                                                  ) &&
                                                                  userType !==
                                                                    "Animator" &&
                                                                  userType !==
                                                                    "Agent" &&
                                                                  userType !==
                                                                    "Accountant" && (
                                                                    <div
                                                                      className="btn-group"
                                                                      role="group"
                                                                      style={{
                                                                        width:
                                                                          "90%",
                                                                      }}
                                                                    >
                                                                      <button
                                                                        type="button"
                                                                        className="d-flex btn btn-light align-items-center justify-content-center edit-button gap-1 mx-auto"
                                                                        style={{
                                                                          borderRadius:'5px',
                                                                          width:
                                                                            "100%",
                                                                          // maxWidth:
                                                                          //   "150px",
                                                                          whiteSpace:
                                                                            "nowrap",
                                                                          textOverflow:
                                                                            "ellipsis",
                                                                          overflow:
                                                                            "hidden",
                                                                          minWidth:
                                                                            "130px",
                                                                          background:
                                                                            "transparent",
                                                                          color:
                                                                            clickedRow?.key ===
                                                                              key &&
                                                                            clickedRow?.index ===
                                                                              index
                                                                              ? "black"
                                                                              : isDarkMode
                                                                              ? "#ffffff"
                                                                              : "black",
                                                                        }}
                                                                        onClick={() => {
                                                                          if (
                                                                            event.copy ===
                                                                            "0"
                                                                          ) {
                                                                            checkParent(
                                                                              event.id
                                                                            );
                                                                            setformDealerID(
                                                                              event
                                                                                ?.dealership
                                                                                ?.id
                                                                            );
                                                                          } else {
                                                                            setDisplayComponent(
                                                                              "create-event"
                                                                            );

                                                                            window.history.pushState(
                                                                              {
                                                                                id: "gallery",
                                                                                randomData:
                                                                                  window.Math.random(),
                                                                              },
                                                                              "title",
                                                                              "/event-portal?page=create-event&parent_id=" +
                                                                                event.id +
                                                                                "&event-navigate=true&getFormData=false"
                                                                            );
                                                                          }
                                                                        }}
                                                                      >
                                                                        {
                                                                          translations
                                                                            .commonWords
                                                                            .form[
                                                                            language
                                                                          ]
                                                                        }
                                                                      </button>
                                                                    </div>
                                                                  )}

                                                                {}
                                                              </div>
                                                            </div>
                                                          )}

                                                        {userType &&
                                                          externalUsers.includes(
                                                            userType
                                                          ) && (
                                                            <div
                                                              style={{
                                                                background: `${
                                                                  clickedRow?.key ===
                                                                    key &&
                                                                  clickedRow?.index ===
                                                                    index
                                                                    ? "yellow"
                                                                    : userType !==
                                                                        "Employee" &&
                                                                      userType !==
                                                                        "Manager" &&
                                                                      event?.call_campaign ==
                                                                        "early"
                                                                    ? isDarkMode
                                                                      ? "#327DDA"
                                                                      : "rgb(108 174 255)"
                                                                    : index %
                                                                        2 ===
                                                                      0
                                                                    ? isDarkMode
                                                                      ? "#343A3F"
                                                                      : "#F8F9FA"
                                                                    : isDarkMode
                                                                    ? "#343A3F"
                                                                    : "#E9ECEF"
                                                                }`,

                                                                width: "100%",
                                                              }}
                                                            >
                                                              <button
                                                                type="button"
                                                                className="d-flex btn btn-light align-items-center justify-content-center gap-1 mx-auto"
                                                                style={{
                                                                  width: "100%",
                                                                  // maxWidth: "150px",
                                                                  whiteSpace:
                                                                    "nowrap",
                                                                  textOverflow:
                                                                    "ellipsis",
                                                                  overflow:
                                                                    "hidden",
                                                                  background:
                                                                    isDarkMode
                                                                      ? ""
                                                                      : !stats?.latest_submission.some(
                                                                          (
                                                                            item
                                                                          ) =>
                                                                            item.Event_ID?.toString() ===
                                                                            event.id?.toString()
                                                                        )
                                                                      ? "#ced4da66"
                                                                      : "",
                                                                }}
                                                                disabled={
                                                                  !stats?.latest_submission.some(
                                                                    (item) =>
                                                                      item.Event_ID?.toString() ===
                                                                      event.id?.toString()
                                                                  )
                                                                }
                                                                onClick={() => {
                                                                  const submission =
                                                                    stats?.latest_submission.find(
                                                                      (item) =>
                                                                        item.Event_ID?.toString() ===
                                                                        event.id?.toString()
                                                                    );

                                                                  const clientID =
                                                                    submission?.Client_ID;

                                                                  setDisplayComponent(
                                                                    "client-submission"
                                                                  );

                                                                  window.history.pushState(
                                                                    {
                                                                      id: "gallery",
                                                                      randomData:
                                                                        window.Math.random(),
                                                                    },

                                                                    "title",
                                                                    "/event-portal?page=client-submission&id=" +
                                                                      clientID
                                                                  );
                                                                }}
                                                              >
                                                                <i
                                                                  className={
                                                                    "bi bi-file-earmark-text"
                                                                  }
                                                                ></i>{" "}
                                                                {
                                                                  translations
                                                                    .commonWords
                                                                    .form[
                                                                    language
                                                                  ]
                                                                }
                                                              </button>
                                                            </div>
                                                          )}

                                                        {userType &&
                                                          userType !==
                                                            "Agent" &&
                                                          currentView?.name !==
                                                            "Contract and Billing" && (
                                                            <div
                                                              style={{
                                                                width: "100%",
                                                                background: `${
                                                                  clickedRow?.key ===
                                                                    key &&
                                                                  clickedRow?.index ===
                                                                    index
                                                                    ? "yellow"
                                                                    : userType !==
                                                                        "Employee" &&
                                                                      userType !==
                                                                        "Manager" &&
                                                                      event?.call_campaign ==
                                                                        "early"
                                                                    ? isDarkMode
                                                                      ? "#327DDA"
                                                                      : "rgb(108 174 255)"
                                                                    : index %
                                                                        2 ===
                                                                      0
                                                                    ? isDarkMode
                                                                      ? "#343A3F"
                                                                      : "#F8F9FA"
                                                                    : isDarkMode
                                                                    ? "#343A3F"
                                                                    : "#E9ECEF"
                                                                }`,

                                                                gap: "10px",
                                                                width: "100%",
                                                                display: "flex",
                                                                margin: "8px ",
                                                              }}
                                                            >
                                                              <button
                                                                type="button"
                                                                className="d-flex btn btn-light align-items-center justify-content-center gap-1 mx-auto"
                                                                style={{
                                                                  width:
                                                                    userType &&
                                                                    internalUsers.includes(
                                                                      userType
                                                                    ) &&
                                                                    userType !==
                                                                      "Animator" &&
                                                                    userType !==
                                                                      "Agent"
                                                                      ? "50%"
                                                                      : "100%",
                                                                  // maxWidth: "150px",
                                                                  whiteSpace:
                                                                    "nowrap",
                                                                  textOverflow:
                                                                    "ellipsis",
                                                                  overflow:
                                                                    "hidden",
                                                                }}
                                                                onClick={() => {
                                                                  setDealershipLabel(
                                                                    event
                                                                      ?.dealership
                                                                      ?.name
                                                                  );
                                                                  setDisplayComponent(
                                                                    "event-view"
                                                                  );
                                                                  setIsLoading(
                                                                    true
                                                                  );

                                                                  window.history.pushState(
                                                                    {
                                                                      id: "gallery",
                                                                      randomData:
                                                                        window.Math.random(),
                                                                    },
                                                                    "title",
                                                                    `/event-portal?page=event-view&event_id=${event.id}`
                                                                  );
                                                                }}
                                                              >
                                                                <i
                                                                  className={
                                                                    "bi bi-calendar2-event"
                                                                  }
                                                                ></i>{" "}
                                                                {
                                                                  pageTranslations[
                                                                    "title"
                                                                  ].events[
                                                                    language
                                                                  ]
                                                                }
                                                              </button>
                                                              {userType &&
                                                                internalUsers.includes(
                                                                  userType
                                                                ) &&
                                                                userType !==
                                                                  "Animator" &&
                                                                userType !==
                                                                  "Agent" && (
                                                                  <button
                                                                    style={{
                                                                      width:
                                                                        "50%",
                                                                      justifyContent:
                                                                        "center",
                                                                    }}
                                                                    type="button"
                                                                    className="btn admin-btn btn-primary d-flex align-items-center gap-1"
                                                                    // data-bs-toggle="modal"
                                                                    // data-bs-target="#modalQuickAdd"
                                                                    // fdprocessedid="2rud2c"
                                                                    onClick={(e) => {
                                                                      e.stopPropagation()
                                                                      // setDisplayComponent(
                                                                      //   "eventReport"
                                                                      // );

                                                                      // window.history.pushState(
                                                                      //   {
                                                                      //     id: "gallery",
                                                                      //     randomData:
                                                                      //       window.Math.random(),
                                                                      //   },
                                                                      //   "title",
                                                                      //   "/event-portal?page=eventReport&event_id=" +
                                                                      //     event.id
                                                                      // );
                                                                       downloadReport(event.id,event.nom_vp)
                                                                    }}
                                                                     disabled={isLoading}
                                                                  >
                                                                    <i className="bi bi-file-earmark-bar-graph"></i>{" "}
                                                                    {
                                                                      translations
                                                                        .viewEventReport
                                                                        .report_title[
                                                                        language
                                                                      ]
                                                                    }
                                                                  </button>
                                                                )}
                                                            </div>
                                                          )}

                                                        {userType &&
                                                          internalUsers.includes(
                                                            userType
                                                          ) &&
                                                          userType !==
                                                            "Animator" &&
                                                          userType !==
                                                            "Agent" && (
                                                            <div
                                                              style={{
                                                                width: "100%",
                                                                background: `${
                                                                  clickedRow?.key ===
                                                                    key &&
                                                                  clickedRow?.index ===
                                                                    index
                                                                    ? "yellow"
                                                                    : userType !==
                                                                        "Employee" &&
                                                                      userType !==
                                                                        "Manager" &&
                                                                      event?.call_campaign ==
                                                                        "early"
                                                                    ? isDarkMode
                                                                      ? "#327DDA"
                                                                      : "rgb(108 174 255)"
                                                                    : index %
                                                                        2 ===
                                                                      0
                                                                    ? isDarkMode
                                                                      ? "#2B3035"
                                                                      : "#F8F9FA"
                                                                    : isDarkMode
                                                                    ? "#343A3F"
                                                                    : "#E9ECEF"
                                                                }`,

                                                                paddingInline:
                                                                  "1px",
                                                              }}
                                                            >
                                                              <div
                                                                className="btn-group"
                                                                role="group"
                                                                style={{
                                                                  width: "100%",
                                                                }}
                                                              >
                                                                {}

                                                                {hasPrivateEventDestroy && (
                                                                  <>
                                                                    {deleteStates &&
                                                                    deleteStates[
                                                                      accordionIndex
                                                                    ][index][
                                                                      event.id
                                                                    ] ? (
                                                                      <div
                                                                        className="btn-group"
                                                                        role="group"
                                                                        style={{
                                                                          width:
                                                                            "100%",
                                                                          gap: "10px",
                                                                        }}
                                                                      >
                                                                        <button
                                                                          style={{
                                                                            borderRadius:
                                                                              "6px",
                                                                            width:
                                                                              "50%",
                                                                          }}
                                                                          type="button"
                                                                          className="btn btn-success delete-button"
                                                                          onClick={() =>
                                                                            handleDelete(
                                                                              event.id,
                                                                              index,
                                                                              accordionIndex
                                                                            )
                                                                          }
                                                                        >
                                                                          {
                                                                            pageTranslations[
                                                                              "eventsTableButtons"
                                                                            ]
                                                                              .confirm[
                                                                              language
                                                                            ]
                                                                          }
                                                                        </button>
                                                                        <button
                                                                          style={{
                                                                            borderRadius:
                                                                              "6px",
                                                                            width:
                                                                              "50%",
                                                                          }}
                                                                          type="button"
                                                                          className="btn btn-secondary cancel-button"
                                                                          onClick={(
                                                                            e
                                                                          ) => {
                                                                            e.stopPropagation();
                                                                            setDeleteStates(
                                                                              (
                                                                                prevStates
                                                                              ) => {
                                                                                const newStates =
                                                                                  [
                                                                                    ...prevStates,
                                                                                  ];
                                                                                newStates[
                                                                                  accordionIndex
                                                                                ][
                                                                                  index
                                                                                ][
                                                                                  event.id
                                                                                ] = false;
                                                                                return newStates;
                                                                              }
                                                                            );
                                                                          }}
                                                                        >
                                                                          {
                                                                            pageTranslations[
                                                                              "eventsTableButtons"
                                                                            ]
                                                                              .cancel[
                                                                              language
                                                                            ]
                                                                          }
                                                                        </button>
                                                                      </div>
                                                                    ) : (
                                                                      <button
                                                                        type="button"
                                                                        className="d-flex btn btn-danger align-items-center justify-content-center before-delete-button gap-1 mx-auto"
                                                                        style={{
                                                                          width:
                                                                            "100%",
                                                                          // maxWidth:
                                                                          //   "150px",
                                                                          whiteSpace:
                                                                            "nowrap",
                                                                          textOverflow:
                                                                            "ellipsis",
                                                                          overflow:
                                                                            "hidden",
                                                                        }}
                                                                        onClick={(
                                                                          e
                                                                        ) => {
                                                                          e.stopPropagation();
                                                                          setDeleteStates(
                                                                            (
                                                                              prevStates
                                                                            ) => {
                                                                              const newStates =
                                                                                [
                                                                                  ...prevStates,
                                                                                ];
                                                                              newStates[
                                                                                accordionIndex
                                                                              ][
                                                                                index
                                                                              ][
                                                                                event.id
                                                                              ] = true;
                                                                              return newStates;
                                                                            }
                                                                          );
                                                                        }}
                                                                      >
                                                                        <i className="bi bi-trash"></i>{" "}
                                                                        {}
                                                                      </button>
                                                                    )}
                                                                  </>
                                                                )}
                                                              </div>
                                                            </div>
                                                          )}
                                                      </div>
                                                    </div>
                                                  )}
                                                </div>
                                              </div>
                                            </td>
                                          </>
                                        ) : (
                                          <>
                                            <td
                                              style={{
                                                background: `${
                                                  clickedRow?.key === key &&
                                                  clickedRow?.index === index
                                                    ? "yellow"
                                                    : userType !== "Employee" &&
                                                      userType !== "Manager" &&
                                                      event?.call_campaign ==
                                                        "early"
                                                    ? isDarkMode
                                                      ? "#327DDA"
                                                      : "rgb(108 174 255)"
                                                    : index % 2 === 0
                                                    ? isDarkMode
                                                      ? "#343A3F"
                                                      : "#F8F9FA"
                                                    : isDarkMode
                                                    ? "#343A3F"
                                                    : "#E9ECEF"
                                                }`,
                                                borderBottom: isLastElement
                                                  ? "1px solid #dee2e6"
                                                  : "0px solid",
                                                position: "-webkit-sticky",
                                                position: "sticky",
                                                right: "0px",
                                                width:
                                                  userType === "Animator" ||
                                                  (userType &&
                                                    externalUsers.includes(
                                                      userType
                                                    ))
                                                    ? "100%"
                                                    : "95%",
                                              }}
                                              colSpan={
                                                currentView?.columns[
                                                  currentView?.columns.length -
                                                    1
                                                ]?.colSpan
                                              }
                                            >
                                              <div className="d-flex justify-content-end align-items-center">
                                                {userType !== "Employee" &&
                                                  userType !== "Manager" && (
                                                    <div
                                                      style={{
                                                        background: `${
                                                          clickedRow?.key ===
                                                            key &&
                                                          clickedRow?.index ===
                                                            index
                                                            ? "yellow"
                                                            : event?.call_campaign ==
                                                              "early"
                                                            ? isDarkMode
                                                              ? "#327DDA"
                                                              : "rgb(108 174 255)"
                                                            : index % 2 === 0
                                                            ? isDarkMode
                                                              ? "#343A3F"
                                                              : "#F8F9FA"
                                                            : isDarkMode
                                                            ? "#343A3F"
                                                            : "#E9ECEF"
                                                        }`,

                                                        minWidth: "202px",
                                                        width: "100%",
                                                        paddingInline: "8px",
                                                      }}
                                                    >
                                                      <div
                                                        className="d-flex align-items-center"
                                                        style={{
                                                          // width: "186px",
                                                          width: "100%",
                                                        }}
                                                      >
                                                        <div
                                                          style={{
                                                            width: "10px",
                                                            height: "10px",
                                                            backgroundColor:
                                                              event?.status ===
                                                                "Active" ||
                                                              event?.status ===
                                                                "Completed"
                                                                ? "#34DBB4"
                                                                : event?.status ===
                                                                  "Waiting"
                                                                ? "orange"
                                                                : "red",
                                                            borderRadius: "50%",
                                                            marginRight: "8px",
                                                          }}
                                                        ></div>
                                                        <Select
                                                          className="w-100 selectpicker"
                                                          aria-labelledby="dealership-name-quick"
                                                          // options={
                                                          //   statusOptions
                                                          // }
                                                           options={statusOptions.map((opt) => ({
                                                              ...opt,
                                                              isDisabled: opt.value.toLocaleLowerCase() === "pending" && filterOption.toLocaleLowerCase() === "pending" && !isAdminUser
                                                            }))}
                                                          placeholder={
                                                            translations[
                                                              "dropdown"
                                                            ].select[language]
                                                          }
                                                          isDisabled={
                                                            userData &&
                                                            !userData.roles[0].permissions.some(
                                                              (item) =>
                                                                item.name ===
                                                                "Change Event Status"
                                                            )
                                                          }
                                                          isSearchable={false}
                                                          value={
                                                            (statusOptions &&
                                                              statusOptions.length >
                                                                0 &&
                                                              statusOptions.find(
                                                                (option) =>
                                                                  option.value ===
                                                                  event?.status
                                                              )) || {
                                                              value: "",
                                                              label:
                                                                translations[
                                                                  "dropdown"
                                                                ].select[
                                                                  language
                                                                ],
                                                            }
                                                          }
                                                          onChange={(
                                                            selectedOption
                                                          ) => {
                                                            changeDropdowns({
                                                              id: event.id,
                                                              status:
                                                                selectedOption.value,
                                                            });
                                                          }}
                                                          menuPortalTarget={
                                                            document.body
                                                          }
                                                          maxMenuHeight={
                                                            "100px"
                                                          }
                                                          styles={{
                                                            menuPortal: (
                                                              base
                                                            ) => ({
                                                              ...base,
                                                              zIndex: 9999,
                                                            }),
                                                            input: (
                                                              provided
                                                            ) => ({
                                                              ...provided,
                                                              color: isDarkMode
                                                                ? "#ffffff"
                                                                : "black",
                                                            }),
                                                            control: (
                                                              provided,
                                                              state
                                                            ) => ({
                                                              ...provided,
                                                              width: "100%",
                                                              backgroundColor:
                                                                isDarkMode
                                                                  ? userData &&
                                                                    userData.roles[0].permissions.some(
                                                                      (item) =>
                                                                        item.name ===
                                                                        "Change Event Status"
                                                                    )
                                                                    ? "transparent"
                                                                    : "#ced4da66"
                                                                  : userData &&
                                                                    userData.roles[0].permissions.some(
                                                                      (item) =>
                                                                        item.name ===
                                                                        "Change Event Status"
                                                                    )
                                                                  ? "white"
                                                                  : "#ced4da66",
                                                              border:
                                                                state.isFocused
                                                                  ? "1px solid #80bdff"
                                                                  : isDarkMode
                                                                  ? "1px solid #495057"
                                                                  : "1px solid #dee2e6",
                                                              boxShadow:
                                                                state.isFocused
                                                                  ? "0 0 0 0.2rem rgba(0, 123, 255, 0.25)"
                                                                  : "none",
                                                              borderRadius:
                                                                ".45rem",
                                                            }),
                                                            valueContainer: (
                                                              provided
                                                            ) => ({
                                                              ...provided,
                                                              padding:
                                                                "0.18rem 0.55rem",
                                                              width: "100%",
                                                            }),
                                                            indicatorSeparator:
                                                              (provided) => ({
                                                                ...provided,
                                                                display: "none",
                                                              }),
                                                            dropdownIndicator: (
                                                              provided
                                                            ) => ({
                                                              ...provided,
                                                              padding:
                                                                "0.375rem 0.75rem",
                                                              color:
                                                                clickedRow?.key ===
                                                                  key &&
                                                                clickedRow?.index ===
                                                                  index
                                                                  ? "black"
                                                                  : isDarkMode
                                                                  ? "#ffffff"
                                                                  : "#868686",
                                                              display:
                                                                userData &&
                                                                userData.roles[0].permissions.some(
                                                                  (item) =>
                                                                    item.name ===
                                                                    "Change Event Status"
                                                                )
                                                                  ? "block"
                                                                  : "none",
                                                            }),
                                                            menu: (
                                                              provided
                                                            ) => ({
                                                              ...provided,
                                                              color: isDarkMode
                                                                ? "#ffffff"
                                                                : "black",
                                                              backgroundColor:
                                                                isDarkMode
                                                                  ? "#1f2023"
                                                                  : "white",
                                                              margin: "0",
                                                              width: "100%",
                                                            }),
                                                            placeholder: (
                                                              provided
                                                            ) => ({
                                                              ...provided,
                                                              color: isDarkMode
                                                                ? "#ffffff"
                                                                : "#333333",
                                                            }),
                                                            singleValue: (
                                                              provided
                                                            ) => ({
                                                              ...provided,
                                                              color:
                                                                clickedRow?.key ===
                                                                  key &&
                                                                clickedRow?.index ===
                                                                  index
                                                                  ? "black"
                                                                  : isDarkMode
                                                                  ? "#ffffff"
                                                                  : "black",
                                                            }),
                                                            option: (
                                                              provided,
                                                              state
                                                            ) => ({
                                                              ...provided,
                                                              //  color: state.isDisabled ? "#B0B0B0" : isDarkMode ? "#ffffff" : "black",
                                                             color:  state.isDisabled
                                                                  ? "#B0B0B0" // gray text for disabled
                                                                  : isDarkMode
                                                                  ? "#ffffff"
                                                                  : "black",
                                                              backgroundColor:
                                                              state.isDisabled
                                                                ? isDarkMode
                                                                  ? "#333333"
                                                                  : "#f0f0f0" :
                                                                state.isHovered
                                                                  ? "#80bdff"
                                                                  : isDarkMode
                                                                  ? "#1f2023"
                                                                  : "white",
                                                              ":hover": {
                                                                backgroundColor:
                                                                state.isDisabled
                                                                  ? isDarkMode
                                                                    ? "#333333" // dark gray background for disabled
                                                                    : "#f0f0f0"
                                                                  :
                                                                  isDarkMode
                                                                    ? "#34DBB4"
                                                                    : "#34DBB4",
                                                              },
                                                               cursor: state.isDisabled ? "not-allowed" : "pointer",
                                                            }),
                                                          }}
                                                        />
                                                      </div>
                                                    </div>
                                                  )}
                                                {userType &&
                                                  internalUsers.includes(
                                                    userType
                                                  ) &&
                                                  userType !== "Animator" &&
                                                  userType !== "Agent" &&
                                                  userType !== "Accountant" &&
                                                  currentView?.name !==
                                                    "Contract and Billing" && (
                                                    <div
                                                      style={{
                                                        background: `${
                                                          clickedRow?.key ===
                                                            key &&
                                                          clickedRow?.index ===
                                                            index
                                                            ? "yellow"
                                                            : userType !==
                                                                "Employee" &&
                                                              userType !==
                                                                "Manager" &&
                                                              event?.call_campaign ==
                                                                "early"
                                                            ? isDarkMode
                                                              ? "#327DDA"
                                                              : "rgb(108 174 255)"
                                                            : index % 2 === 0
                                                            ? isDarkMode
                                                              ? "#343A3F"
                                                              : "#F8F9FA"
                                                            : isDarkMode
                                                            ? "#343A3F"
                                                            : "#E9ECEF"
                                                        }`,

                                                        paddingRight: "8px",
                                                      }}
                                                      className="my-2"
                                                    >
                                                      <div
                                                        className="btn-group"
                                                        role="group"
                                                        aria-label="Basic example"
                                                      >
                                                        {}
                                                        {userType &&
                                                          internalUsers.includes(
                                                            userType
                                                          ) &&
                                                          userType !==
                                                            "Animator" &&
                                                          userType !==
                                                            "Agent" &&
                                                          userType !==
                                                            "Accountant" && (
                                                            <div
                                                              className="btn-group"
                                                              role="group"
                                                            >
                                                              <button
                                                                type="button"
                                                                className="d-flex btn btn-light align-items-center justify-content-center edit-button gap-1 mx-auto"
                                                                style={{
                                                                  width: "100%",
                                                                  maxWidth:
                                                                    "150px",
                                                                  whiteSpace:
                                                                    "nowrap",
                                                                  textOverflow:
                                                                    "ellipsis",
                                                                  overflow:
                                                                    "hidden",
                                                                  minWidth:
                                                                    "130px",
                                                                  background:
                                                                    "transparent",
                                                                  color:
                                                                    clickedRow?.key ===
                                                                      key &&
                                                                    clickedRow?.index ===
                                                                      index
                                                                      ? "black"
                                                                      : isDarkMode
                                                                      ? "#ffffff"
                                                                      : "black",
                                                                }}
                                                                onClick={() => {
                                                                  if (
                                                                    event.copy ===
                                                                    "0"
                                                                  ) {
                                                                    checkParent(
                                                                      event.id
                                                                    );
                                                                    setformDealerID(
                                                                      event
                                                                        ?.dealership
                                                                        ?.id
                                                                    );
                                                                  } else {
                                                                    setDisplayComponent(
                                                                      "create-event"
                                                                    );

                                                                    window.history.pushState(
                                                                      {
                                                                        id: "gallery",
                                                                        randomData:
                                                                          window.Math.random(),
                                                                      },
                                                                      "title",
                                                                      "/event-portal?page=create-event&parent_id=" +
                                                                        event.id +
                                                                        "&event-navigate=true&getFormData=false"
                                                                    );
                                                                  }
                                                                }}
                                                              >
                                                                {
                                                                  translations
                                                                    .commonWords
                                                                    .form[
                                                                    language
                                                                  ]
                                                                }
                                                              </button>
                                                              {userType !==
                                                                "Representative" && (
                                                                <button
                                                                  type="button"
                                                                  className="d-flex btn btn-light align-items-center justify-content-center edit-button gap-1 mx-auto"
                                                                  style={{
                                                                    width:
                                                                      "100%",
                                                                    maxWidth:
                                                                      "150px",
                                                                    whiteSpace:
                                                                      "nowrap",
                                                                    textOverflow:
                                                                      "ellipsis",
                                                                    overflow:
                                                                      "hidden",
                                                                  }}
                                                                  onClick={() => {
                                                                    if (
                                                                      event.copy ===
                                                                      "0"
                                                                    ) {
                                                                      checkParent(
                                                                        event.id
                                                                      );
                                                                      setformDealerID(
                                                                        event
                                                                          ?.dealership
                                                                          ?.id
                                                                      );
                                                                    } else {
                                                                      setDisplayComponent(
                                                                        "create-event"
                                                                      );

                                                                      window.history.pushState(
                                                                        {
                                                                          id: "gallery",
                                                                          randomData:
                                                                            window.Math.random(),
                                                                        },
                                                                        "title",
                                                                        "/event-portal?page=create-event&parent_id=" +
                                                                          event.id +
                                                                          "&event-navigate=true&getFormData=false"
                                                                      );
                                                                    }
                                                                  }}
                                                                >
                                                                  <i
                                                                    className={
                                                                      "bi bi-plus-circle"
                                                                    }
                                                                  ></i>{" "}
                                                                </button>
                                                              )}
                                                            </div>
                                                          )}
                                                        {(hasCreateParentForm ||
                                                          userType ===
                                                            "Representative") && (
                                                          <button
                                                            type="button"
                                                            className="d-flex btn align-items-center justify-content-center admin-btn edit-button gap-1 mx-auto"
                                                            style={{
                                                              width: "100%",
                                                              maxWidth: "150px",
                                                              whiteSpace:
                                                                "nowrap",
                                                              textOverflow:
                                                                "ellipsis",
                                                              overflow:
                                                                "hidden",

                                                              color: "#ffffff",
                                                            }}
                                                            disabled={
                                                              event &&
                                                              (userType &&
                                                              internalUsers.includes(
                                                                userType
                                                              )
                                                                ? event?.parents_form ===
                                                                  null
                                                                : event
                                                                    ?.parents_form
                                                                    ?.clients_form ===
                                                                  null)
                                                            }
                                                            onClick={() => {
                                                              if (
                                                                userType &&
                                                                internalUsers.includes(
                                                                  userType
                                                                )
                                                              ) {
                                                                setDisplayComponent(
                                                                  "edit-form"
                                                                );
                                                                window.history.pushState(
                                                                  {
                                                                    id: "gallery",
                                                                    randomData:
                                                                      window.Math.random(),
                                                                  },
                                                                  "title",
                                                                  "/event-portal?page=edit-form&event_id=" +
                                                                    event.id +
                                                                    "&form_id=" +
                                                                    event
                                                                      ?.parents_form
                                                                      ?.id
                                                                );
                                                              } else {
                                                                navigate(
                                                                  "/client-submission?id=" +
                                                                    event
                                                                      ?.parents_form
                                                                      ?.clients_form
                                                                      ?.id
                                                                );
                                                              }
                                                            }}
                                                          >
                                                            <i
                                                              className={`bi bi-file-earmark-text`}
                                                            ></i>{" "}
                                                            {}
                                                          </button>
                                                        )}
                                                        {}
                                                      </div>
                                                    </div>
                                                  )}

                                                {userType &&
                                                  externalUsers.includes(
                                                    userType
                                                  ) && (
                                                    <div
                                                      style={{
                                                        background: `${
                                                          clickedRow?.key ===
                                                            key &&
                                                          clickedRow?.index ===
                                                            index
                                                            ? "yellow"
                                                            : userType !==
                                                                "Employee" &&
                                                              userType !==
                                                                "Manager" &&
                                                              event?.call_campaign ==
                                                                "early"
                                                            ? isDarkMode
                                                              ? "#327DDA"
                                                              : "rgb(108 174 255)"
                                                            : index % 2 === 0
                                                            ? isDarkMode
                                                              ? "#343A3F"
                                                              : "#F8F9FA"
                                                            : isDarkMode
                                                            ? "#343A3F"
                                                            : "#E9ECEF"
                                                        }`,

                                                        paddingInline: "1px",
                                                        width: "100%",
                                                      }}
                                                    >
                                                      <button
                                                        type="button"
                                                        className="d-flex btn btn-light align-items-center justify-content-center gap-1 mx-auto"
                                                        style={{
                                                          width: "100%",
                                                          // maxWidth: "150px",
                                                          whiteSpace: "nowrap",
                                                          textOverflow:
                                                            "ellipsis",
                                                          overflow: "hidden",
                                                          background: isDarkMode
                                                            ? ""
                                                            : !stats?.latest_submission.some(
                                                                (item) =>
                                                                  item.Event_ID?.toString() ===
                                                                  event.id?.toString()
                                                              )
                                                            ? "#ced4da66"
                                                            : "",
                                                        }}
                                                        disabled={
                                                          !stats?.latest_submission.some(
                                                            (item) =>
                                                              item.Event_ID?.toString() ===
                                                              event.id?.toString()
                                                          )
                                                        }
                                                        onClick={() => {
                                                          const submission =
                                                            stats?.latest_submission.find(
                                                              (item) =>
                                                                item.Event_ID?.toString() ===
                                                                event.id?.toString()
                                                            );

                                                          const clientID =
                                                            submission?.Client_ID;

                                                          setDisplayComponent(
                                                            "animator"
                                                          );

                                                          window.history.pushState(
                                                            {
                                                              id: "gallery",
                                                              randomData:
                                                                window.Math.random(),
                                                            },

                                                            "title",
                                                            "/event-portal?page=client-submission&id=" +
                                                              clientID
                                                          );
                                                        }}
                                                      >
                                                        <i
                                                          className={
                                                            "bi bi-file-earmark-text"
                                                          }
                                                        ></i>{" "}
                                                        {
                                                          translations
                                                            .commonWords.form[
                                                            language
                                                          ]
                                                        }
                                                      </button>
                                                    </div>
                                                  )}
                                                {userType &&
                                                  userType !== "Agent" &&
                                                  currentView?.name !==
                                                    "Contract and Billing" && (
                                                    <div
                                                      style={{
                                                        background: `${
                                                          clickedRow?.key ===
                                                            key &&
                                                          clickedRow?.index ===
                                                            index
                                                            ? "yellow"
                                                            : userType !==
                                                                "Employee" &&
                                                              userType !==
                                                                "Manager" &&
                                                              event?.call_campaign ==
                                                                "early"
                                                            ? isDarkMode
                                                              ? "#327DDA"
                                                              : "rgb(108 174 255)"
                                                            : index % 2 === 0
                                                            ? isDarkMode
                                                              ? "#343A3F"
                                                              : "#F8F9FA"
                                                            : isDarkMode
                                                            ? "#343A3F"
                                                            : "#E9ECEF"
                                                        }`,

                                                        paddingRight: "8px",
                                                        width: "100%",
                                                        display:'flex',
                                                        gap:'8px',

                                                      }}
                                                    >
                                                      <button
                                                        type="button"
                                                        className="d-flex btn btn-light align-items-center justify-content-center gap-1 mx-auto"
                                                        style={{
                                                          width: "70%",
                                                          // maxWidth: "150px",
                                                          whiteSpace: "nowrap",
                                                          textOverflow:
                                                            "ellipsis",
                                                          overflow: "hidden",
                                                        }}
                                                        onClick={() => {
                                                          setDealershipLabel(
                                                            event?.dealership
                                                              ?.name
                                                          );
                                                          setDisplayComponent(
                                                            "event-view"
                                                          );
                                                          setIsLoading(true);

                                                          window.history.pushState(
                                                            {
                                                              id: "gallery",
                                                              randomData:
                                                                window.Math.random(),
                                                            },
                                                            "title",
                                                            `/event-portal?page=event-view&event_id=${event.id}`
                                                          );
                                                        }}
                                                      >
                                                        <i
                                                          className={
                                                            "bi bi-calendar2-event"
                                                          }
                                                        ></i>{" "}
                                                        {
                                                          pageTranslations[
                                                            "title"
                                                          ].events[language]
                                                        }
                                                      </button>
                                                      {userType &&
                                                        internalUsers.includes(
                                                          userType
                                                        ) &&
                                                        userType !==
                                                          "Animator" &&
                                                        userType !==
                                                          "Agent" && (
                                                          <button
                                                            style={{
                                                              width: "30%",
                                                              justifyContent:
                                                                "center",
                                                            }}
                                                            type="button"
                                                            className="btn admin-btn btn-primary d-flex align-items-center gap-1"
                                                            // data-bs-toggle="modal"
                                                            // data-bs-target="#modalQuickAdd"
                                                            // fdprocessedid="2rud2c"
                                                            onClick={(e) => {
                                                              e.stopPropagation()
                                                              // setDisplayComponent(
                                                              //   "eventReport"
                                                              // );

                                                              // window.history.pushState(
                                                              //   {
                                                              //     id: "gallery",
                                                              //     randomData:
                                                              //       window.Math.random(),
                                                              //   },
                                                              //   "title",
                                                              //   "/event-portal?page=eventReport&event_id=" +
                                                              //     event.id
                                                              // );
                                                              downloadReport(event.id,event.nom_vp)
                                                            }}
                                                             disabled={isLoading}
                                                          >
                                                            <i className="bi bi-file-earmark-bar-graph"></i>{" "}
                                                            {/* {
                                                              translations
                                                                .viewEventReport
                                                                .report_title[
                                                                language
                                                              ]
                                                            } */}
                                                          </button>
                                                        )}
                                                    </div>
                                                  )}
                                                {userType &&
                                                  internalUsers.includes(
                                                    userType
                                                  ) &&
                                                  userType !== "Animator" &&
                                                  userType !== "Agent" && (
                                                    <div
                                                      style={{
                                                        background: `${
                                                          clickedRow?.key ===
                                                            key &&
                                                          clickedRow?.index ===
                                                            index
                                                            ? "yellow"
                                                            : userType !==
                                                                "Employee" &&
                                                              userType !==
                                                                "Manager" &&
                                                              event?.call_campaign ==
                                                                "early"
                                                            ? isDarkMode
                                                              ? "#327DDA"
                                                              : "rgb(108 174 255)"
                                                            : index % 2 === 0
                                                            ? isDarkMode
                                                              ? "#2B3035"
                                                              : "#F8F9FA"
                                                            : isDarkMode
                                                            ? "#343A3F"
                                                            : "#E9ECEF"
                                                        }`,

                                                        paddingInline: "1px",
                                                      }}
                                                    >
                                                      <div
                                                        className="btn-group"
                                                        role="group"
                                                      >
                                                        {}
                                                        {userType &&
                                                          internalUsers.includes(
                                                            userType
                                                          ) &&
                                                          userType !==
                                                            "Animator" &&
                                                          userType !==
                                                            "Agent" && (
                                                            <button
                                                              type="button"
                                                              className="d-flex btn btn-light align-items-center justify-content-center edit-button gap-1 mx-auto"
                                                              style={{
                                                                width: "100%",
                                                                maxWidth:
                                                                  "150px",
                                                                whiteSpace:
                                                                  "nowrap",
                                                                textOverflow:
                                                                  "ellipsis",
                                                                overflow:
                                                                  "hidden",
                                                              }}
                                                              onClick={() => {
                                                                setDisplayComponent(
                                                                  "edit-event"
                                                                );
                                                                setEditEventID(
                                                                  event.id
                                                                );
                                                                window.history.pushState(
                                                                  {
                                                                    id: "gallery",
                                                                    randomData:
                                                                      window.Math.random(),
                                                                  },
                                                                  "title",
                                                                  "/event-portal?page=edit-event&parent_id=" +
                                                                    event.id
                                                                );
                                                              }}
                                                            >
                                                              <i
                                                                className={
                                                                userData && userData.roles[0].name === "Representative"
                                                                  ? "bi bi-eye" :
                                                                  userData &&
                                                                  userData.roles[0].permissions.some(
                                                                    (item) =>
                                                                      item.name ===
                                                                      "Private Event Show"
                                                                  )
                                                                    ? "bi bi-pencil"
                                                                    : "bi bi-eye"
                                                                }
                                                              ></i>{" "}
                                                              {}
                                                            </button>
                                                          )}
                                                        {hasPrivateEventDestroy && (
                                                          <>
                                                            {deleteStates &&
                                                            deleteStates[
                                                              accordionIndex
                                                            ][index][
                                                              event.id
                                                            ] ? (
                                                              <div
                                                                className="btn-group"
                                                                role="group"
                                                                style={{
                                                                  width:
                                                                    "180px",
                                                                }}
                                                              >
                                                                <button
                                                                  type="button"
                                                                  className="btn btn-success delete-button"
                                                                  onClick={() =>
                                                                    handleDelete(
                                                                      event.id,
                                                                      index,
                                                                      accordionIndex
                                                                    )
                                                                  }
                                                                >
                                                                  {
                                                                    pageTranslations[
                                                                      "eventsTableButtons"
                                                                    ].confirm[
                                                                      language
                                                                    ]
                                                                  }
                                                                </button>
                                                                <button
                                                                  type="button"
                                                                  className="btn btn-secondary cancel-button"
                                                                  onClick={() =>
                                                                    setDeleteStates(
                                                                      (
                                                                        prevStates
                                                                      ) => {
                                                                        const newStates =
                                                                          [
                                                                            ...prevStates,
                                                                          ];
                                                                        newStates[
                                                                          accordionIndex
                                                                        ][
                                                                          index
                                                                        ][
                                                                          event.id
                                                                        ] = false;
                                                                        return newStates;
                                                                      }
                                                                    )
                                                                  }
                                                                >
                                                                  {
                                                                    pageTranslations[
                                                                      "eventsTableButtons"
                                                                    ].cancel[
                                                                      language
                                                                    ]
                                                                  }
                                                                </button>
                                                              </div>
                                                            ) : (
                                                              <button
                                                                type="button"
                                                                className="d-flex btn btn-danger align-items-center justify-content-center before-delete-button gap-1 mx-auto"
                                                                style={{
                                                                  width: "100%",
                                                                  maxWidth:
                                                                    "150px",
                                                                  whiteSpace:
                                                                    "nowrap",
                                                                  textOverflow:
                                                                    "ellipsis",
                                                                  overflow:
                                                                    "hidden",
                                                                }}
                                                                onClick={() => {
                                                                  setDeleteStates(
                                                                    (
                                                                      prevStates
                                                                    ) => {
                                                                      const newStates =
                                                                        [
                                                                          ...prevStates,
                                                                        ];
                                                                      newStates[
                                                                        accordionIndex
                                                                      ][index][
                                                                        event.id
                                                                      ] = true;
                                                                      return newStates;
                                                                    }
                                                                  );
                                                                }}
                                                              >
                                                                <i className="bi bi-trash"></i>{" "}
                                                                {}
                                                              </button>
                                                            )}
                                                          </>
                                                        )}
                                                      </div>
                                                    </div>
                                                  )}
                                              </div>
                                            </td>
                                          </>
                                        ): null}
                                      </tr>

                                      {isMobile
                                        ? isLastElement && (
                                            <tr
                                              key={index}
                                              className="align-middle"
                                              style={
                                                {
                                                  // position: "relative",
                                                  // height: "30px",
                                                  // zIndex:
                                                  //   10 + eventList.length - index,
                                                }
                                              }
                                            >
                                              {/* {(currentView?.csv == "1" ||
                                            currentView?.xlsx == "1") &&
                                            userData.roles[0].permissions.some(
                                              (item) =>
                                                item.name ===
                                                "Event Data Export"
                                            ) && (
                                              <td
                                                style={{
                                                  background: "#435574",
                                                  borderBottom:
                                                    "1px solid #dee2e6",
                                                  fontWeight: "700",
                                                  // Apply column-specific styles
                                                }}
                                                id="totalRow"
                                                className="text-center"
                                                // className={col.className || ""}
                                              >
                                                {"-"}
                                              </td>
                                            )} */}

                                              <td
                                                id="totalRow"
                                                style={{
                                                  borderBottom:
                                                    "1px solid #dee2e6",
                                                  background: `${
                                                    isDarkMode
                                                      ? "#435574"
                                                      : "#435574"
                                                  }`,
                                                  // position: "-webkit-sticky",
                                                  // position: "sticky",
                                                  // left: "0px",
                                                  width: "100%",
                                                  textalign: "center",
                                                  // marginBottom: "10px",
                                                }}
                                                className="text-center dlrname fw-bold"
                                              >
                                                Total{" "}
                                                <span>{eventList.length}</span>
                                              </td>
                                              {currentView &&
                                                currentView?.columns
                                                  .slice(1, -1)
                                                  .filter(
                                                    (header) =>
                                                      header.renderInView !==
                                                      false
                                                  )
                                                  .map((col) => {
                                                    let value = null;
                                                    const totalColumns = [
                                                      "clients",
                                                      "inactive",
                                                      "conquest",
                                                      "amount",
                                                    ];
                                                    if (col.showIf === false)
                                                      return null;
                                                    if (
                                                      !totalColumns.includes(
                                                        col.id
                                                      )
                                                    )
                                                      return null;

                                                    // if (col.id === "nom_vp") {
                                                    //   value = eventList.length;
                                                    // } else

                                                    if (col.id === "clients") {
                                                      value = eventList.reduce(
                                                        (sum, e) =>
                                                          sum +
                                                          (Number(e?.clients) ||
                                                            0),
                                                        0
                                                      );
                                                    } else if (
                                                      col.id === "inactive"
                                                    ) {
                                                      value = eventList.reduce(
                                                        (sum, e) =>
                                                          sum +
                                                          (Number(
                                                            e?.inactive
                                                          ) || 0),
                                                        0
                                                      );
                                                    } else if (
                                                      col.id === "conquest"
                                                    ) {
                                                      value = eventList.reduce(
                                                        (sum, e) =>
                                                          sum +
                                                          (Number(
                                                            e?.conquest
                                                          ) || 0),
                                                        0
                                                      );
                                                    } else if (
                                                      col.id === "amount"
                                                    ) {
                                                      value = eventList.reduce(
                                                        (sum, e) =>
                                                          sum +
                                                          (Number(e?.amount) ||
                                                            0),
                                                        0
                                                      );
                                                    }

                                                    return (
                                                      <td
                                                        key={col.id}
                                                        style={{
                                                          //  width: `${col.width}px`,
                                                          //  minWidth: col.width,
                                                          //  maxWidth: `${col.width + 50}px`,
                                                          background: "#435574",
                                                          borderBottom:
                                                            "1px solid #dee2e6",
                                                          fontWeight: "700",
                                                          width: "100%",
                                                        }}
                                                        id="totalRow"
                                                        className="dlrname"
                                                      >
                                                        <div
                                                          style={{
                                                            display: "flex",
                                                            width: "100%",
                                                            justifyContent:
                                                              "space-between",
                                                          }}
                                                        >
                                                          <p
                                                            style={{
                                                              fontWeight: "600",
                                                              color: "white",
                                                              // width: "100%",
                                                            }}
                                                          >
                                                            {/* {col?.content} */}
                                                            {FindPathForMobile(col?.content, language)}
                                                          </p>

                                                          <p
                                                            style={{
                                                              color: "white",
                                                              // width: "100%",
                                                            }}
                                                          >
                                                            {value}
                                                          </p>
                                                        </div>
                                                      </td>
                                                    );
                                                  })}
                                            </tr>
                                          )
                                        : isLastElement && (
                                            <tr
                                              key={index}
                                              className="align-middle"
                                              style={{
                                                position: "relative",
                                                height: "30px",
                                                zIndex:
                                                  10 + eventList.length - index,
                                              }}
                                            >
                                              {(currentView?.csv == "1" ||
                                                currentView?.xlsx == "1") &&
                                                userData.roles[0].permissions.some(
                                                  (item) =>
                                                    item.name ===
                                                    "Event Data Export"
                                                ) && (
                                                  <td
                                                    style={{
                                                      background: "#435574",
                                                      borderBottom:
                                                        "1px solid #dee2e6",
                                                      fontWeight: "700",
                                                      // Apply column-specific styles
                                                    }}
                                                    id="totalRow"
                                                    className="text-center"
                                                    // className={col.className || ""}
                                                  >
                                                    {"-"}
                                                  </td>
                                                )}

                                              <td
                                                id="totalRow"
                                                style={{
                                                  borderBottom:
                                                    "1px solid #dee2e6",
                                                  background: `${
                                                    isDarkMode
                                                      ? "#435574"
                                                      : "#435574"
                                                  }`,
                                                  position: "-webkit-sticky",
                                                  position: "sticky",
                                                  left: "0px",
                                                  width: "57px",
                                                }}
                                                className="text-center dlrname fw-bold"
                                              >
                                                Total
                                              </td>
                                              {currentView &&
                                                currentView?.columns
                                                  .slice(1, -1)
                                                  .filter(
                                                    (header) =>
                                                      header.renderInView !==
                                                      false
                                                  )
                                                  .map((col) => {
                                                    if (col.showIf === false)
                                                      return null; // Skip columns with showIf: false

                                                    return (
                                                      <td
                                                        key={col.id}
                                                        style={{
                                                          width: `${col.width}px`,
                                                          minWidth: col.width,
                                                          maxWidth: `${
                                                            col.width + 50
                                                          }px`,
                                                          background: "#435574",
                                                          borderBottom:
                                                            "1px solid #dee2e6",
                                                          fontWeight: "700",
                                                          // Apply column-specific styles
                                                        }}
                                                        id="totalRow"
                                                        className="dlrname"
                                                        // className={col.className || ""}
                                                      >
                                                        {col.id === "nom_vp"
                                                          ? eventList.length
                                                          : col.id === "clients"
                                                          ? eventList.reduce(
                                                              (sum, event) =>
                                                                sum +
                                                                (Number(
                                                                  event?.clients
                                                                ) || 0),
                                                              0
                                                            )
                                                          : col.id ===
                                                            "inactive"
                                                          ? eventList.reduce(
                                                              (sum, event) =>
                                                                sum +
                                                                (Number(
                                                                  event?.inactive
                                                                ) || 0),
                                                              0
                                                            )
                                                          : col.id ===
                                                            "conquest"
                                                          ? eventList.reduce(
                                                              (sum, event) =>
                                                                sum +
                                                                (Number(
                                                                  event?.conquest
                                                                ) || 0),
                                                              0
                                                            )
                                                          : col.id === "amount"
                                                          ? eventList.reduce(
                                                              (sum, event) =>
                                                                sum +
                                                                (Number(
                                                                  event?.amount
                                                                ) || 0),
                                                              0
                                                            )
                                                          : "-"}
                                                      </td>
                                                    );
                                                  })}
                                              {shouldShowActions && (
                                                <>
                                                  <td
                                                    style={{
                                                      background: `${
                                                        isDarkMode
                                                          ? "#435574"
                                                          : "#435574"
                                                      }`,
                                                      borderBottom:
                                                        isLastElement
                                                          ? "1px solid #dee2e6"
                                                          : "0px solid",
                                                      position:
                                                        "-webkit-sticky",
                                                      position: "sticky",
                                                      right: 0,

                                                      // width: "151px",
                                                    }}
                                                    className="text-center"
                                                    id="totalRow"
                                                  >
                                                    -
                                                  </td>
                                                </>
                                              )}
                                            </tr>
                                          )}
                                    </>
                                  );
                                })}
                              </React.Fragment>
                            );
                          })
                        ) : (
                          <tr
                            className="align-middle"
                            style={{
                              position: "relative",
                            }}
                          >
                            <td
                              style={{
                                background: `${
                                  isDarkMode ? "transparent" : "white"
                                }`,
                                borderStyle: "none",
                              }}
                              colSpan={15}
                              className="text-center py-5"
                            >
                              <h4>
                                {
                                  translations.EventsPortal.noDataMessage[
                                    language
                                  ]
                                }
                              </h4>
                            </td>
                          </tr>
                        )}

                        {/* Loader Row  */}

                        {!isMobile && isFetching && (
                          <tr className="skeleton-loader">
                            <th className="p-2">
                              <div
                                className={
                                  isDarkMode ? "skeleton-dark" : "skeleton"
                                }
                              ></div>
                            </th>
                            {currentView?.columns
                              .slice(1, -1)
                              .filter((header) => header.renderInView !== false)
                              .map((col) => {
                                if (col.showIf === false) return null; // Skip columns with showIf: false

                                return (
                                  <td className="p-2">
                                    <div
                                      className={
                                        isDarkMode
                                          ? "skeleton-dark"
                                          : "skeleton"
                                      }
                                    ></div>
                                  </td>
                                );
                              })}

                            {shouldShowActions && (
                              <>
                                <td className="p-2">
                                  <div
                                    className={
                                      isDarkMode ? "skeleton-dark" : "skeleton"
                                    }
                                  ></div>
                                </td>
                              </>
                            )}
                          </tr>
                        )}

                        {/* Total Row  */}

                        {isMobile
                          ? userType &&
                            internalUsers.includes(userType) &&
                            events &&
                            Object.keys(events).length > 0 && (
                              <tr
                                className="align-middle"
                                style={{
                                  position: "-webkit-sticky",
                                  position: "sticky",
                                  bottom: 0,
                                  zIndex: 999,
                                  backgroundColor: "#435574",
                                  background: "#435574",
                                  // height: "30px",
                                }}
                              >
                                <td
                                  id="totalRow"
                                  style={{
                                    borderBottom: "1px solid #dee2e6",
                                    background: `${
                                      isDarkMode ? "#435574" : "#435574"
                                    }`,

                                    // position: "sticky",
                                    // left: "0px",
                                    // width: "57px",
                                  }}
                                  className="text-center dlrname fw-bold"
                                >
                                  Total{" "}
                                  <span>
                                    {displayedEvents.length}
                                  </span>
                                </td>
                                {[
                                  "clients",
                                  "inactive",
                                  "conquest",
                                  "amount",
                                ].map((key) => {
                                  const total = displayedEvents
                                    .reduce(
                                      (sum, event) =>
                                        sum + Number(event[key] || 0),
                                      0
                                    );

                                  const formatted =
                                    key === "amount"
                                      ? numeral(total).format("0,000.00")
                                      : numeral(total).format("0,000");

                                  return (
                                    <td
                                      key={key}
                                      style={{
                                        width: "100%",
                                        // minWidth: "150px",
                                        background: "#435574",
                                        borderBottom: "1px solid #dee2e6",
                                        fontWeight: "700",
                                        color: "white",
                                      }}
                                      id="totalRow"
                                      className="dlrname"
                                    >
                                      <div
                                        style={{
                                          display: "flex",
                                          justifyContent: "space-between",
                                          width:'100%'
                                        }}
                                      >
                                        <p
                                          style={{
                                            fontWeight: "600",
                                            // width:'50%',
                                            color:'white'
                                          }}
                                        >
                                          {key.charAt(0).toUpperCase() +
                                            key.slice(1)}
                                        </p>
                                        <p style={{  
                                          // width:'50%',
                                            color:'white' }}>{formatted}</p>
                                      </div>
                                    </td>
                                  );
                                })}
                                {shouldShowActions && (
                                  <>
                                    <td
                                      style={{
                                        background: `${
                                          isDarkMode ? "#435574" : "#435574"
                                        }`,
                                        borderBottom: "1px solid #dee2e6",
                                        // width: "151px",

                                        position: "-webkit-sticky",
                                        position: "sticky",
                                        right: 0,
                                      }}
                                      id="totalRow"
                                      className="text-center"
                                    >
                                      -
                                    </td>
                                  </>
                                )}
                              </tr>
                            )
                          : userType &&
                            internalUsers.includes(userType) &&
                            events &&
                            Object.keys(events).length > 0 && (
                              <tr
                                className="align-middle"
                                style={{
                                  position: "-webkit-sticky",
                                  position: "sticky",
                                  bottom: 0,
                                  zIndex: 999,
                                  backgroundColor: "#435574",
                                  background: "#435574",
                                  // height: "30px",
                                }}
                              >
                                <td
                                  id="totalRow"
                                  style={{
                                    borderBottom: "1px solid #dee2e6",
                                    background: `${
                                      isDarkMode ? "#435574" : "#435574"
                                    }`,

                                    position: "sticky",
                                    left: "0px",
                                    width: "57px",
                                  }}
                                  className="text-center dlrname fw-bold"
                                >
                                  Total
                                </td>
                                {currentView?.columns
                                  // .slice(1, -1)
                                  .filter(
                                    (header) =>
                                      header.renderInView !== false &&
                                      header.showIf !== false &&
                                      header.id !== "actions"
                                  )
                                  .map((col) => {
                                    // if (col.showIf === false) return null; // Skip columns with showIf: false

                                    return (
                                      <td
                                        key={col.id}
                                        style={{
                                          width: `${col.width}px`,
                                          minWidth: col.width,
                                          background: "#435574",
                                          borderBottom: "1px solid #dee2e6",
                                          fontWeight: "700",

                                          // Apply column-specific styles
                                        }}
                                        id="totalRow"
                                        className="dlrname"
                                        // className={col.className || ""}
                                      >
                                        {col.id === "week"
                                          ? displayedEvents.length
                                          : col.id === "clients"
                                          ? numeral(
                                              displayedEvents
                                                .reduce(
                                                  (total, event) =>
                                                    total +
                                                    Number(event.clients || 0),
                                                  0
                                                )
                                            ).format("0,000")
                                          : col.id === "inactive"
                                          ? numeral(
                                              displayedEvents
                                                .reduce(
                                                  (total, event) =>
                                                    total +
                                                    Number(event.inactive || 0),
                                                  0
                                                )
                                            ).format("0,000")
                                          : col.id === "conquest"
                                          ? numeral(
                                              displayedEvents
                                                .reduce(
                                                  (total, event) =>
                                                    total +
                                                    Number(event.conquest || 0),
                                                  0
                                                )
                                            ).format("0,0")
                                          : col.id === "amount"
                                          ? numeral(
                                              displayedEvents
                                                .reduce(
                                                  (total, event) =>
                                                    total +
                                                    Number(event.amount || 0),
                                                  0
                                                )
                                            ).format("0,000.00")
                                          : "-"}
              

                                      </td>
                                    );
                                  })}
                                {shouldShowActions && (
                                  <>
                                    <td
                                      style={{
                                        background: `${
                                          isDarkMode ? "#435574" : "#435574"
                                        }`,
                                        borderBottom: "1px solid #dee2e6",
                                        // width: "151px",

                                        position: "-webkit-sticky",
                                        position: "sticky",
                                        right: 0,
                                      }}
                                      id="totalRow"
                                      className="text-center"
                                    >
                                      -
                                    </td>
                                  </>
                                )}
                              </tr>
                            )}
                        {isMobile && isFetching && (
                          <tr className="skeleton-loader">
                            <th className="p-2">
                              <div
                                className={
                                  isDarkMode ? "skeleton-dark" : "skeleton"
                                }
                              ></div>
                            </th>
                            {currentView?.columns
                              .slice(1, -1)
                              .filter((header) => header.renderInView !== false)
                              .map((col) => {
                                if (col.showIf === false) return null; // Skip columns with showIf: false

                                return (
                                  <td className="p-2">
                                    <div
                                      className={
                                        isDarkMode
                                          ? "skeleton-dark"
                                          : "skeleton"
                                      }
                                    ></div>
                                  </td>
                                );
                              })}

                            {shouldShowActions && (
                              <>
                                <td className="p-2">
                                  <div
                                    className={
                                      isDarkMode ? "skeleton-dark" : "skeleton"
                                    }
                                  ></div>
                                </td>
                              </>
                            )}
                          </tr>
                        )}
                      </tbody>
                    </table>
                    <div ref={bottomMarkerRef} style={{ height: "1px" }} />
                  </div>
                </SortableContext>
              </DndContext>
            </div>
          </div>

          <AddWeekModal
            handleCopy={handleCopy}
            eventId={eventId}
            week={week}
            setWeek={setWeek}
            setEventId={setEventId}
          />
        </>
      ) : (
        <Loader />
      )}
    </div>
  );
};

export default EventsNew;
